var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/design-system/common/src/cdn-base-url.ts
import { getGlobalThis } from "@gs-ux-uitoolkit-common/shared";
var cdnBaseUrl = "https://cdn.gs.com";
function getCdnBaseUrl() {
  return getGlobalThis().GS_UITOOLKIT_CDN_BASE_URL || cdnBaseUrl;
}

// components/design-system/common/src/color.ts
var colorNames = [
  "gray",
  "red",
  "orange",
  "yellow",
  "lime",
  "green",
  "teal",
  "turquoise",
  "aqua",
  "blue",
  "ultramarine",
  "purple",
  "pink"
];
var colorSwatches = [
  "010",
  "020",
  "030",
  "040",
  "050",
  "060",
  "070",
  "080",
  "090",
  "100"
];
var colors = {
  gray010: "#f2f5f7",
  gray020: "#dce3e8",
  gray030: "#c1ccd6",
  gray040: "#9fb1bd",
  gray050: "#7a909e",
  gray060: "#5b7282",
  gray070: "#3e5463",
  gray080: "#2a3f4d",
  gray090: "#1c2b36",
  gray100: "#0e171f",
  gray110: "#090f14",
  aqua010: "#ebf3f7",
  aqua020: "#c9e7f5",
  aqua030: "#8bd3f7",
  aqua040: "#48b8f0",
  aqua050: "#1195d6",
  aqua060: "#0073ba",
  aqua070: "#08548a",
  aqua080: "#0e3d66",
  aqua090: "#0c2b45",
  aqua100: "#0b1724",
  blue010: "#f0f4fa",
  blue020: "#d4e4fa",
  blue030: "#adccf7",
  blue040: "#75b1ff",
  blue050: "#3d8df5",
  blue060: "#186ade",
  blue070: "#0d4ea6",
  blue080: "#103a75",
  blue090: "#11294d",
  blue100: "#0d1826",
  green010: "#ebf7ed",
  green020: "#c7ebd1",
  green030: "#88dba8",
  green040: "#43c478",
  green050: "#16a163",
  green060: "#077d55",
  green070: "#075e45",
  green080: "#094536",
  green090: "#092e25",
  green100: "#081a15",
  lime010: "#ebf7da",
  lime020: "#d5f0b1",
  lime030: "#aad971",
  lime040: "#78bf39",
  lime050: "#52a31d",
  lime060: "#3c7d0e",
  lime070: "#2e5c0e",
  lime080: "#254211",
  lime090: "#1c2e10",
  lime100: "#121a0d",
  orange010: "#fcf2eb",
  orange020: "#fcddc7",
  orange030: "#fcbc97",
  orange040: "#fc9162",
  orange050: "#e86427",
  orange060: "#bf4815",
  orange070: "#8f3415",
  orange080: "#632b17",
  orange090: "#402117",
  orange100: "#1f1410",
  pink010: "#fcf0f8",
  pink020: "#f7daed",
  pink030: "#f7b7e2",
  pink040: "#fa87d4",
  pink050: "#ed4cb7",
  pink060: "#cc1d92",
  pink070: "#961574",
  pink080: "#6b155a",
  pink090: "#47153f",
  pink100: "#241020",
  purple010: "#f7f2fc",
  purple020: "#eadcfc",
  purple030: "#dabefa",
  purple040: "#c89afc",
  purple050: "#ac71f0",
  purple060: "#8f49de",
  purple070: "#6b30ab",
  purple080: "#4c277d",
  purple090: "#331f4d",
  purple100: "#1c1229",
  red010: "#fcf0f0",
  red020: "#fadcd9",
  red030: "#fabbb4",
  red040: "#fc9086",
  red050: "#fa5343",
  red060: "#d91f11",
  red070: "#a1160a",
  red080: "#75160c",
  red090: "#4f150f",
  red100: "#24120c",
  teal010: "#ebf5f4",
  teal020: "#beebe7",
  teal030: "#86d9d4",
  teal040: "#4ebfb9",
  teal050: "#279c9c",
  teal060: "#167b7d",
  teal070: "#155c5e",
  teal080: "#124241",
  teal090: "#102e2d",
  teal100: "#0c1a19",
  turquoise010: "#ebf5f4",
  turquoise020: "#c7e8ed",
  turquoise030: "#81d8e6",
  turquoise040: "#45bcd1",
  turquoise050: "#159ab3",
  turquoise060: "#067a91",
  turquoise070: "#09596b",
  turquoise080: "#0c424d",
  turquoise090: "#102d33",
  turquoise100: "#0f181a",
  ultramarine010: "#f2f3fa",
  ultramarine020: "#dee0fa",
  ultramarine030: "#c2c7fc",
  ultramarine040: "#a0a7fa",
  ultramarine050: "#7681fc",
  ultramarine060: "#545fe8",
  ultramarine070: "#3a45b0",
  ultramarine080: "#2f337d",
  ultramarine090: "#23254d",
  ultramarine100: "#141429",
  yellow010: "#faf6cf",
  yellow020: "#f7e379",
  yellow030: "#f5c518",
  yellow040: "#d9a514",
  yellow050: "#b3870e",
  yellow060: "#946613",
  yellow070: "#70491c",
  yellow080: "#54341f",
  yellow090: "#38251b",
  yellow100: "#1c1613",
  black: "#000000",
  white: "#ffffff",
  transparent: "transparent"
};

// components/design-system/common/src/color-variants.ts
import { rgba } from "polished";
import { camelCase } from "gs-uitk-lodash";
var alphaSubtle = 0.3;
var emphasisColorVariants = {
  boldGray: {
    backgroundColor: colors.gray060,
    color: colors.white
  },
  boldRed: {
    backgroundColor: colors.red060,
    color: colors.white
  },
  boldOrange: {
    backgroundColor: colors.orange050,
    color: colors.white
  },
  boldYellow: {
    backgroundColor: colors.yellow030,
    color: colors.gray100
  },
  boldLime: {
    backgroundColor: colors.lime060,
    color: colors.white
  },
  boldGreen: {
    backgroundColor: colors.green060,
    color: colors.white
  },
  boldTeal: {
    backgroundColor: colors.teal060,
    color: colors.white
  },
  boldTurquoise: {
    backgroundColor: colors.turquoise060,
    color: colors.white
  },
  boldAqua: {
    backgroundColor: colors.aqua070,
    color: colors.white
  },
  boldBlue: {
    backgroundColor: colors.blue060,
    color: colors.white
  },
  boldUltramarine: {
    backgroundColor: colors.ultramarine060,
    color: colors.white
  },
  boldPurple: {
    backgroundColor: colors.purple060,
    color: colors.white
  },
  boldPink: {
    backgroundColor: colors.pink060,
    color: colors.white
  },
  subtleGray: {
    backgroundColor: rgba(colors.gray040, alphaSubtle),
    color: colors.gray100
  },
  subtleRed: {
    backgroundColor: rgba(colors.red040, alphaSubtle),
    color: colors.gray100
  },
  subtleOrange: {
    backgroundColor: rgba(colors.orange040, alphaSubtle),
    color: colors.gray100
  },
  subtleYellow: {
    backgroundColor: rgba(colors.yellow020, alphaSubtle),
    color: colors.gray100
  },
  subtleLime: {
    backgroundColor: rgba(colors.lime040, alphaSubtle),
    color: colors.gray100
  },
  subtleGreen: {
    backgroundColor: rgba(colors.green040, alphaSubtle),
    color: colors.gray100
  },
  subtleTeal: {
    backgroundColor: rgba(colors.teal040, alphaSubtle),
    color: colors.gray100
  },
  subtleTurquoise: {
    backgroundColor: rgba(colors.turquoise040, alphaSubtle),
    color: colors.gray100
  },
  subtleAqua: {
    backgroundColor: rgba(colors.aqua040, alphaSubtle),
    color: colors.gray100
  },
  subtleBlue: {
    backgroundColor: rgba(colors.blue040, alphaSubtle),
    color: colors.gray100
  },
  subtleUltramarine: {
    backgroundColor: rgba(colors.ultramarine040, alphaSubtle),
    color: colors.gray100
  },
  subtlePurple: {
    backgroundColor: rgba(colors.purple040, alphaSubtle),
    color: colors.gray100
  },
  subtlePink: {
    backgroundColor: rgba(colors.pink040, alphaSubtle),
    color: colors.gray100
  }
};
var emphasisStatusVariants = {
  boldNone: emphasisColorVariants.boldGray,
  boldInformation: emphasisColorVariants.boldBlue,
  boldSuccess: emphasisColorVariants.boldGreen,
  boldWarning: emphasisColorVariants.boldYellow,
  boldError: emphasisColorVariants.boldRed,
  subtleNone: emphasisColorVariants.subtleGray,
  subtleInformation: emphasisColorVariants.subtleBlue,
  subtleSuccess: emphasisColorVariants.subtleGreen,
  subtleWarning: emphasisColorVariants.subtleYellow,
  subtleError: emphasisColorVariants.subtleRed
};
function getColorVariant(color, emphasis) {
  const emphasisColor = camelCase(`${emphasis} ${color}`);
  return emphasisColorVariants[emphasisColor];
}
function getStatusVariant(status, emphasis) {
  const emphasisStatus = camelCase(`${emphasis} ${status}`);
  return emphasisStatusVariants[emphasisStatus];
}
function getEmphasisStatusClassName(emphasis, status) {
  return `emphasis-status-${emphasis}-${status}`;
}

// components/design-system/common/src/emphasis.ts
var emphases = ["bold", "subtle", "minimal"];

// components/design-system/common/src/inject-legacy-global-design-system-css.ts
import { injectGlobal } from "@gs-ux-uitoolkit-common/style";

// components/design-system/common/src/generated/design-system.scss.ts
var design_system_scss_default = {
  ".gs-uitk-elevation-00": {
    boxShadow: "none !important"
  },
  ".gs-uitk-elevation-01": {
    boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-02": {
    boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-03": {
    boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px -1px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-04": {
    boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px -1px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-05": {
    boxShadow: "0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 5px 5px -3px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-06": {
    boxShadow: "0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12), 0px 7px 8px -4px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-07": {
    boxShadow: "0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12), 0px 8px 10px -5px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-08": {
    boxShadow: "0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 11px 15px -7px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-emphasis-color-bold-gray, .gs-uitk-emphasis-color-bold-default": {
    backgroundColor: "#5b7282",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-red": {
    backgroundColor: "#d91f11",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-orange": {
    backgroundColor: "#e86427",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-yellow": {
    backgroundColor: "#f5c518",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-bold-lime": {
    backgroundColor: "#3c7d0e",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-green": {
    backgroundColor: "#077d55",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-teal": {
    backgroundColor: "#167b7d",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-turquoise": {
    backgroundColor: "#067a91",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-aqua": {
    backgroundColor: "#08548a",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-blue": {
    backgroundColor: "#186ade",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-ultramarine": {
    backgroundColor: "#545fe8",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-purple": {
    backgroundColor: "#8f49de",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-pink": {
    backgroundColor: "#cc1d92",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-subtle-gray, .gs-uitk-emphasis-color-subtle-default": {
    backgroundColor: "rgba(159, 177, 189, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-red": {
    backgroundColor: "rgba(252, 144, 134, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-orange": {
    backgroundColor: "rgba(252, 145, 98, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-yellow": {
    backgroundColor: "rgba(247, 227, 121, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-lime": {
    backgroundColor: "rgba(120, 191, 57, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-green": {
    backgroundColor: "rgba(67, 196, 120, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-teal": {
    backgroundColor: "rgba(78, 191, 185, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-turquoise": {
    backgroundColor: "rgba(69, 188, 209, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-aqua": {
    backgroundColor: "rgba(72, 184, 240, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-blue": {
    backgroundColor: "rgba(117, 177, 255, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-ultramarine": {
    backgroundColor: "rgba(160, 167, 250, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-purple": {
    backgroundColor: "rgba(200, 154, 252, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-pink": {
    backgroundColor: "rgba(250, 135, 212, 0.3)",
    color: "#0e171f"
  },
  "@font-face": {
    fontFamily: '"Sabon"',
    src: 'url("https://cdn.gs.com/fonts/sabon/v1/sabon.woff2") format("woff2"), url("https://cdn.gs.com/fonts/sabon/v1/sabon.woff") format("woff")',
    fontWeight: 400,
    fontStyle: "normal"
  },
  body: {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  },
  ".display-1": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "78px",
    lineHeight: "104px",
    letterSpacing: "0.2px"
  },
  ".display-2": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "60px",
    lineHeight: "80px",
    letterSpacing: "0.2px"
  },
  ".display-3": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "0.2px"
  },
  ".display-4": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: ["48px", "38.4px"],
    lineHeight: "64px",
    letterSpacing: "0.2px"
  },
  "h1, .text-7, .h1": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "40px",
    lineHeight: "52px",
    letterSpacing: "0.2px",
    margin: "0.5rem 0 1rem"
  },
  "h2, .text-6, .h2": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.2px",
    margin: "1.25rem 0 0.75rem"
  },
  "h3, .text-5, .h3": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.2px",
    margin: "1.25rem 0 0.75rem"
  },
  "h4, .text-4, .h4": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "0.2px",
    margin: "1.25rem 0 0.75rem"
  },
  "h5, .text-3, .h5": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0",
    margin: "1.25rem 0 0.5rem"
  },
  "h6, .text-2, .h6": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0",
    margin: "1.25rem 0 0.25rem"
  },
  "p, .text-1": {
    margin: "0.375rem 0 0.75rem"
  },
  small: {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  "ul, ol": {
    listStyle: "none"
  },
  "ul.list-bulleted": {
    listStyle: "square"
  },
  "ol.list-numbered": {
    listStyle: "decimal"
  },
  ".gs-uitk-text-display-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "300 !important",
    fontSize: "78px !important",
    lineHeight: "104px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-display-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "300 !important",
    fontSize: "60px !important",
    lineHeight: "80px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-display-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "300 !important",
    fontSize: "48px !important",
    lineHeight: "64px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-heading-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "40px !important",
    lineHeight: "52px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-heading-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "32px !important",
    lineHeight: "40px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-heading-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "24px !important",
    lineHeight: "32px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-heading-04": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "20px !important",
    lineHeight: "28px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-heading-05": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-heading-06": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "14px !important",
    lineHeight: "20px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-heading-07": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "12px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-body-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-body-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "14px !important",
    lineHeight: "20px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-body-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "12px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-body-04": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "11px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-body-05": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "10px !important",
    lineHeight: "12px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-ui-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "24px !important",
    lineHeight: "32px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-ui-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "11px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-caption-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "11px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-code-01": {
    fontFamily: '"Roboto Mono", "Courier New", monospace !important',
    fontWeight: "400 !important",
    fontSize: "14px !important",
    lineHeight: "20px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-code-02": {
    fontFamily: '"Roboto Mono", "Courier New", monospace !important',
    fontWeight: "400 !important",
    fontSize: "12px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".gs-uitk-text-label-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-label-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-label-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-display-01-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "78px !important",
    lineHeight: "104px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-display-02-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "60px !important",
    lineHeight: "80px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-display-03-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "48px !important",
    lineHeight: "64px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-heading-01-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "40px !important",
    lineHeight: "52px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-heading-02-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "32px !important",
    lineHeight: "40px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-heading-03-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "24px !important",
    lineHeight: "32px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-heading-04-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "20px !important",
    lineHeight: "28px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-display-01": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "78px !important",
    lineHeight: "104px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-display-02": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "60px !important",
    lineHeight: "80px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-display-03": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "48px !important",
    lineHeight: "64px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-heading-01": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "40px !important",
    lineHeight: "52px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-heading-02": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "32px !important",
    lineHeight: "40px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-heading-03": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "24px !important",
    lineHeight: "32px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-heading-04": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "20px !important",
    lineHeight: "28px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-m-0": {
    margin: "0 !important"
  },
  ".gs-uitk-mt-0, .gs-uitk-my-0": {
    marginTop: "0 !important"
  },
  ".gs-uitk-mr-0, .gs-uitk-mx-0": {
    marginRight: "0 !important"
  },
  ".gs-uitk-mb-0, .gs-uitk-my-0": {
    marginBottom: "0 !important"
  },
  ".gs-uitk-ml-0, .gs-uitk-mx-0": {
    marginLeft: "0 !important"
  },
  ".gs-uitk-m-1px": {
    margin: "1px !important"
  },
  ".gs-uitk-mt-1px, .gs-uitk-my-1px": {
    marginTop: "1px !important"
  },
  ".gs-uitk-mr-1px, .gs-uitk-mx-1px": {
    marginRight: "1px !important"
  },
  ".gs-uitk-mb-1px, .gs-uitk-my-1px": {
    marginBottom: "1px !important"
  },
  ".gs-uitk-ml-1px, .gs-uitk-mx-1px": {
    marginLeft: "1px !important"
  },
  ".gs-uitk-m-0_25": {
    margin: "0.125rem !important"
  },
  ".gs-uitk-mt-0_25, .gs-uitk-my-0_25": {
    marginTop: "0.125rem !important"
  },
  ".gs-uitk-mr-0_25, .gs-uitk-mx-0_25": {
    marginRight: "0.125rem !important"
  },
  ".gs-uitk-mb-0_25, .gs-uitk-my-0_25": {
    marginBottom: "0.125rem !important"
  },
  ".gs-uitk-ml-0_25, .gs-uitk-mx-0_25": {
    marginLeft: "0.125rem !important"
  },
  ".gs-uitk-m-0_5": {
    margin: "0.25rem !important"
  },
  ".gs-uitk-mt-0_5, .gs-uitk-my-0_5": {
    marginTop: "0.25rem !important"
  },
  ".gs-uitk-mr-0_5, .gs-uitk-mx-0_5": {
    marginRight: "0.25rem !important"
  },
  ".gs-uitk-mb-0_5, .gs-uitk-my-0_5": {
    marginBottom: "0.25rem !important"
  },
  ".gs-uitk-ml-0_5, .gs-uitk-mx-0_5": {
    marginLeft: "0.25rem !important"
  },
  ".gs-uitk-m-0_75": {
    margin: "0.375rem !important"
  },
  ".gs-uitk-mt-0_75, .gs-uitk-my-0_75": {
    marginTop: "0.375rem !important"
  },
  ".gs-uitk-mr-0_75, .gs-uitk-mx-0_75": {
    marginRight: "0.375rem !important"
  },
  ".gs-uitk-mb-0_75, .gs-uitk-my-0_75": {
    marginBottom: "0.375rem !important"
  },
  ".gs-uitk-ml-0_75, .gs-uitk-mx-0_75": {
    marginLeft: "0.375rem !important"
  },
  ".gs-uitk-m-1": {
    margin: "0.5rem !important"
  },
  ".gs-uitk-mt-1, .gs-uitk-my-1": {
    marginTop: "0.5rem !important"
  },
  ".gs-uitk-mr-1, .gs-uitk-mx-1": {
    marginRight: "0.5rem !important"
  },
  ".gs-uitk-mb-1, .gs-uitk-my-1": {
    marginBottom: "0.5rem !important"
  },
  ".gs-uitk-ml-1, .gs-uitk-mx-1": {
    marginLeft: "0.5rem !important"
  },
  ".gs-uitk-m-1_5": {
    margin: "0.75rem !important"
  },
  ".gs-uitk-mt-1_5, .gs-uitk-my-1_5": {
    marginTop: "0.75rem !important"
  },
  ".gs-uitk-mr-1_5, .gs-uitk-mx-1_5": {
    marginRight: "0.75rem !important"
  },
  ".gs-uitk-mb-1_5, .gs-uitk-my-1_5": {
    marginBottom: "0.75rem !important"
  },
  ".gs-uitk-ml-1_5, .gs-uitk-mx-1_5": {
    marginLeft: "0.75rem !important"
  },
  ".gs-uitk-m-2": {
    margin: "1rem !important"
  },
  ".gs-uitk-mt-2, .gs-uitk-my-2": {
    marginTop: "1rem !important"
  },
  ".gs-uitk-mr-2, .gs-uitk-mx-2": {
    marginRight: "1rem !important"
  },
  ".gs-uitk-mb-2, .gs-uitk-my-2": {
    marginBottom: "1rem !important"
  },
  ".gs-uitk-ml-2, .gs-uitk-mx-2": {
    marginLeft: "1rem !important"
  },
  ".gs-uitk-m-2_5": {
    margin: "1.25rem !important"
  },
  ".gs-uitk-mt-2_5, .gs-uitk-my-2_5": {
    marginTop: "1.25rem !important"
  },
  ".gs-uitk-mr-2_5, .gs-uitk-mx-2_5": {
    marginRight: "1.25rem !important"
  },
  ".gs-uitk-mb-2_5, .gs-uitk-my-2_5": {
    marginBottom: "1.25rem !important"
  },
  ".gs-uitk-ml-2_5, .gs-uitk-mx-2_5": {
    marginLeft: "1.25rem !important"
  },
  ".gs-uitk-m-3": {
    margin: "1.5rem !important"
  },
  ".gs-uitk-mt-3, .gs-uitk-my-3": {
    marginTop: "1.5rem !important"
  },
  ".gs-uitk-mr-3, .gs-uitk-mx-3": {
    marginRight: "1.5rem !important"
  },
  ".gs-uitk-mb-3, .gs-uitk-my-3": {
    marginBottom: "1.5rem !important"
  },
  ".gs-uitk-ml-3, .gs-uitk-mx-3": {
    marginLeft: "1.5rem !important"
  },
  ".gs-uitk-m-4": {
    margin: "2rem !important"
  },
  ".gs-uitk-mt-4, .gs-uitk-my-4": {
    marginTop: "2rem !important"
  },
  ".gs-uitk-mr-4, .gs-uitk-mx-4": {
    marginRight: "2rem !important"
  },
  ".gs-uitk-mb-4, .gs-uitk-my-4": {
    marginBottom: "2rem !important"
  },
  ".gs-uitk-ml-4, .gs-uitk-mx-4": {
    marginLeft: "2rem !important"
  },
  ".gs-uitk-m-5": {
    margin: "2.5rem !important"
  },
  ".gs-uitk-mt-5, .gs-uitk-my-5": {
    marginTop: "2.5rem !important"
  },
  ".gs-uitk-mr-5, .gs-uitk-mx-5": {
    marginRight: "2.5rem !important"
  },
  ".gs-uitk-mb-5, .gs-uitk-my-5": {
    marginBottom: "2.5rem !important"
  },
  ".gs-uitk-ml-5, .gs-uitk-mx-5": {
    marginLeft: "2.5rem !important"
  },
  ".gs-uitk-m-6": {
    margin: "3rem !important"
  },
  ".gs-uitk-mt-6, .gs-uitk-my-6": {
    marginTop: "3rem !important"
  },
  ".gs-uitk-mr-6, .gs-uitk-mx-6": {
    marginRight: "3rem !important"
  },
  ".gs-uitk-mb-6, .gs-uitk-my-6": {
    marginBottom: "3rem !important"
  },
  ".gs-uitk-ml-6, .gs-uitk-mx-6": {
    marginLeft: "3rem !important"
  },
  ".gs-uitk-m-7": {
    margin: "3.5rem !important"
  },
  ".gs-uitk-mt-7, .gs-uitk-my-7": {
    marginTop: "3.5rem !important"
  },
  ".gs-uitk-mr-7, .gs-uitk-mx-7": {
    marginRight: "3.5rem !important"
  },
  ".gs-uitk-mb-7, .gs-uitk-my-7": {
    marginBottom: "3.5rem !important"
  },
  ".gs-uitk-ml-7, .gs-uitk-mx-7": {
    marginLeft: "3.5rem !important"
  },
  ".gs-uitk-m-8": {
    margin: "4rem !important"
  },
  ".gs-uitk-mt-8, .gs-uitk-my-8": {
    marginTop: "4rem !important"
  },
  ".gs-uitk-mr-8, .gs-uitk-mx-8": {
    marginRight: "4rem !important"
  },
  ".gs-uitk-mb-8, .gs-uitk-my-8": {
    marginBottom: "4rem !important"
  },
  ".gs-uitk-ml-8, .gs-uitk-mx-8": {
    marginLeft: "4rem !important"
  },
  ".gs-uitk-m-9": {
    margin: "4.5rem !important"
  },
  ".gs-uitk-mt-9, .gs-uitk-my-9": {
    marginTop: "4.5rem !important"
  },
  ".gs-uitk-mr-9, .gs-uitk-mx-9": {
    marginRight: "4.5rem !important"
  },
  ".gs-uitk-mb-9, .gs-uitk-my-9": {
    marginBottom: "4.5rem !important"
  },
  ".gs-uitk-ml-9, .gs-uitk-mx-9": {
    marginLeft: "4.5rem !important"
  },
  ".gs-uitk-m-10": {
    margin: "5rem !important"
  },
  ".gs-uitk-mt-10, .gs-uitk-my-10": {
    marginTop: "5rem !important"
  },
  ".gs-uitk-mr-10, .gs-uitk-mx-10": {
    marginRight: "5rem !important"
  },
  ".gs-uitk-mb-10, .gs-uitk-my-10": {
    marginBottom: "5rem !important"
  },
  ".gs-uitk-ml-10, .gs-uitk-mx-10": {
    marginLeft: "5rem !important"
  },
  ".gs-uitk-p-0": {
    padding: "0 !important"
  },
  ".gs-uitk-pt-0, .gs-uitk-py-0": {
    paddingTop: "0 !important"
  },
  ".gs-uitk-pr-0, .gs-uitk-px-0": {
    paddingRight: "0 !important"
  },
  ".gs-uitk-pb-0, .gs-uitk-py-0": {
    paddingBottom: "0 !important"
  },
  ".gs-uitk-pl-0, .gs-uitk-px-0": {
    paddingLeft: "0 !important"
  },
  ".gs-uitk-p-1px": {
    padding: "1px !important"
  },
  ".gs-uitk-pt-1px, .gs-uitk-py-1px": {
    paddingTop: "1px !important"
  },
  ".gs-uitk-pr-1px, .gs-uitk-px-1px": {
    paddingRight: "1px !important"
  },
  ".gs-uitk-pb-1px, .gs-uitk-py-1px": {
    paddingBottom: "1px !important"
  },
  ".gs-uitk-pl-1px, .gs-uitk-px-1px": {
    paddingLeft: "1px !important"
  },
  ".gs-uitk-p-0_25": {
    padding: "0.125rem !important"
  },
  ".gs-uitk-pt-0_25, .gs-uitk-py-0_25": {
    paddingTop: "0.125rem !important"
  },
  ".gs-uitk-pr-0_25, .gs-uitk-px-0_25": {
    paddingRight: "0.125rem !important"
  },
  ".gs-uitk-pb-0_25, .gs-uitk-py-0_25": {
    paddingBottom: "0.125rem !important"
  },
  ".gs-uitk-pl-0_25, .gs-uitk-px-0_25": {
    paddingLeft: "0.125rem !important"
  },
  ".gs-uitk-p-0_5": {
    padding: "0.25rem !important"
  },
  ".gs-uitk-pt-0_5, .gs-uitk-py-0_5": {
    paddingTop: "0.25rem !important"
  },
  ".gs-uitk-pr-0_5, .gs-uitk-px-0_5": {
    paddingRight: "0.25rem !important"
  },
  ".gs-uitk-pb-0_5, .gs-uitk-py-0_5": {
    paddingBottom: "0.25rem !important"
  },
  ".gs-uitk-pl-0_5, .gs-uitk-px-0_5": {
    paddingLeft: "0.25rem !important"
  },
  ".gs-uitk-p-0_75": {
    padding: "0.375rem !important"
  },
  ".gs-uitk-pt-0_75, .gs-uitk-py-0_75": {
    paddingTop: "0.375rem !important"
  },
  ".gs-uitk-pr-0_75, .gs-uitk-px-0_75": {
    paddingRight: "0.375rem !important"
  },
  ".gs-uitk-pb-0_75, .gs-uitk-py-0_75": {
    paddingBottom: "0.375rem !important"
  },
  ".gs-uitk-pl-0_75, .gs-uitk-px-0_75": {
    paddingLeft: "0.375rem !important"
  },
  ".gs-uitk-p-1": {
    padding: "0.5rem !important"
  },
  ".gs-uitk-pt-1, .gs-uitk-py-1": {
    paddingTop: "0.5rem !important"
  },
  ".gs-uitk-pr-1, .gs-uitk-px-1": {
    paddingRight: "0.5rem !important"
  },
  ".gs-uitk-pb-1, .gs-uitk-py-1": {
    paddingBottom: "0.5rem !important"
  },
  ".gs-uitk-pl-1, .gs-uitk-px-1": {
    paddingLeft: "0.5rem !important"
  },
  ".gs-uitk-p-1_5": {
    padding: "0.75rem !important"
  },
  ".gs-uitk-pt-1_5, .gs-uitk-py-1_5": {
    paddingTop: "0.75rem !important"
  },
  ".gs-uitk-pr-1_5, .gs-uitk-px-1_5": {
    paddingRight: "0.75rem !important"
  },
  ".gs-uitk-pb-1_5, .gs-uitk-py-1_5": {
    paddingBottom: "0.75rem !important"
  },
  ".gs-uitk-pl-1_5, .gs-uitk-px-1_5": {
    paddingLeft: "0.75rem !important"
  },
  ".gs-uitk-p-2": {
    padding: "1rem !important"
  },
  ".gs-uitk-pt-2, .gs-uitk-py-2": {
    paddingTop: "1rem !important"
  },
  ".gs-uitk-pr-2, .gs-uitk-px-2": {
    paddingRight: "1rem !important"
  },
  ".gs-uitk-pb-2, .gs-uitk-py-2": {
    paddingBottom: "1rem !important"
  },
  ".gs-uitk-pl-2, .gs-uitk-px-2": {
    paddingLeft: "1rem !important"
  },
  ".gs-uitk-p-2_5": {
    padding: "1.25rem !important"
  },
  ".gs-uitk-pt-2_5, .gs-uitk-py-2_5": {
    paddingTop: "1.25rem !important"
  },
  ".gs-uitk-pr-2_5, .gs-uitk-px-2_5": {
    paddingRight: "1.25rem !important"
  },
  ".gs-uitk-pb-2_5, .gs-uitk-py-2_5": {
    paddingBottom: "1.25rem !important"
  },
  ".gs-uitk-pl-2_5, .gs-uitk-px-2_5": {
    paddingLeft: "1.25rem !important"
  },
  ".gs-uitk-p-3": {
    padding: "1.5rem !important"
  },
  ".gs-uitk-pt-3, .gs-uitk-py-3": {
    paddingTop: "1.5rem !important"
  },
  ".gs-uitk-pr-3, .gs-uitk-px-3": {
    paddingRight: "1.5rem !important"
  },
  ".gs-uitk-pb-3, .gs-uitk-py-3": {
    paddingBottom: "1.5rem !important"
  },
  ".gs-uitk-pl-3, .gs-uitk-px-3": {
    paddingLeft: "1.5rem !important"
  },
  ".gs-uitk-p-4": {
    padding: "2rem !important"
  },
  ".gs-uitk-pt-4, .gs-uitk-py-4": {
    paddingTop: "2rem !important"
  },
  ".gs-uitk-pr-4, .gs-uitk-px-4": {
    paddingRight: "2rem !important"
  },
  ".gs-uitk-pb-4, .gs-uitk-py-4": {
    paddingBottom: "2rem !important"
  },
  ".gs-uitk-pl-4, .gs-uitk-px-4": {
    paddingLeft: "2rem !important"
  },
  ".gs-uitk-p-5": {
    padding: "2.5rem !important"
  },
  ".gs-uitk-pt-5, .gs-uitk-py-5": {
    paddingTop: "2.5rem !important"
  },
  ".gs-uitk-pr-5, .gs-uitk-px-5": {
    paddingRight: "2.5rem !important"
  },
  ".gs-uitk-pb-5, .gs-uitk-py-5": {
    paddingBottom: "2.5rem !important"
  },
  ".gs-uitk-pl-5, .gs-uitk-px-5": {
    paddingLeft: "2.5rem !important"
  },
  ".gs-uitk-p-6": {
    padding: "3rem !important"
  },
  ".gs-uitk-pt-6, .gs-uitk-py-6": {
    paddingTop: "3rem !important"
  },
  ".gs-uitk-pr-6, .gs-uitk-px-6": {
    paddingRight: "3rem !important"
  },
  ".gs-uitk-pb-6, .gs-uitk-py-6": {
    paddingBottom: "3rem !important"
  },
  ".gs-uitk-pl-6, .gs-uitk-px-6": {
    paddingLeft: "3rem !important"
  },
  ".gs-uitk-p-7": {
    padding: "3.5rem !important"
  },
  ".gs-uitk-pt-7, .gs-uitk-py-7": {
    paddingTop: "3.5rem !important"
  },
  ".gs-uitk-pr-7, .gs-uitk-px-7": {
    paddingRight: "3.5rem !important"
  },
  ".gs-uitk-pb-7, .gs-uitk-py-7": {
    paddingBottom: "3.5rem !important"
  },
  ".gs-uitk-pl-7, .gs-uitk-px-7": {
    paddingLeft: "3.5rem !important"
  },
  ".gs-uitk-p-8": {
    padding: "4rem !important"
  },
  ".gs-uitk-pt-8, .gs-uitk-py-8": {
    paddingTop: "4rem !important"
  },
  ".gs-uitk-pr-8, .gs-uitk-px-8": {
    paddingRight: "4rem !important"
  },
  ".gs-uitk-pb-8, .gs-uitk-py-8": {
    paddingBottom: "4rem !important"
  },
  ".gs-uitk-pl-8, .gs-uitk-px-8": {
    paddingLeft: "4rem !important"
  },
  ".gs-uitk-p-9": {
    padding: "4.5rem !important"
  },
  ".gs-uitk-pt-9, .gs-uitk-py-9": {
    paddingTop: "4.5rem !important"
  },
  ".gs-uitk-pr-9, .gs-uitk-px-9": {
    paddingRight: "4.5rem !important"
  },
  ".gs-uitk-pb-9, .gs-uitk-py-9": {
    paddingBottom: "4.5rem !important"
  },
  ".gs-uitk-pl-9, .gs-uitk-px-9": {
    paddingLeft: "4.5rem !important"
  },
  ".gs-uitk-p-10": {
    padding: "5rem !important"
  },
  ".gs-uitk-pt-10, .gs-uitk-py-10": {
    paddingTop: "5rem !important"
  },
  ".gs-uitk-pr-10, .gs-uitk-px-10": {
    paddingRight: "5rem !important"
  },
  ".gs-uitk-pb-10, .gs-uitk-py-10": {
    paddingBottom: "5rem !important"
  },
  ".gs-uitk-pl-10, .gs-uitk-px-10": {
    paddingLeft: "5rem !important"
  },
  ".gs-uitk-h-0": {
    height: "0 !important"
  },
  ".gs-uitk-w-0": {
    width: "0 !important"
  },
  ".gs-uitk-m-n0": {
    margin: "0 !important"
  },
  ".gs-uitk-mt-n0, .gs-uitk-my-n0": {
    marginTop: "0 !important"
  },
  ".gs-uitk-mr-n0, .gs-uitk-mx-n0": {
    marginRight: "0 !important"
  },
  ".gs-uitk-mb-n0, .gs-uitk-my-n0": {
    marginBottom: "0 !important"
  },
  ".gs-uitk-ml-n0, .gs-uitk-mx-n0": {
    marginLeft: "0 !important"
  },
  ".gs-uitk-h-1px": {
    height: "1px !important"
  },
  ".gs-uitk-w-1px": {
    width: "1px !important"
  },
  ".gs-uitk-m-n1px": {
    margin: "-1px !important"
  },
  ".gs-uitk-mt-n1px, .gs-uitk-my-n1px": {
    marginTop: "-1px !important"
  },
  ".gs-uitk-mr-n1px, .gs-uitk-mx-n1px": {
    marginRight: "-1px !important"
  },
  ".gs-uitk-mb-n1px, .gs-uitk-my-n1px": {
    marginBottom: "-1px !important"
  },
  ".gs-uitk-ml-n1px, .gs-uitk-mx-n1px": {
    marginLeft: "-1px !important"
  },
  ".gs-uitk-h-0_25": {
    height: "0.125rem !important"
  },
  ".gs-uitk-w-0_25": {
    width: "0.125rem !important"
  },
  ".gs-uitk-m-n0_25": {
    margin: "-0.125rem !important"
  },
  ".gs-uitk-mt-n0_25, .gs-uitk-my-n0_25": {
    marginTop: "-0.125rem !important"
  },
  ".gs-uitk-mr-n0_25, .gs-uitk-mx-n0_25": {
    marginRight: "-0.125rem !important"
  },
  ".gs-uitk-mb-n0_25, .gs-uitk-my-n0_25": {
    marginBottom: "-0.125rem !important"
  },
  ".gs-uitk-ml-n0_25, .gs-uitk-mx-n0_25": {
    marginLeft: "-0.125rem !important"
  },
  ".gs-uitk-h-0_5": {
    height: "0.25rem !important"
  },
  ".gs-uitk-w-0_5": {
    width: "0.25rem !important"
  },
  ".gs-uitk-m-n0_5": {
    margin: "-0.25rem !important"
  },
  ".gs-uitk-mt-n0_5, .gs-uitk-my-n0_5": {
    marginTop: "-0.25rem !important"
  },
  ".gs-uitk-mr-n0_5, .gs-uitk-mx-n0_5": {
    marginRight: "-0.25rem !important"
  },
  ".gs-uitk-mb-n0_5, .gs-uitk-my-n0_5": {
    marginBottom: "-0.25rem !important"
  },
  ".gs-uitk-ml-n0_5, .gs-uitk-mx-n0_5": {
    marginLeft: "-0.25rem !important"
  },
  ".gs-uitk-h-0_75": {
    height: "0.375rem !important"
  },
  ".gs-uitk-w-0_75": {
    width: "0.375rem !important"
  },
  ".gs-uitk-m-n0_75": {
    margin: "-0.375rem !important"
  },
  ".gs-uitk-mt-n0_75, .gs-uitk-my-n0_75": {
    marginTop: "-0.375rem !important"
  },
  ".gs-uitk-mr-n0_75, .gs-uitk-mx-n0_75": {
    marginRight: "-0.375rem !important"
  },
  ".gs-uitk-mb-n0_75, .gs-uitk-my-n0_75": {
    marginBottom: "-0.375rem !important"
  },
  ".gs-uitk-ml-n0_75, .gs-uitk-mx-n0_75": {
    marginLeft: "-0.375rem !important"
  },
  ".gs-uitk-h-1": {
    height: "0.5rem !important"
  },
  ".gs-uitk-w-1": {
    width: "0.5rem !important"
  },
  ".gs-uitk-m-n1": {
    margin: "-0.5rem !important"
  },
  ".gs-uitk-mt-n1, .gs-uitk-my-n1": {
    marginTop: "-0.5rem !important"
  },
  ".gs-uitk-mr-n1, .gs-uitk-mx-n1": {
    marginRight: "-0.5rem !important"
  },
  ".gs-uitk-mb-n1, .gs-uitk-my-n1": {
    marginBottom: "-0.5rem !important"
  },
  ".gs-uitk-ml-n1, .gs-uitk-mx-n1": {
    marginLeft: "-0.5rem !important"
  },
  ".gs-uitk-h-1_5": {
    height: "0.75rem !important"
  },
  ".gs-uitk-w-1_5": {
    width: "0.75rem !important"
  },
  ".gs-uitk-m-n1_5": {
    margin: "-0.75rem !important"
  },
  ".gs-uitk-mt-n1_5, .gs-uitk-my-n1_5": {
    marginTop: "-0.75rem !important"
  },
  ".gs-uitk-mr-n1_5, .gs-uitk-mx-n1_5": {
    marginRight: "-0.75rem !important"
  },
  ".gs-uitk-mb-n1_5, .gs-uitk-my-n1_5": {
    marginBottom: "-0.75rem !important"
  },
  ".gs-uitk-ml-n1_5, .gs-uitk-mx-n1_5": {
    marginLeft: "-0.75rem !important"
  },
  ".gs-uitk-h-2": {
    height: "1rem !important"
  },
  ".gs-uitk-w-2": {
    width: "1rem !important"
  },
  ".gs-uitk-m-n2": {
    margin: "-1rem !important"
  },
  ".gs-uitk-mt-n2, .gs-uitk-my-n2": {
    marginTop: "-1rem !important"
  },
  ".gs-uitk-mr-n2, .gs-uitk-mx-n2": {
    marginRight: "-1rem !important"
  },
  ".gs-uitk-mb-n2, .gs-uitk-my-n2": {
    marginBottom: "-1rem !important"
  },
  ".gs-uitk-ml-n2, .gs-uitk-mx-n2": {
    marginLeft: "-1rem !important"
  },
  ".gs-uitk-h-2_5": {
    height: "1.25rem !important"
  },
  ".gs-uitk-w-2_5": {
    width: "1.25rem !important"
  },
  ".gs-uitk-m-n2_5": {
    margin: "-1.25rem !important"
  },
  ".gs-uitk-mt-n2_5, .gs-uitk-my-n2_5": {
    marginTop: "-1.25rem !important"
  },
  ".gs-uitk-mr-n2_5, .gs-uitk-mx-n2_5": {
    marginRight: "-1.25rem !important"
  },
  ".gs-uitk-mb-n2_5, .gs-uitk-my-n2_5": {
    marginBottom: "-1.25rem !important"
  },
  ".gs-uitk-ml-n2_5, .gs-uitk-mx-n2_5": {
    marginLeft: "-1.25rem !important"
  },
  ".gs-uitk-h-3": {
    height: "1.5rem !important"
  },
  ".gs-uitk-w-3": {
    width: "1.5rem !important"
  },
  ".gs-uitk-m-n3": {
    margin: "-1.5rem !important"
  },
  ".gs-uitk-mt-n3, .gs-uitk-my-n3": {
    marginTop: "-1.5rem !important"
  },
  ".gs-uitk-mr-n3, .gs-uitk-mx-n3": {
    marginRight: "-1.5rem !important"
  },
  ".gs-uitk-mb-n3, .gs-uitk-my-n3": {
    marginBottom: "-1.5rem !important"
  },
  ".gs-uitk-ml-n3, .gs-uitk-mx-n3": {
    marginLeft: "-1.5rem !important"
  },
  ".gs-uitk-h-4": {
    height: "2rem !important"
  },
  ".gs-uitk-w-4": {
    width: "2rem !important"
  },
  ".gs-uitk-m-n4": {
    margin: "-2rem !important"
  },
  ".gs-uitk-mt-n4, .gs-uitk-my-n4": {
    marginTop: "-2rem !important"
  },
  ".gs-uitk-mr-n4, .gs-uitk-mx-n4": {
    marginRight: "-2rem !important"
  },
  ".gs-uitk-mb-n4, .gs-uitk-my-n4": {
    marginBottom: "-2rem !important"
  },
  ".gs-uitk-ml-n4, .gs-uitk-mx-n4": {
    marginLeft: "-2rem !important"
  },
  ".gs-uitk-h-5": {
    height: "2.5rem !important"
  },
  ".gs-uitk-w-5": {
    width: "2.5rem !important"
  },
  ".gs-uitk-m-n5": {
    margin: "-2.5rem !important"
  },
  ".gs-uitk-mt-n5, .gs-uitk-my-n5": {
    marginTop: "-2.5rem !important"
  },
  ".gs-uitk-mr-n5, .gs-uitk-mx-n5": {
    marginRight: "-2.5rem !important"
  },
  ".gs-uitk-mb-n5, .gs-uitk-my-n5": {
    marginBottom: "-2.5rem !important"
  },
  ".gs-uitk-ml-n5, .gs-uitk-mx-n5": {
    marginLeft: "-2.5rem !important"
  },
  ".gs-uitk-h-6": {
    height: "3rem !important"
  },
  ".gs-uitk-w-6": {
    width: "3rem !important"
  },
  ".gs-uitk-m-n6": {
    margin: "-3rem !important"
  },
  ".gs-uitk-mt-n6, .gs-uitk-my-n6": {
    marginTop: "-3rem !important"
  },
  ".gs-uitk-mr-n6, .gs-uitk-mx-n6": {
    marginRight: "-3rem !important"
  },
  ".gs-uitk-mb-n6, .gs-uitk-my-n6": {
    marginBottom: "-3rem !important"
  },
  ".gs-uitk-ml-n6, .gs-uitk-mx-n6": {
    marginLeft: "-3rem !important"
  },
  ".gs-uitk-h-7": {
    height: "3.5rem !important"
  },
  ".gs-uitk-w-7": {
    width: "3.5rem !important"
  },
  ".gs-uitk-m-n7": {
    margin: "-3.5rem !important"
  },
  ".gs-uitk-mt-n7, .gs-uitk-my-n7": {
    marginTop: "-3.5rem !important"
  },
  ".gs-uitk-mr-n7, .gs-uitk-mx-n7": {
    marginRight: "-3.5rem !important"
  },
  ".gs-uitk-mb-n7, .gs-uitk-my-n7": {
    marginBottom: "-3.5rem !important"
  },
  ".gs-uitk-ml-n7, .gs-uitk-mx-n7": {
    marginLeft: "-3.5rem !important"
  },
  ".gs-uitk-h-8": {
    height: "4rem !important"
  },
  ".gs-uitk-w-8": {
    width: "4rem !important"
  },
  ".gs-uitk-m-n8": {
    margin: "-4rem !important"
  },
  ".gs-uitk-mt-n8, .gs-uitk-my-n8": {
    marginTop: "-4rem !important"
  },
  ".gs-uitk-mr-n8, .gs-uitk-mx-n8": {
    marginRight: "-4rem !important"
  },
  ".gs-uitk-mb-n8, .gs-uitk-my-n8": {
    marginBottom: "-4rem !important"
  },
  ".gs-uitk-ml-n8, .gs-uitk-mx-n8": {
    marginLeft: "-4rem !important"
  },
  ".gs-uitk-h-9": {
    height: "4.5rem !important"
  },
  ".gs-uitk-w-9": {
    width: "4.5rem !important"
  },
  ".gs-uitk-m-n9": {
    margin: "-4.5rem !important"
  },
  ".gs-uitk-mt-n9, .gs-uitk-my-n9": {
    marginTop: "-4.5rem !important"
  },
  ".gs-uitk-mr-n9, .gs-uitk-mx-n9": {
    marginRight: "-4.5rem !important"
  },
  ".gs-uitk-mb-n9, .gs-uitk-my-n9": {
    marginBottom: "-4.5rem !important"
  },
  ".gs-uitk-ml-n9, .gs-uitk-mx-n9": {
    marginLeft: "-4.5rem !important"
  },
  ".gs-uitk-h-10": {
    height: "5rem !important"
  },
  ".gs-uitk-w-10": {
    width: "5rem !important"
  },
  ".gs-uitk-m-n10": {
    margin: "-5rem !important"
  },
  ".gs-uitk-mt-n10, .gs-uitk-my-n10": {
    marginTop: "-5rem !important"
  },
  ".gs-uitk-mr-n10, .gs-uitk-mx-n10": {
    marginRight: "-5rem !important"
  },
  ".gs-uitk-mb-n10, .gs-uitk-my-n10": {
    marginBottom: "-5rem !important"
  },
  ".gs-uitk-ml-n10, .gs-uitk-mx-n10": {
    marginLeft: "-5rem !important"
  },
  ".gs-uitk-shadow-100": {
    boxShadow: "0 0 1px 0 rgba(0, 0, 0, 0.1), 0 2px 4px 0 rgba(0, 0, 0, 0.1) !important"
  },
  ".gs-uitk-shadow-200": {
    boxShadow: "0 8px 12px 0 rgba(0, 0, 0, 0.06), 0 2px 4px 0 rgba(0, 0, 0, 0.06) !important"
  },
  ".gs-uitk-shadow-300": {
    boxShadow: "0 10px 32px 0 rgba(0, 0, 0, 0.08), 0 3px 8px 0 rgba(0, 0, 0, 0.12) !important"
  },
  ".gs-uitk-shadow-400": {
    boxShadow: "0 24px 32px 0 rgba(0, 0, 0, 0.12), 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1) !important"
  },
  ".gs-uitk-shadow-side-right": {
    boxShadow: "3px 0 15px 0 rgba(0, 0, 0, 0.12), 2px 0 3px 0 rgba(0, 0, 0, 0.15) !important"
  },
  ".gs-uitk-shadow-side-left": {
    boxShadow: "-3px 0 15px 0 rgba(0, 0, 0, 0.12), -2px 0 3px 0 rgba(0, 0, 0, 0.15) !important"
  },
  ".dataviz-purple-10": {
    background: "#F3E5F5",
    color: "#000000"
  },
  ".dataviz-purple-20": {
    background: "#E1BEE7",
    color: "#000000"
  },
  ".dataviz-purple-30": {
    background: "#CE93D8",
    color: "#000000"
  },
  ".dataviz-purple-40": {
    background: "#BA68C8",
    color: "#000000"
  },
  ".dataviz-purple-50": {
    background: "#AB47BC",
    color: "#ffffff"
  },
  ".dataviz-purple-60": {
    background: "#9C27B0",
    color: "#ffffff"
  },
  ".dataviz-purple-70": {
    background: "#8E24AA",
    color: "#ffffff"
  },
  ".dataviz-purple-80": {
    background: "#7B1FA2",
    color: "#ffffff"
  },
  ".dataviz-purple-90": {
    background: "#6a1b9a",
    color: "#ffffff"
  },
  ".dataviz-purple-100": {
    background: "#4A148C",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-10": {
    background: "#E7EAF4",
    color: "#000000"
  },
  ".dataviz-darker-blue-20": {
    background: "#C2C9E5",
    color: "#000000"
  },
  ".dataviz-darker-blue-30": {
    background: "#9BA6D3",
    color: "#000000"
  },
  ".dataviz-darker-blue-40": {
    background: "#7484C2",
    color: "#000000"
  },
  ".dataviz-darker-blue-50": {
    background: "#5569B5",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-60": {
    background: "#364FA9",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-70": {
    background: "#2F48A0",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-80": {
    background: "#263E94",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-90": {
    background: "#1E3488",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-100": {
    background: "#0F2372",
    color: "#ffffff"
  },
  ".dataviz-dark-blue-10": {
    background: "#E3F2FC",
    color: "#000000"
  },
  ".dataviz-dark-blue-20": {
    background: "#BADFF9",
    color: "#000000"
  },
  ".dataviz-dark-blue-30": {
    background: "#8FCBF6",
    color: "#000000"
  },
  ".dataviz-dark-blue-40": {
    background: "#63B6F3",
    color: "#000000"
  },
  ".dataviz-dark-blue-50": {
    background: "#3FA6F1",
    color: "#000000"
  },
  ".dataviz-dark-blue-60": {
    background: "#1898EF",
    color: "#000000"
  },
  ".dataviz-dark-blue-70": {
    background: "#118AE1",
    color: "#000000"
  },
  ".dataviz-dark-blue-80": {
    background: "#0778CF",
    color: "#ffffff"
  },
  ".dataviz-dark-blue-90": {
    background: "#0067BD",
    color: "#ffffff"
  },
  ".dataviz-dark-blue-100": {
    background: "#00499E",
    color: "#ffffff"
  },
  ".dataviz-blue-10": {
    background: "#E2F1FF",
    color: "#000000"
  },
  ".dataviz-blue-20": {
    background: "#B9DCFF",
    color: "#000000"
  },
  ".dataviz-blue-30": {
    background: "#8AC7FF",
    color: "#000000"
  },
  ".dataviz-blue-40": {
    background: "#54B1FF",
    color: "#000000"
  },
  ".dataviz-blue-50": {
    background: "#21A0FF",
    color: "#000000"
  },
  ".dataviz-blue-60": {
    background: "#008FFF",
    color: "#000000"
  },
  ".dataviz-blue-70": {
    background: "#0080FF",
    color: "#000000"
  },
  ".dataviz-blue-80": {
    background: "#0F6DEE",
    color: "#ffffff"
  },
  ".dataviz-blue-90": {
    background: "#195BDB",
    color: "#ffffff"
  },
  ".dataviz-blue-100": {
    background: "#2239BC",
    color: "#ffffff"
  },
  ".dataviz-teal-10": {
    background: "#E0F2F1",
    color: "#000000"
  },
  ".dataviz-teal-20": {
    background: "#B2DFDB",
    color: "#000000"
  },
  ".dataviz-teal-30": {
    background: "#80CBC4",
    color: "#000000"
  },
  ".dataviz-teal-40": {
    background: "#4DB6AC",
    color: "#000000"
  },
  ".dataviz-teal-50": {
    background: "#26A69A",
    color: "#000000"
  },
  ".dataviz-teal-60": {
    background: "#009688",
    color: "#000000"
  },
  ".dataviz-teal-70": {
    background: "#00897B",
    color: "#000000"
  },
  ".dataviz-teal-80": {
    background: "#00796B",
    color: "#ffffff"
  },
  ".dataviz-teal-90": {
    background: "#00695C",
    color: "#ffffff"
  },
  ".dataviz-teal-100": {
    background: "#004D40",
    color: "#ffffff"
  },
  ".dataviz-green-10": {
    background: "#E6F7ED",
    color: "#000000"
  },
  ".dataviz-green-20": {
    background: "#C3EAD3",
    color: "#000000"
  },
  ".dataviz-green-30": {
    background: "#9CDDB8",
    color: "#000000"
  },
  ".dataviz-green-40": {
    background: "#70D19C",
    color: "#000000"
  },
  ".dataviz-green-50": {
    background: "#4CC686",
    color: "#000000"
  },
  ".dataviz-green-60": {
    background: "#1ABB71",
    color: "#000000"
  },
  ".dataviz-green-70": {
    background: "#10AC66",
    color: "#000000"
  },
  ".dataviz-green-80": {
    background: "#009959",
    color: "#000000"
  },
  ".dataviz-green-90": {
    background: "#00884D",
    color: "#ffffff"
  },
  ".dataviz-green-100": {
    background: "#006838",
    color: "#ffffff"
  },
  ".dataviz-red-10": {
    background: "#FFECEF",
    color: "#000000"
  },
  ".dataviz-red-20": {
    background: "#FFCFD4",
    color: "#000000"
  },
  ".dataviz-red-30": {
    background: "#F29E9E",
    color: "#000000"
  },
  ".dataviz-red-40": {
    background: "#E97878",
    color: "#000000"
  },
  ".dataviz-red-50": {
    background: "#F45A56",
    color: "#000000"
  },
  ".dataviz-red-60": {
    background: "#F94B3C",
    color: "#000000"
  },
  ".dataviz-red-70": {
    background: "#EB423C",
    color: "#000000"
  },
  ".dataviz-red-80": {
    background: "#D93836",
    color: "#ffffff"
  },
  ".dataviz-red-90": {
    background: "#CC322F",
    color: "#ffffff"
  },
  ".dataviz-red-100": {
    background: "#BC2723",
    color: "#ffffff"
  },
  ".dataviz-orange-10": {
    background: "#FFF8E1",
    color: "#000000"
  },
  ".dataviz-orange-20": {
    background: "#FFECB3",
    color: "#000000"
  },
  ".dataviz-orange-30": {
    background: "#FFE082",
    color: "#000000"
  },
  ".dataviz-orange-40": {
    background: "#FFD54F",
    color: "#000000"
  },
  ".dataviz-orange-50": {
    background: "#FFCA28",
    color: "#000000"
  },
  ".dataviz-orange-60": {
    background: "#FFC107",
    color: "#000000"
  },
  ".dataviz-orange-70": {
    background: "#FFB300",
    color: "#000000"
  },
  ".dataviz-orange-80": {
    background: "#FFA000",
    color: "#000000"
  },
  ".dataviz-orange-90": {
    background: "#FF8F00",
    color: "#000000"
  },
  ".dataviz-orange-100": {
    background: "#FF6F00",
    color: "#000000"
  },
  ".dataviz-light-orange-10": {
    background: "#FFF8E2",
    color: "#000000"
  },
  ".dataviz-light-orange-20": {
    background: "#FFECB4",
    color: "#000000"
  },
  ".dataviz-light-orange-30": {
    background: "#FFE084",
    color: "#000000"
  },
  ".dataviz-light-orange-40": {
    background: "#FFD653",
    color: "#000000"
  },
  ".dataviz-light-orange-50": {
    background: "#FFCB30",
    color: "#000000"
  },
  ".dataviz-light-orange-60": {
    background: "#FFC219",
    color: "#000000"
  },
  ".dataviz-light-orange-70": {
    background: "#FFB413",
    color: "#000000"
  },
  ".dataviz-light-orange-80": {
    background: "#FEA111",
    color: "#000000"
  },
  ".dataviz-light-orange-90": {
    background: "#FE9110",
    color: "#000000"
  },
  ".dataviz-light-orange-100": {
    background: "#FE710D",
    color: "#000000"
  },
  ".dataviz-yellow-10": {
    background: "#FFFDE7",
    color: "#000000"
  },
  ".dataviz-yellow-20": {
    background: "#FFF9C4",
    color: "#000000"
  },
  ".dataviz-yellow-30": {
    background: "#FEF59D",
    color: "#000000"
  },
  ".dataviz-yellow-40": {
    background: "#FEF075",
    color: "#000000"
  },
  ".dataviz-yellow-50": {
    background: "#FBEB55",
    color: "#000000"
  },
  ".dataviz-yellow-60": {
    background: "#FEEB3B",
    color: "#000000"
  },
  ".dataviz-yellow-70": {
    background: "#FCD835",
    color: "#000000"
  },
  ".dataviz-yellow-80": {
    background: "#FAC02D",
    color: "#000000"
  },
  ".dataviz-yellow-90": {
    background: "#F8A824",
    color: "#000000"
  },
  ".dataviz-yellow-100": {
    background: "#F47F16",
    color: "#000000"
  },
  ".dataviz-pastel-10": {
    background: "#FFF8E1",
    color: "#000000"
  },
  ".dataviz-pastel-20": {
    background: "#F3E5F5",
    color: "#000000"
  },
  ".dataviz-pastel-30": {
    background: "#E0F2F1",
    color: "#000000"
  },
  ".dataviz-pastel-40": {
    background: "#FFFDE7",
    color: "#000000"
  },
  ".dataviz-pastel-50": {
    background: "#E7EAF4",
    color: "#000000"
  },
  ".dataviz-pastel-60": {
    background: "#FFF8E1",
    color: "#000000"
  },
  ".dataviz-pastel-70": {
    background: "#F3E5F5",
    color: "#000000"
  },
  ".dataviz-pastel-80": {
    background: "#E0F2F1",
    color: "#000000"
  },
  ".dataviz-pastel-90": {
    background: "#FFFDE7",
    color: "#000000"
  },
  ".dataviz-pastel-100": {
    background: "#E7EAF4",
    color: "#000000"
  },
  "@keyframes rotating": {
    from: {
      transform: "rotate(0deg)"
    },
    to: {
      transform: "rotate(360deg)"
    }
  },
  "@keyframes animation-fade": {
    "0%": {
      opacity: 0
    },
    "100%": {
      opacity: 1
    }
  },
  "@keyframes animation-grow": {
    "0%": {
      opacity: 0,
      transform: "scale(0)"
    },
    "100%": {
      opacity: 1,
      transform: "scale(1)"
    }
  },
  "@keyframes animation-slide-left": {
    "0%": {
      opacity: 0,
      transform: "translateX(2rem)"
    },
    "75%": {
      opacity: 1
    },
    "100%": {
      transform: "translateX(0)"
    }
  },
  "@keyframes animation-slide-right": {
    "0%": {
      opacity: 0,
      transform: "translateX(-2rem)"
    },
    "75%": {
      opacity: 1
    },
    "100%": {
      transform: "translateX(0)"
    }
  },
  "@keyframes animation-slide-top": {
    "0%": {
      opacity: 0,
      transform: "translateY(2rem)"
    },
    "75%": {
      opacity: 1
    },
    "100%": {
      transform: "translateY(0)"
    }
  },
  "@keyframes animation-slide-bottom": {
    "0%": {
      opacity: 0,
      transform: "translateY(-2rem)"
    },
    "75%": {
      opacity: 1
    },
    "100%": {
      transform: "translateY(0)"
    }
  },
  "@keyframes animation-ring-bell": {
    "20%": {
      transform: "rotate(30deg)"
    },
    "40%": {
      transform: "rotate(-30deg)"
    },
    "60%": {
      transform: "rotate(12.66deg)"
    },
    "80%": {
      transform: "rotate(-3.75deg)"
    },
    "100%": {
      transform: "rotate(0)"
    }
  },
  "@keyframes animation-rotate-2": {
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(360deg)"
    }
  },
  "@keyframes animation-fly-plane": {
    "0%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    },
    "40%": {
      transform: "translate3d(1rem, -1rem, 0)",
      opacity: 0
    },
    "60%": {
      transform: "translate3d(-1rem, 1rem, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  },
  "@keyframes animation-heartbeat": {
    "0%": {
      transform: "scale(1)",
      color: "inherit"
    },
    "15%": {
      transform: "scale(1.2)",
      color: "var(--danger)"
    },
    "50%": {
      transform: "scale(1)",
      color: "inherit"
    },
    "65%": {
      transform: "scale(1.2)",
      color: "var(--danger)"
    },
    "100%": {
      transform: "scale(1)",
      color: "inherit"
    }
  },
  "::-webkit-scrollbar": {
    width: "9px",
    height: "8px",
    backgroundColor: "transparent"
  },
  "@media (max-width: 575.98px)": {
    "::-webkit-scrollbar": {
      display: "none",
      width: "0px"
    }
  },
  "::-webkit-scrollbar-track": {
    borderRadius: "0px",
    backgroundColor: "transparent",
    border: "4px solid transparent",
    backgroundClip: "content-box"
  },
  "::-webkit-scrollbar-track:hover": {
    background: "#f2f5f7"
  },
  "::-webkit-scrollbar-thumb": {
    border: "1px solid #c1ccd6",
    background: "#c1ccd6"
  },
  "::-webkit-scrollbar-thumb:hover": {
    border: "0px solid #dce3e8",
    background: "#1c2b36"
  },
  "::-webkit-scrollbar-thumb:active": {
    background: "#1c2b36"
  },
  "::-webkit-scrollbar-corner": {
    background: "transparent"
  },
  ".gs-uitk-html-select": {
    backgroundColor: "#ffffff",
    backgroundClip: "padding-box",
    height: "2rem",
    borderRadius: "0.125rem",
    border: "1px solid #9fb1bd",
    padding: "0.3125rem 0.5rem",
    transition: "border-color 0.15s ease-in-out",
    color: "#1c2b36",
    fontFamily: "Goldman Sans",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.00625rem"
  },
  ".gs-uitk-html-select:focus": {
    boxShadow: "none",
    borderColor: "#186ade",
    outlineWidth: "0"
  },
  ".gs-uitk-html-select:hover": {
    borderColor: "#7a909e"
  },
  ".gs-uitk-html-select--xs, .gs-uitk-html-select--sm": {
    height: "1.5rem",
    lineHeight: "1rem",
    fontSize: "0.75rem"
  },
  ".gs-uitk-html-select--lg, .gs-uitk-html-select--xl": {
    height: "2.5rem",
    lineHeight: "1.5rem",
    fontSize: "1rem"
  },
  ".gs-uitk-html-select:disabled, .gs-uitk-html-select:disabled:hover, .gs-uitk-html-select:disabled:focus, .gs-uitk-html-select:disabled:active": {
    backgroundColor: "rgba(91, 114, 130, 0.1)",
    borderColor: "rgba(91, 114, 130, 0.1)",
    color: "rgba(28, 43, 54, 0.2)"
  },
  ".gs-uitk-html-select--error": {
    borderColor: "#d91f11"
  },
  ".gs-uitk-html-select--success": {
    borderColor: "#fc9162"
  },
  ".gs-uitk-html-select--warning": {
    borderColor: "#186ade"
  }
};

// components/design-system/common/src/get-scoped-css.ts
function getScopedCss(css, scopingSelector) {
  return Object.entries(css).reduce(
    (rules, [selector, properties]) => {
      if (selector.startsWith("@")) {
        if (selector.startsWith("@media")) {
          const mediaSelector = Object.keys(properties)[0];
          delete Object.assign(properties, {
            [`${scopingSelector} ${mediaSelector}`]: properties[mediaSelector]
          })[mediaSelector];
          rules[selector] = properties;
        }
      } else {
        rules[`${scopingSelector} ${selector === "body" ? "" : selector}`] = properties;
      }
      return rules;
    },
    {}
  );
}

// components/design-system/common/src/inject-legacy-global-design-system-css.ts
var stylesInjected = /* @__PURE__ */ new Set();
function injectLegacyGlobalDesignSystemCss(scopingSelector) {
  if (stylesInjected.has(scopingSelector || ""))
    return;
  if (scopingSelector) {
    injectGlobal(getScopedCss(design_system_scss_default, scopingSelector));
  } else {
    injectGlobal(design_system_scss_default);
  }
  stylesInjected.add(scopingSelector || "");
}

// components/design-system/common/src/inject-legacy-global-design-system-demo-css.ts
import { injectGlobal as injectGlobal2 } from "@gs-ux-uitoolkit-common/style";

// components/design-system/common/src/generated/demo.scss.ts
var demo_scss_default = {
  ".gs-uitk-elevation-00": {
    boxShadow: "none !important"
  },
  ".gs-uitk-elevation-01": {
    boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-02": {
    boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-03": {
    boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px -1px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-04": {
    boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px -1px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-05": {
    boxShadow: "0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 5px 5px -3px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-06": {
    boxShadow: "0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12), 0px 7px 8px -4px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-07": {
    boxShadow: "0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12), 0px 8px 10px -5px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-elevation-08": {
    boxShadow: "0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 11px 15px -7px rgba(0, 0, 0, 0.2) !important"
  },
  ".gs-uitk-emphasis-color-bold-gray, .gs-uitk-emphasis-color-bold-default": {
    backgroundColor: "#5b7282",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-red": {
    backgroundColor: "#d91f11",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-orange": {
    backgroundColor: "#e86427",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-yellow": {
    backgroundColor: "#f5c518",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-bold-lime": {
    backgroundColor: "#3c7d0e",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-green": {
    backgroundColor: "#077d55",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-teal": {
    backgroundColor: "#167b7d",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-turquoise": {
    backgroundColor: "#067a91",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-aqua": {
    backgroundColor: "#08548a",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-blue": {
    backgroundColor: "#186ade",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-ultramarine": {
    backgroundColor: "#545fe8",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-purple": {
    backgroundColor: "#8f49de",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-bold-pink": {
    backgroundColor: "#cc1d92",
    color: "#ffffff"
  },
  ".gs-uitk-emphasis-color-subtle-gray, .gs-uitk-emphasis-color-subtle-default": {
    backgroundColor: "rgba(159, 177, 189, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-red": {
    backgroundColor: "rgba(252, 144, 134, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-orange": {
    backgroundColor: "rgba(252, 145, 98, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-yellow": {
    backgroundColor: "rgba(247, 227, 121, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-lime": {
    backgroundColor: "rgba(120, 191, 57, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-green": {
    backgroundColor: "rgba(67, 196, 120, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-teal": {
    backgroundColor: "rgba(78, 191, 185, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-turquoise": {
    backgroundColor: "rgba(69, 188, 209, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-aqua": {
    backgroundColor: "rgba(72, 184, 240, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-blue": {
    backgroundColor: "rgba(117, 177, 255, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-ultramarine": {
    backgroundColor: "rgba(160, 167, 250, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-purple": {
    backgroundColor: "rgba(200, 154, 252, 0.3)",
    color: "#0e171f"
  },
  ".gs-uitk-emphasis-color-subtle-pink": {
    backgroundColor: "rgba(250, 135, 212, 0.3)",
    color: "#0e171f"
  },
  "@font-face": {
    fontFamily: '"Sabon"',
    src: 'url("https://cdn.gs.com/fonts/sabon/v1/sabon.woff2") format("woff2"), url("https://cdn.gs.com/fonts/sabon/v1/sabon.woff") format("woff")',
    fontWeight: 400,
    fontStyle: "normal"
  },
  body: {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  },
  ".display-1": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "78px",
    lineHeight: "104px",
    letterSpacing: "0.2px"
  },
  ".display-2": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "60px",
    lineHeight: "80px",
    letterSpacing: "0.2px"
  },
  ".display-3": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "0.2px"
  },
  ".display-4": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: ["48px", "38.4px"],
    lineHeight: "64px",
    letterSpacing: "0.2px"
  },
  "h1, .text-7, .h1": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "40px",
    lineHeight: "52px",
    letterSpacing: "0.2px",
    margin: "0.5rem 0 1rem"
  },
  "h2, .text-6, .h2": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.2px",
    margin: "1.25rem 0 0.75rem"
  },
  "h3, .text-5, .h3": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.2px",
    margin: "1.25rem 0 0.75rem"
  },
  "h4, .text-4, .h4": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "0.2px",
    margin: "1.25rem 0 0.75rem"
  },
  "h5, .text-3, .h5": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0",
    margin: "1.25rem 0 0.5rem"
  },
  "h6, .text-2, .h6": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0",
    margin: "1.25rem 0 0.25rem"
  },
  "p, .text-1": {
    margin: "0.375rem 0 0.75rem"
  },
  small: {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  "ul, ol": {
    listStyle: "none"
  },
  "ul.list-bulleted": {
    listStyle: "square"
  },
  "ol.list-numbered": {
    listStyle: "decimal"
  },
  ".gs-uitk-text-display-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "300 !important",
    fontSize: "78px !important",
    lineHeight: "104px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-display-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "78px",
    lineHeight: "104px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-display-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "300 !important",
    fontSize: "60px !important",
    lineHeight: "80px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-display-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "60px",
    lineHeight: "80px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-display-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "300 !important",
    fontSize: "48px !important",
    lineHeight: "64px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-display-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-heading-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "40px !important",
    lineHeight: "52px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-heading-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "40px",
    lineHeight: "52px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-heading-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "32px !important",
    lineHeight: "40px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-heading-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-heading-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "24px !important",
    lineHeight: "32px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-heading-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-heading-04": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "20px !important",
    lineHeight: "28px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-heading-04": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-heading-05": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-heading-05": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-heading-06": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "14px !important",
    lineHeight: "20px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-heading-06": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-heading-07": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "12px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-heading-07": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-body-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-body-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-body-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "14px !important",
    lineHeight: "20px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-body-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-body-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "12px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-body-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-body-04": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "11px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-body-04": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "11px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-body-05": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "10px !important",
    lineHeight: "12px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-body-05": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "10px",
    lineHeight: "12px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-ui-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "24px !important",
    lineHeight: "32px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-ui-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-ui-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "500 !important",
    fontSize: "11px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-ui-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "11px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-caption-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif !important',
    fontWeight: "400 !important",
    fontSize: "11px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-caption-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "11px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-code-01": {
    fontFamily: '"Roboto Mono", "Courier New", monospace !important',
    fontWeight: "400 !important",
    fontSize: "14px !important",
    lineHeight: "20px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-code-01": {
    fontFamily: '"Roboto Mono", "Courier New", monospace',
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-code-02": {
    fontFamily: '"Roboto Mono", "Courier New", monospace !important',
    fontWeight: "400 !important",
    fontSize: "12px !important",
    lineHeight: "16px !important",
    letterSpacing: "0 !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-code-02": {
    fontFamily: '"Roboto Mono", "Courier New", monospace',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-label-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-label-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-label-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".gs-uitk-text-display-01-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "78px !important",
    lineHeight: "104px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-display-01-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "78px",
    lineHeight: "104px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-display-02-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "60px !important",
    lineHeight: "80px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-display-02-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "60px",
    lineHeight: "80px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-display-03-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "48px !important",
    lineHeight: "64px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-display-03-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-heading-01-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "40px !important",
    lineHeight: "52px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-heading-01-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "40px",
    lineHeight: "52px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-heading-02-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "32px !important",
    lineHeight: "40px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-heading-02-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-heading-03-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "24px !important",
    lineHeight: "32px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-heading-03-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-heading-04-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "20px !important",
    lineHeight: "28px !important",
    letterSpacing: "0.2px !important"
  },
  ".type-system-demo .type-system-demo__text-placeholder-heading-04-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "0.2px"
  },
  ".gs-uitk-text-serif-display-01": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "78px !important",
    lineHeight: "104px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-display-02": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "60px !important",
    lineHeight: "80px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-display-03": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "48px !important",
    lineHeight: "64px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-heading-01": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "40px !important",
    lineHeight: "52px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-heading-02": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "32px !important",
    lineHeight: "40px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-heading-03": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "24px !important",
    lineHeight: "32px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-text-serif-heading-04": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif !important',
    fontWeight: "400 !important",
    fontSize: "20px !important",
    lineHeight: "28px !important",
    letterSpacing: "0.2px !important"
  },
  ".gs-uitk-m-0": {
    margin: "0 !important"
  },
  ".gs-uitk-mt-0, .gs-uitk-my-0": {
    marginTop: "0 !important"
  },
  ".gs-uitk-mr-0, .gs-uitk-mx-0": {
    marginRight: "0 !important"
  },
  ".gs-uitk-mb-0, .gs-uitk-my-0": {
    marginBottom: "0 !important"
  },
  ".gs-uitk-ml-0, .gs-uitk-mx-0": {
    marginLeft: "0 !important"
  },
  ".gs-uitk-m-1px": {
    margin: "1px !important"
  },
  ".gs-uitk-mt-1px, .gs-uitk-my-1px": {
    marginTop: "1px !important"
  },
  ".gs-uitk-mr-1px, .gs-uitk-mx-1px": {
    marginRight: "1px !important"
  },
  ".gs-uitk-mb-1px, .gs-uitk-my-1px": {
    marginBottom: "1px !important"
  },
  ".gs-uitk-ml-1px, .gs-uitk-mx-1px": {
    marginLeft: "1px !important"
  },
  ".gs-uitk-m-0_25": {
    margin: "0.125rem !important"
  },
  ".gs-uitk-mt-0_25, .gs-uitk-my-0_25": {
    marginTop: "0.125rem !important"
  },
  ".gs-uitk-mr-0_25, .gs-uitk-mx-0_25": {
    marginRight: "0.125rem !important"
  },
  ".gs-uitk-mb-0_25, .gs-uitk-my-0_25": {
    marginBottom: "0.125rem !important"
  },
  ".gs-uitk-ml-0_25, .gs-uitk-mx-0_25": {
    marginLeft: "0.125rem !important"
  },
  ".gs-uitk-m-0_5": {
    margin: "0.25rem !important"
  },
  ".gs-uitk-mt-0_5, .gs-uitk-my-0_5": {
    marginTop: "0.25rem !important"
  },
  ".gs-uitk-mr-0_5, .gs-uitk-mx-0_5": {
    marginRight: "0.25rem !important"
  },
  ".gs-uitk-mb-0_5, .gs-uitk-my-0_5": {
    marginBottom: "0.25rem !important"
  },
  ".gs-uitk-ml-0_5, .gs-uitk-mx-0_5": {
    marginLeft: "0.25rem !important"
  },
  ".gs-uitk-m-0_75": {
    margin: "0.375rem !important"
  },
  ".gs-uitk-mt-0_75, .gs-uitk-my-0_75": {
    marginTop: "0.375rem !important"
  },
  ".gs-uitk-mr-0_75, .gs-uitk-mx-0_75": {
    marginRight: "0.375rem !important"
  },
  ".gs-uitk-mb-0_75, .gs-uitk-my-0_75": {
    marginBottom: "0.375rem !important"
  },
  ".gs-uitk-ml-0_75, .gs-uitk-mx-0_75": {
    marginLeft: "0.375rem !important"
  },
  ".gs-uitk-m-1": {
    margin: "0.5rem !important"
  },
  ".gs-uitk-mt-1, .gs-uitk-my-1": {
    marginTop: "0.5rem !important"
  },
  ".gs-uitk-mr-1, .gs-uitk-mx-1": {
    marginRight: "0.5rem !important"
  },
  ".gs-uitk-mb-1, .gs-uitk-my-1": {
    marginBottom: "0.5rem !important"
  },
  ".gs-uitk-ml-1, .gs-uitk-mx-1": {
    marginLeft: "0.5rem !important"
  },
  ".gs-uitk-m-1_5": {
    margin: "0.75rem !important"
  },
  ".gs-uitk-mt-1_5, .gs-uitk-my-1_5": {
    marginTop: "0.75rem !important"
  },
  ".gs-uitk-mr-1_5, .gs-uitk-mx-1_5": {
    marginRight: "0.75rem !important"
  },
  ".gs-uitk-mb-1_5, .gs-uitk-my-1_5": {
    marginBottom: "0.75rem !important"
  },
  ".gs-uitk-ml-1_5, .gs-uitk-mx-1_5": {
    marginLeft: "0.75rem !important"
  },
  ".gs-uitk-m-2": {
    margin: "1rem !important"
  },
  ".gs-uitk-mt-2, .gs-uitk-my-2": {
    marginTop: "1rem !important"
  },
  ".gs-uitk-mr-2, .gs-uitk-mx-2": {
    marginRight: "1rem !important"
  },
  ".gs-uitk-mb-2, .gs-uitk-my-2": {
    marginBottom: "1rem !important"
  },
  ".gs-uitk-ml-2, .gs-uitk-mx-2": {
    marginLeft: "1rem !important"
  },
  ".gs-uitk-m-2_5": {
    margin: "1.25rem !important"
  },
  ".gs-uitk-mt-2_5, .gs-uitk-my-2_5": {
    marginTop: "1.25rem !important"
  },
  ".gs-uitk-mr-2_5, .gs-uitk-mx-2_5": {
    marginRight: "1.25rem !important"
  },
  ".gs-uitk-mb-2_5, .gs-uitk-my-2_5": {
    marginBottom: "1.25rem !important"
  },
  ".gs-uitk-ml-2_5, .gs-uitk-mx-2_5": {
    marginLeft: "1.25rem !important"
  },
  ".gs-uitk-m-3": {
    margin: "1.5rem !important"
  },
  ".gs-uitk-mt-3, .gs-uitk-my-3": {
    marginTop: "1.5rem !important"
  },
  ".gs-uitk-mr-3, .gs-uitk-mx-3": {
    marginRight: "1.5rem !important"
  },
  ".gs-uitk-mb-3, .gs-uitk-my-3": {
    marginBottom: "1.5rem !important"
  },
  ".gs-uitk-ml-3, .gs-uitk-mx-3": {
    marginLeft: "1.5rem !important"
  },
  ".gs-uitk-m-4": {
    margin: "2rem !important"
  },
  ".gs-uitk-mt-4, .gs-uitk-my-4": {
    marginTop: "2rem !important"
  },
  ".gs-uitk-mr-4, .gs-uitk-mx-4": {
    marginRight: "2rem !important"
  },
  ".gs-uitk-mb-4, .gs-uitk-my-4": {
    marginBottom: "2rem !important"
  },
  ".gs-uitk-ml-4, .gs-uitk-mx-4": {
    marginLeft: "2rem !important"
  },
  ".gs-uitk-m-5": {
    margin: "2.5rem !important"
  },
  ".gs-uitk-mt-5, .gs-uitk-my-5": {
    marginTop: "2.5rem !important"
  },
  ".gs-uitk-mr-5, .gs-uitk-mx-5": {
    marginRight: "2.5rem !important"
  },
  ".gs-uitk-mb-5, .gs-uitk-my-5": {
    marginBottom: "2.5rem !important"
  },
  ".gs-uitk-ml-5, .gs-uitk-mx-5": {
    marginLeft: "2.5rem !important"
  },
  ".gs-uitk-m-6": {
    margin: "3rem !important"
  },
  ".gs-uitk-mt-6, .gs-uitk-my-6": {
    marginTop: "3rem !important"
  },
  ".gs-uitk-mr-6, .gs-uitk-mx-6": {
    marginRight: "3rem !important"
  },
  ".gs-uitk-mb-6, .gs-uitk-my-6": {
    marginBottom: "3rem !important"
  },
  ".gs-uitk-ml-6, .gs-uitk-mx-6": {
    marginLeft: "3rem !important"
  },
  ".gs-uitk-m-7": {
    margin: "3.5rem !important"
  },
  ".gs-uitk-mt-7, .gs-uitk-my-7": {
    marginTop: "3.5rem !important"
  },
  ".gs-uitk-mr-7, .gs-uitk-mx-7": {
    marginRight: "3.5rem !important"
  },
  ".gs-uitk-mb-7, .gs-uitk-my-7": {
    marginBottom: "3.5rem !important"
  },
  ".gs-uitk-ml-7, .gs-uitk-mx-7": {
    marginLeft: "3.5rem !important"
  },
  ".gs-uitk-m-8": {
    margin: "4rem !important"
  },
  ".gs-uitk-mt-8, .gs-uitk-my-8": {
    marginTop: "4rem !important"
  },
  ".gs-uitk-mr-8, .gs-uitk-mx-8": {
    marginRight: "4rem !important"
  },
  ".gs-uitk-mb-8, .gs-uitk-my-8": {
    marginBottom: "4rem !important"
  },
  ".gs-uitk-ml-8, .gs-uitk-mx-8": {
    marginLeft: "4rem !important"
  },
  ".gs-uitk-m-9": {
    margin: "4.5rem !important"
  },
  ".gs-uitk-mt-9, .gs-uitk-my-9": {
    marginTop: "4.5rem !important"
  },
  ".gs-uitk-mr-9, .gs-uitk-mx-9": {
    marginRight: "4.5rem !important"
  },
  ".gs-uitk-mb-9, .gs-uitk-my-9": {
    marginBottom: "4.5rem !important"
  },
  ".gs-uitk-ml-9, .gs-uitk-mx-9": {
    marginLeft: "4.5rem !important"
  },
  ".gs-uitk-m-10": {
    margin: "5rem !important"
  },
  ".gs-uitk-mt-10, .gs-uitk-my-10": {
    marginTop: "5rem !important"
  },
  ".gs-uitk-mr-10, .gs-uitk-mx-10": {
    marginRight: "5rem !important"
  },
  ".gs-uitk-mb-10, .gs-uitk-my-10": {
    marginBottom: "5rem !important"
  },
  ".gs-uitk-ml-10, .gs-uitk-mx-10": {
    marginLeft: "5rem !important"
  },
  ".gs-uitk-p-0": {
    padding: "0 !important"
  },
  ".gs-uitk-pt-0, .gs-uitk-py-0": {
    paddingTop: "0 !important"
  },
  ".gs-uitk-pr-0, .gs-uitk-px-0": {
    paddingRight: "0 !important"
  },
  ".gs-uitk-pb-0, .gs-uitk-py-0": {
    paddingBottom: "0 !important"
  },
  ".gs-uitk-pl-0, .gs-uitk-px-0": {
    paddingLeft: "0 !important"
  },
  ".gs-uitk-p-1px": {
    padding: "1px !important"
  },
  ".gs-uitk-pt-1px, .gs-uitk-py-1px": {
    paddingTop: "1px !important"
  },
  ".gs-uitk-pr-1px, .gs-uitk-px-1px": {
    paddingRight: "1px !important"
  },
  ".gs-uitk-pb-1px, .gs-uitk-py-1px": {
    paddingBottom: "1px !important"
  },
  ".gs-uitk-pl-1px, .gs-uitk-px-1px": {
    paddingLeft: "1px !important"
  },
  ".gs-uitk-p-0_25": {
    padding: "0.125rem !important"
  },
  ".gs-uitk-pt-0_25, .gs-uitk-py-0_25": {
    paddingTop: "0.125rem !important"
  },
  ".gs-uitk-pr-0_25, .gs-uitk-px-0_25": {
    paddingRight: "0.125rem !important"
  },
  ".gs-uitk-pb-0_25, .gs-uitk-py-0_25": {
    paddingBottom: "0.125rem !important"
  },
  ".gs-uitk-pl-0_25, .gs-uitk-px-0_25": {
    paddingLeft: "0.125rem !important"
  },
  ".gs-uitk-p-0_5": {
    padding: "0.25rem !important"
  },
  ".gs-uitk-pt-0_5, .gs-uitk-py-0_5": {
    paddingTop: "0.25rem !important"
  },
  ".gs-uitk-pr-0_5, .gs-uitk-px-0_5": {
    paddingRight: "0.25rem !important"
  },
  ".gs-uitk-pb-0_5, .gs-uitk-py-0_5": {
    paddingBottom: "0.25rem !important"
  },
  ".gs-uitk-pl-0_5, .gs-uitk-px-0_5": {
    paddingLeft: "0.25rem !important"
  },
  ".gs-uitk-p-0_75": {
    padding: "0.375rem !important"
  },
  ".gs-uitk-pt-0_75, .gs-uitk-py-0_75": {
    paddingTop: "0.375rem !important"
  },
  ".gs-uitk-pr-0_75, .gs-uitk-px-0_75": {
    paddingRight: "0.375rem !important"
  },
  ".gs-uitk-pb-0_75, .gs-uitk-py-0_75": {
    paddingBottom: "0.375rem !important"
  },
  ".gs-uitk-pl-0_75, .gs-uitk-px-0_75": {
    paddingLeft: "0.375rem !important"
  },
  ".gs-uitk-p-1": {
    padding: "0.5rem !important"
  },
  ".gs-uitk-pt-1, .gs-uitk-py-1": {
    paddingTop: "0.5rem !important"
  },
  ".gs-uitk-pr-1, .gs-uitk-px-1": {
    paddingRight: "0.5rem !important"
  },
  ".gs-uitk-pb-1, .gs-uitk-py-1": {
    paddingBottom: "0.5rem !important"
  },
  ".gs-uitk-pl-1, .gs-uitk-px-1": {
    paddingLeft: "0.5rem !important"
  },
  ".gs-uitk-p-1_5": {
    padding: "0.75rem !important"
  },
  ".gs-uitk-pt-1_5, .gs-uitk-py-1_5": {
    paddingTop: "0.75rem !important"
  },
  ".gs-uitk-pr-1_5, .gs-uitk-px-1_5": {
    paddingRight: "0.75rem !important"
  },
  ".gs-uitk-pb-1_5, .gs-uitk-py-1_5": {
    paddingBottom: "0.75rem !important"
  },
  ".gs-uitk-pl-1_5, .gs-uitk-px-1_5": {
    paddingLeft: "0.75rem !important"
  },
  ".gs-uitk-p-2": {
    padding: "1rem !important"
  },
  ".gs-uitk-pt-2, .gs-uitk-py-2": {
    paddingTop: "1rem !important"
  },
  ".gs-uitk-pr-2, .gs-uitk-px-2": {
    paddingRight: "1rem !important"
  },
  ".gs-uitk-pb-2, .gs-uitk-py-2": {
    paddingBottom: "1rem !important"
  },
  ".gs-uitk-pl-2, .gs-uitk-px-2": {
    paddingLeft: "1rem !important"
  },
  ".gs-uitk-p-2_5": {
    padding: "1.25rem !important"
  },
  ".gs-uitk-pt-2_5, .gs-uitk-py-2_5": {
    paddingTop: "1.25rem !important"
  },
  ".gs-uitk-pr-2_5, .gs-uitk-px-2_5": {
    paddingRight: "1.25rem !important"
  },
  ".gs-uitk-pb-2_5, .gs-uitk-py-2_5": {
    paddingBottom: "1.25rem !important"
  },
  ".gs-uitk-pl-2_5, .gs-uitk-px-2_5": {
    paddingLeft: "1.25rem !important"
  },
  ".gs-uitk-p-3": {
    padding: "1.5rem !important"
  },
  ".gs-uitk-pt-3, .gs-uitk-py-3": {
    paddingTop: "1.5rem !important"
  },
  ".gs-uitk-pr-3, .gs-uitk-px-3": {
    paddingRight: "1.5rem !important"
  },
  ".gs-uitk-pb-3, .gs-uitk-py-3": {
    paddingBottom: "1.5rem !important"
  },
  ".gs-uitk-pl-3, .gs-uitk-px-3": {
    paddingLeft: "1.5rem !important"
  },
  ".gs-uitk-p-4": {
    padding: "2rem !important"
  },
  ".gs-uitk-pt-4, .gs-uitk-py-4": {
    paddingTop: "2rem !important"
  },
  ".gs-uitk-pr-4, .gs-uitk-px-4": {
    paddingRight: "2rem !important"
  },
  ".gs-uitk-pb-4, .gs-uitk-py-4": {
    paddingBottom: "2rem !important"
  },
  ".gs-uitk-pl-4, .gs-uitk-px-4": {
    paddingLeft: "2rem !important"
  },
  ".gs-uitk-p-5": {
    padding: "2.5rem !important"
  },
  ".gs-uitk-pt-5, .gs-uitk-py-5": {
    paddingTop: "2.5rem !important"
  },
  ".gs-uitk-pr-5, .gs-uitk-px-5": {
    paddingRight: "2.5rem !important"
  },
  ".gs-uitk-pb-5, .gs-uitk-py-5": {
    paddingBottom: "2.5rem !important"
  },
  ".gs-uitk-pl-5, .gs-uitk-px-5": {
    paddingLeft: "2.5rem !important"
  },
  ".gs-uitk-p-6": {
    padding: "3rem !important"
  },
  ".gs-uitk-pt-6, .gs-uitk-py-6": {
    paddingTop: "3rem !important"
  },
  ".gs-uitk-pr-6, .gs-uitk-px-6": {
    paddingRight: "3rem !important"
  },
  ".gs-uitk-pb-6, .gs-uitk-py-6": {
    paddingBottom: "3rem !important"
  },
  ".gs-uitk-pl-6, .gs-uitk-px-6": {
    paddingLeft: "3rem !important"
  },
  ".gs-uitk-p-7": {
    padding: "3.5rem !important"
  },
  ".gs-uitk-pt-7, .gs-uitk-py-7": {
    paddingTop: "3.5rem !important"
  },
  ".gs-uitk-pr-7, .gs-uitk-px-7": {
    paddingRight: "3.5rem !important"
  },
  ".gs-uitk-pb-7, .gs-uitk-py-7": {
    paddingBottom: "3.5rem !important"
  },
  ".gs-uitk-pl-7, .gs-uitk-px-7": {
    paddingLeft: "3.5rem !important"
  },
  ".gs-uitk-p-8": {
    padding: "4rem !important"
  },
  ".gs-uitk-pt-8, .gs-uitk-py-8": {
    paddingTop: "4rem !important"
  },
  ".gs-uitk-pr-8, .gs-uitk-px-8": {
    paddingRight: "4rem !important"
  },
  ".gs-uitk-pb-8, .gs-uitk-py-8": {
    paddingBottom: "4rem !important"
  },
  ".gs-uitk-pl-8, .gs-uitk-px-8": {
    paddingLeft: "4rem !important"
  },
  ".gs-uitk-p-9": {
    padding: "4.5rem !important"
  },
  ".gs-uitk-pt-9, .gs-uitk-py-9": {
    paddingTop: "4.5rem !important"
  },
  ".gs-uitk-pr-9, .gs-uitk-px-9": {
    paddingRight: "4.5rem !important"
  },
  ".gs-uitk-pb-9, .gs-uitk-py-9": {
    paddingBottom: "4.5rem !important"
  },
  ".gs-uitk-pl-9, .gs-uitk-px-9": {
    paddingLeft: "4.5rem !important"
  },
  ".gs-uitk-p-10": {
    padding: "5rem !important"
  },
  ".gs-uitk-pt-10, .gs-uitk-py-10": {
    paddingTop: "5rem !important"
  },
  ".gs-uitk-pr-10, .gs-uitk-px-10": {
    paddingRight: "5rem !important"
  },
  ".gs-uitk-pb-10, .gs-uitk-py-10": {
    paddingBottom: "5rem !important"
  },
  ".gs-uitk-pl-10, .gs-uitk-px-10": {
    paddingLeft: "5rem !important"
  },
  ".gs-uitk-h-0": {
    height: "0 !important"
  },
  ".gs-uitk-w-0": {
    width: "0 !important"
  },
  ".gs-uitk-m-n0": {
    margin: "0 !important"
  },
  ".gs-uitk-mt-n0, .gs-uitk-my-n0": {
    marginTop: "0 !important"
  },
  ".gs-uitk-mr-n0, .gs-uitk-mx-n0": {
    marginRight: "0 !important"
  },
  ".gs-uitk-mb-n0, .gs-uitk-my-n0": {
    marginBottom: "0 !important"
  },
  ".gs-uitk-ml-n0, .gs-uitk-mx-n0": {
    marginLeft: "0 !important"
  },
  ".gs-uitk-h-1px": {
    height: "1px !important"
  },
  ".gs-uitk-w-1px": {
    width: "1px !important"
  },
  ".gs-uitk-m-n1px": {
    margin: "-1px !important"
  },
  ".gs-uitk-mt-n1px, .gs-uitk-my-n1px": {
    marginTop: "-1px !important"
  },
  ".gs-uitk-mr-n1px, .gs-uitk-mx-n1px": {
    marginRight: "-1px !important"
  },
  ".gs-uitk-mb-n1px, .gs-uitk-my-n1px": {
    marginBottom: "-1px !important"
  },
  ".gs-uitk-ml-n1px, .gs-uitk-mx-n1px": {
    marginLeft: "-1px !important"
  },
  ".gs-uitk-h-0_25": {
    height: "0.125rem !important"
  },
  ".gs-uitk-w-0_25": {
    width: "0.125rem !important"
  },
  ".gs-uitk-m-n0_25": {
    margin: "-0.125rem !important"
  },
  ".gs-uitk-mt-n0_25, .gs-uitk-my-n0_25": {
    marginTop: "-0.125rem !important"
  },
  ".gs-uitk-mr-n0_25, .gs-uitk-mx-n0_25": {
    marginRight: "-0.125rem !important"
  },
  ".gs-uitk-mb-n0_25, .gs-uitk-my-n0_25": {
    marginBottom: "-0.125rem !important"
  },
  ".gs-uitk-ml-n0_25, .gs-uitk-mx-n0_25": {
    marginLeft: "-0.125rem !important"
  },
  ".gs-uitk-h-0_5": {
    height: "0.25rem !important"
  },
  ".gs-uitk-w-0_5": {
    width: "0.25rem !important"
  },
  ".gs-uitk-m-n0_5": {
    margin: "-0.25rem !important"
  },
  ".gs-uitk-mt-n0_5, .gs-uitk-my-n0_5": {
    marginTop: "-0.25rem !important"
  },
  ".gs-uitk-mr-n0_5, .gs-uitk-mx-n0_5": {
    marginRight: "-0.25rem !important"
  },
  ".gs-uitk-mb-n0_5, .gs-uitk-my-n0_5": {
    marginBottom: "-0.25rem !important"
  },
  ".gs-uitk-ml-n0_5, .gs-uitk-mx-n0_5": {
    marginLeft: "-0.25rem !important"
  },
  ".gs-uitk-h-0_75": {
    height: "0.375rem !important"
  },
  ".gs-uitk-w-0_75": {
    width: "0.375rem !important"
  },
  ".gs-uitk-m-n0_75": {
    margin: "-0.375rem !important"
  },
  ".gs-uitk-mt-n0_75, .gs-uitk-my-n0_75": {
    marginTop: "-0.375rem !important"
  },
  ".gs-uitk-mr-n0_75, .gs-uitk-mx-n0_75": {
    marginRight: "-0.375rem !important"
  },
  ".gs-uitk-mb-n0_75, .gs-uitk-my-n0_75": {
    marginBottom: "-0.375rem !important"
  },
  ".gs-uitk-ml-n0_75, .gs-uitk-mx-n0_75": {
    marginLeft: "-0.375rem !important"
  },
  ".gs-uitk-h-1": {
    height: "0.5rem !important"
  },
  ".gs-uitk-w-1": {
    width: "0.5rem !important"
  },
  ".gs-uitk-m-n1": {
    margin: "-0.5rem !important"
  },
  ".gs-uitk-mt-n1, .gs-uitk-my-n1": {
    marginTop: "-0.5rem !important"
  },
  ".gs-uitk-mr-n1, .gs-uitk-mx-n1": {
    marginRight: "-0.5rem !important"
  },
  ".gs-uitk-mb-n1, .gs-uitk-my-n1": {
    marginBottom: "-0.5rem !important"
  },
  ".gs-uitk-ml-n1, .gs-uitk-mx-n1": {
    marginLeft: "-0.5rem !important"
  },
  ".gs-uitk-h-1_5": {
    height: "0.75rem !important"
  },
  ".gs-uitk-w-1_5": {
    width: "0.75rem !important"
  },
  ".gs-uitk-m-n1_5": {
    margin: "-0.75rem !important"
  },
  ".gs-uitk-mt-n1_5, .gs-uitk-my-n1_5": {
    marginTop: "-0.75rem !important"
  },
  ".gs-uitk-mr-n1_5, .gs-uitk-mx-n1_5": {
    marginRight: "-0.75rem !important"
  },
  ".gs-uitk-mb-n1_5, .gs-uitk-my-n1_5": {
    marginBottom: "-0.75rem !important"
  },
  ".gs-uitk-ml-n1_5, .gs-uitk-mx-n1_5": {
    marginLeft: "-0.75rem !important"
  },
  ".gs-uitk-h-2": {
    height: "1rem !important"
  },
  ".gs-uitk-w-2": {
    width: "1rem !important"
  },
  ".gs-uitk-m-n2": {
    margin: "-1rem !important"
  },
  ".gs-uitk-mt-n2, .gs-uitk-my-n2": {
    marginTop: "-1rem !important"
  },
  ".gs-uitk-mr-n2, .gs-uitk-mx-n2": {
    marginRight: "-1rem !important"
  },
  ".gs-uitk-mb-n2, .gs-uitk-my-n2": {
    marginBottom: "-1rem !important"
  },
  ".gs-uitk-ml-n2, .gs-uitk-mx-n2": {
    marginLeft: "-1rem !important"
  },
  ".gs-uitk-h-2_5": {
    height: "1.25rem !important"
  },
  ".gs-uitk-w-2_5": {
    width: "1.25rem !important"
  },
  ".gs-uitk-m-n2_5": {
    margin: "-1.25rem !important"
  },
  ".gs-uitk-mt-n2_5, .gs-uitk-my-n2_5": {
    marginTop: "-1.25rem !important"
  },
  ".gs-uitk-mr-n2_5, .gs-uitk-mx-n2_5": {
    marginRight: "-1.25rem !important"
  },
  ".gs-uitk-mb-n2_5, .gs-uitk-my-n2_5": {
    marginBottom: "-1.25rem !important"
  },
  ".gs-uitk-ml-n2_5, .gs-uitk-mx-n2_5": {
    marginLeft: "-1.25rem !important"
  },
  ".gs-uitk-h-3": {
    height: "1.5rem !important"
  },
  ".gs-uitk-w-3": {
    width: "1.5rem !important"
  },
  ".gs-uitk-m-n3": {
    margin: "-1.5rem !important"
  },
  ".gs-uitk-mt-n3, .gs-uitk-my-n3": {
    marginTop: "-1.5rem !important"
  },
  ".gs-uitk-mr-n3, .gs-uitk-mx-n3": {
    marginRight: "-1.5rem !important"
  },
  ".gs-uitk-mb-n3, .gs-uitk-my-n3": {
    marginBottom: "-1.5rem !important"
  },
  ".gs-uitk-ml-n3, .gs-uitk-mx-n3": {
    marginLeft: "-1.5rem !important"
  },
  ".gs-uitk-h-4": {
    height: "2rem !important"
  },
  ".gs-uitk-w-4": {
    width: "2rem !important"
  },
  ".gs-uitk-m-n4": {
    margin: "-2rem !important"
  },
  ".gs-uitk-mt-n4, .gs-uitk-my-n4": {
    marginTop: "-2rem !important"
  },
  ".gs-uitk-mr-n4, .gs-uitk-mx-n4": {
    marginRight: "-2rem !important"
  },
  ".gs-uitk-mb-n4, .gs-uitk-my-n4": {
    marginBottom: "-2rem !important"
  },
  ".gs-uitk-ml-n4, .gs-uitk-mx-n4": {
    marginLeft: "-2rem !important"
  },
  ".gs-uitk-h-5": {
    height: "2.5rem !important"
  },
  ".gs-uitk-w-5": {
    width: "2.5rem !important"
  },
  ".gs-uitk-m-n5": {
    margin: "-2.5rem !important"
  },
  ".gs-uitk-mt-n5, .gs-uitk-my-n5": {
    marginTop: "-2.5rem !important"
  },
  ".gs-uitk-mr-n5, .gs-uitk-mx-n5": {
    marginRight: "-2.5rem !important"
  },
  ".gs-uitk-mb-n5, .gs-uitk-my-n5": {
    marginBottom: "-2.5rem !important"
  },
  ".gs-uitk-ml-n5, .gs-uitk-mx-n5": {
    marginLeft: "-2.5rem !important"
  },
  ".gs-uitk-h-6": {
    height: "3rem !important"
  },
  ".gs-uitk-w-6": {
    width: "3rem !important"
  },
  ".gs-uitk-m-n6": {
    margin: "-3rem !important"
  },
  ".gs-uitk-mt-n6, .gs-uitk-my-n6": {
    marginTop: "-3rem !important"
  },
  ".gs-uitk-mr-n6, .gs-uitk-mx-n6": {
    marginRight: "-3rem !important"
  },
  ".gs-uitk-mb-n6, .gs-uitk-my-n6": {
    marginBottom: "-3rem !important"
  },
  ".gs-uitk-ml-n6, .gs-uitk-mx-n6": {
    marginLeft: "-3rem !important"
  },
  ".gs-uitk-h-7": {
    height: "3.5rem !important"
  },
  ".gs-uitk-w-7": {
    width: "3.5rem !important"
  },
  ".gs-uitk-m-n7": {
    margin: "-3.5rem !important"
  },
  ".gs-uitk-mt-n7, .gs-uitk-my-n7": {
    marginTop: "-3.5rem !important"
  },
  ".gs-uitk-mr-n7, .gs-uitk-mx-n7": {
    marginRight: "-3.5rem !important"
  },
  ".gs-uitk-mb-n7, .gs-uitk-my-n7": {
    marginBottom: "-3.5rem !important"
  },
  ".gs-uitk-ml-n7, .gs-uitk-mx-n7": {
    marginLeft: "-3.5rem !important"
  },
  ".gs-uitk-h-8": {
    height: "4rem !important"
  },
  ".gs-uitk-w-8": {
    width: "4rem !important"
  },
  ".gs-uitk-m-n8": {
    margin: "-4rem !important"
  },
  ".gs-uitk-mt-n8, .gs-uitk-my-n8": {
    marginTop: "-4rem !important"
  },
  ".gs-uitk-mr-n8, .gs-uitk-mx-n8": {
    marginRight: "-4rem !important"
  },
  ".gs-uitk-mb-n8, .gs-uitk-my-n8": {
    marginBottom: "-4rem !important"
  },
  ".gs-uitk-ml-n8, .gs-uitk-mx-n8": {
    marginLeft: "-4rem !important"
  },
  ".gs-uitk-h-9": {
    height: "4.5rem !important"
  },
  ".gs-uitk-w-9": {
    width: "4.5rem !important"
  },
  ".gs-uitk-m-n9": {
    margin: "-4.5rem !important"
  },
  ".gs-uitk-mt-n9, .gs-uitk-my-n9": {
    marginTop: "-4.5rem !important"
  },
  ".gs-uitk-mr-n9, .gs-uitk-mx-n9": {
    marginRight: "-4.5rem !important"
  },
  ".gs-uitk-mb-n9, .gs-uitk-my-n9": {
    marginBottom: "-4.5rem !important"
  },
  ".gs-uitk-ml-n9, .gs-uitk-mx-n9": {
    marginLeft: "-4.5rem !important"
  },
  ".gs-uitk-h-10": {
    height: "5rem !important"
  },
  ".gs-uitk-w-10": {
    width: "5rem !important"
  },
  ".gs-uitk-m-n10": {
    margin: "-5rem !important"
  },
  ".gs-uitk-mt-n10, .gs-uitk-my-n10": {
    marginTop: "-5rem !important"
  },
  ".gs-uitk-mr-n10, .gs-uitk-mx-n10": {
    marginRight: "-5rem !important"
  },
  ".gs-uitk-mb-n10, .gs-uitk-my-n10": {
    marginBottom: "-5rem !important"
  },
  ".gs-uitk-ml-n10, .gs-uitk-mx-n10": {
    marginLeft: "-5rem !important"
  },
  ".gs-uitk-shadow-100": {
    boxShadow: "0 0 1px 0 rgba(0, 0, 0, 0.1), 0 2px 4px 0 rgba(0, 0, 0, 0.1) !important"
  },
  ".gs-uitk-shadow-200": {
    boxShadow: "0 8px 12px 0 rgba(0, 0, 0, 0.06), 0 2px 4px 0 rgba(0, 0, 0, 0.06) !important"
  },
  ".gs-uitk-shadow-300": {
    boxShadow: "0 10px 32px 0 rgba(0, 0, 0, 0.08), 0 3px 8px 0 rgba(0, 0, 0, 0.12) !important"
  },
  ".gs-uitk-shadow-400": {
    boxShadow: "0 24px 32px 0 rgba(0, 0, 0, 0.12), 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1) !important"
  },
  ".gs-uitk-shadow-side-right": {
    boxShadow: "3px 0 15px 0 rgba(0, 0, 0, 0.12), 2px 0 3px 0 rgba(0, 0, 0, 0.15) !important"
  },
  ".gs-uitk-shadow-side-left": {
    boxShadow: "-3px 0 15px 0 rgba(0, 0, 0, 0.12), -2px 0 3px 0 rgba(0, 0, 0, 0.15) !important"
  },
  ".dataviz-purple-10": {
    background: "#F3E5F5",
    color: "#000000"
  },
  ".dataviz-purple-20": {
    background: "#E1BEE7",
    color: "#000000"
  },
  ".dataviz-purple-30": {
    background: "#CE93D8",
    color: "#000000"
  },
  ".dataviz-purple-40": {
    background: "#BA68C8",
    color: "#000000"
  },
  ".dataviz-purple-50": {
    background: "#AB47BC",
    color: "#ffffff"
  },
  ".dataviz-purple-60": {
    background: "#9C27B0",
    color: "#ffffff"
  },
  ".dataviz-purple-70": {
    background: "#8E24AA",
    color: "#ffffff"
  },
  ".dataviz-purple-80": {
    background: "#7B1FA2",
    color: "#ffffff"
  },
  ".dataviz-purple-90": {
    background: "#6a1b9a",
    color: "#ffffff"
  },
  ".dataviz-purple-100": {
    background: "#4A148C",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-10": {
    background: "#E7EAF4",
    color: "#000000"
  },
  ".dataviz-darker-blue-20": {
    background: "#C2C9E5",
    color: "#000000"
  },
  ".dataviz-darker-blue-30": {
    background: "#9BA6D3",
    color: "#000000"
  },
  ".dataviz-darker-blue-40": {
    background: "#7484C2",
    color: "#000000"
  },
  ".dataviz-darker-blue-50": {
    background: "#5569B5",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-60": {
    background: "#364FA9",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-70": {
    background: "#2F48A0",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-80": {
    background: "#263E94",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-90": {
    background: "#1E3488",
    color: "#ffffff"
  },
  ".dataviz-darker-blue-100": {
    background: "#0F2372",
    color: "#ffffff"
  },
  ".dataviz-dark-blue-10": {
    background: "#E3F2FC",
    color: "#000000"
  },
  ".dataviz-dark-blue-20": {
    background: "#BADFF9",
    color: "#000000"
  },
  ".dataviz-dark-blue-30": {
    background: "#8FCBF6",
    color: "#000000"
  },
  ".dataviz-dark-blue-40": {
    background: "#63B6F3",
    color: "#000000"
  },
  ".dataviz-dark-blue-50": {
    background: "#3FA6F1",
    color: "#000000"
  },
  ".dataviz-dark-blue-60": {
    background: "#1898EF",
    color: "#000000"
  },
  ".dataviz-dark-blue-70": {
    background: "#118AE1",
    color: "#000000"
  },
  ".dataviz-dark-blue-80": {
    background: "#0778CF",
    color: "#ffffff"
  },
  ".dataviz-dark-blue-90": {
    background: "#0067BD",
    color: "#ffffff"
  },
  ".dataviz-dark-blue-100": {
    background: "#00499E",
    color: "#ffffff"
  },
  ".dataviz-blue-10": {
    background: "#E2F1FF",
    color: "#000000"
  },
  ".dataviz-blue-20": {
    background: "#B9DCFF",
    color: "#000000"
  },
  ".dataviz-blue-30": {
    background: "#8AC7FF",
    color: "#000000"
  },
  ".dataviz-blue-40": {
    background: "#54B1FF",
    color: "#000000"
  },
  ".dataviz-blue-50": {
    background: "#21A0FF",
    color: "#000000"
  },
  ".dataviz-blue-60": {
    background: "#008FFF",
    color: "#000000"
  },
  ".dataviz-blue-70": {
    background: "#0080FF",
    color: "#000000"
  },
  ".dataviz-blue-80": {
    background: "#0F6DEE",
    color: "#ffffff"
  },
  ".dataviz-blue-90": {
    background: "#195BDB",
    color: "#ffffff"
  },
  ".dataviz-blue-100": {
    background: "#2239BC",
    color: "#ffffff"
  },
  ".dataviz-teal-10": {
    background: "#E0F2F1",
    color: "#000000"
  },
  ".dataviz-teal-20": {
    background: "#B2DFDB",
    color: "#000000"
  },
  ".dataviz-teal-30": {
    background: "#80CBC4",
    color: "#000000"
  },
  ".dataviz-teal-40": {
    background: "#4DB6AC",
    color: "#000000"
  },
  ".dataviz-teal-50": {
    background: "#26A69A",
    color: "#000000"
  },
  ".dataviz-teal-60": {
    background: "#009688",
    color: "#000000"
  },
  ".dataviz-teal-70": {
    background: "#00897B",
    color: "#000000"
  },
  ".dataviz-teal-80": {
    background: "#00796B",
    color: "#ffffff"
  },
  ".dataviz-teal-90": {
    background: "#00695C",
    color: "#ffffff"
  },
  ".dataviz-teal-100": {
    background: "#004D40",
    color: "#ffffff"
  },
  ".dataviz-green-10": {
    background: "#E6F7ED",
    color: "#000000"
  },
  ".dataviz-green-20": {
    background: "#C3EAD3",
    color: "#000000"
  },
  ".dataviz-green-30": {
    background: "#9CDDB8",
    color: "#000000"
  },
  ".dataviz-green-40": {
    background: "#70D19C",
    color: "#000000"
  },
  ".dataviz-green-50": {
    background: "#4CC686",
    color: "#000000"
  },
  ".dataviz-green-60": {
    background: "#1ABB71",
    color: "#000000"
  },
  ".dataviz-green-70": {
    background: "#10AC66",
    color: "#000000"
  },
  ".dataviz-green-80": {
    background: "#009959",
    color: "#000000"
  },
  ".dataviz-green-90": {
    background: "#00884D",
    color: "#ffffff"
  },
  ".dataviz-green-100": {
    background: "#006838",
    color: "#ffffff"
  },
  ".dataviz-red-10": {
    background: "#FFECEF",
    color: "#000000"
  },
  ".dataviz-red-20": {
    background: "#FFCFD4",
    color: "#000000"
  },
  ".dataviz-red-30": {
    background: "#F29E9E",
    color: "#000000"
  },
  ".dataviz-red-40": {
    background: "#E97878",
    color: "#000000"
  },
  ".dataviz-red-50": {
    background: "#F45A56",
    color: "#000000"
  },
  ".dataviz-red-60": {
    background: "#F94B3C",
    color: "#000000"
  },
  ".dataviz-red-70": {
    background: "#EB423C",
    color: "#000000"
  },
  ".dataviz-red-80": {
    background: "#D93836",
    color: "#ffffff"
  },
  ".dataviz-red-90": {
    background: "#CC322F",
    color: "#ffffff"
  },
  ".dataviz-red-100": {
    background: "#BC2723",
    color: "#ffffff"
  },
  ".dataviz-orange-10": {
    background: "#FFF8E1",
    color: "#000000"
  },
  ".dataviz-orange-20": {
    background: "#FFECB3",
    color: "#000000"
  },
  ".dataviz-orange-30": {
    background: "#FFE082",
    color: "#000000"
  },
  ".dataviz-orange-40": {
    background: "#FFD54F",
    color: "#000000"
  },
  ".dataviz-orange-50": {
    background: "#FFCA28",
    color: "#000000"
  },
  ".dataviz-orange-60": {
    background: "#FFC107",
    color: "#000000"
  },
  ".dataviz-orange-70": {
    background: "#FFB300",
    color: "#000000"
  },
  ".dataviz-orange-80": {
    background: "#FFA000",
    color: "#000000"
  },
  ".dataviz-orange-90": {
    background: "#FF8F00",
    color: "#000000"
  },
  ".dataviz-orange-100": {
    background: "#FF6F00",
    color: "#000000"
  },
  ".dataviz-light-orange-10": {
    background: "#FFF8E2",
    color: "#000000"
  },
  ".dataviz-light-orange-20": {
    background: "#FFECB4",
    color: "#000000"
  },
  ".dataviz-light-orange-30": {
    background: "#FFE084",
    color: "#000000"
  },
  ".dataviz-light-orange-40": {
    background: "#FFD653",
    color: "#000000"
  },
  ".dataviz-light-orange-50": {
    background: "#FFCB30",
    color: "#000000"
  },
  ".dataviz-light-orange-60": {
    background: "#FFC219",
    color: "#000000"
  },
  ".dataviz-light-orange-70": {
    background: "#FFB413",
    color: "#000000"
  },
  ".dataviz-light-orange-80": {
    background: "#FEA111",
    color: "#000000"
  },
  ".dataviz-light-orange-90": {
    background: "#FE9110",
    color: "#000000"
  },
  ".dataviz-light-orange-100": {
    background: "#FE710D",
    color: "#000000"
  },
  ".dataviz-yellow-10": {
    background: "#FFFDE7",
    color: "#000000"
  },
  ".dataviz-yellow-20": {
    background: "#FFF9C4",
    color: "#000000"
  },
  ".dataviz-yellow-30": {
    background: "#FEF59D",
    color: "#000000"
  },
  ".dataviz-yellow-40": {
    background: "#FEF075",
    color: "#000000"
  },
  ".dataviz-yellow-50": {
    background: "#FBEB55",
    color: "#000000"
  },
  ".dataviz-yellow-60": {
    background: "#FEEB3B",
    color: "#000000"
  },
  ".dataviz-yellow-70": {
    background: "#FCD835",
    color: "#000000"
  },
  ".dataviz-yellow-80": {
    background: "#FAC02D",
    color: "#000000"
  },
  ".dataviz-yellow-90": {
    background: "#F8A824",
    color: "#000000"
  },
  ".dataviz-yellow-100": {
    background: "#F47F16",
    color: "#000000"
  },
  ".dataviz-pastel-10": {
    background: "#FFF8E1",
    color: "#000000"
  },
  ".dataviz-pastel-20": {
    background: "#F3E5F5",
    color: "#000000"
  },
  ".dataviz-pastel-30": {
    background: "#E0F2F1",
    color: "#000000"
  },
  ".dataviz-pastel-40": {
    background: "#FFFDE7",
    color: "#000000"
  },
  ".dataviz-pastel-50": {
    background: "#E7EAF4",
    color: "#000000"
  },
  ".dataviz-pastel-60": {
    background: "#FFF8E1",
    color: "#000000"
  },
  ".dataviz-pastel-70": {
    background: "#F3E5F5",
    color: "#000000"
  },
  ".dataviz-pastel-80": {
    background: "#E0F2F1",
    color: "#000000"
  },
  ".dataviz-pastel-90": {
    background: "#FFFDE7",
    color: "#000000"
  },
  ".dataviz-pastel-100": {
    background: "#E7EAF4",
    color: "#000000"
  },
  "@keyframes rotating": {
    from: {
      transform: "rotate(0deg)"
    },
    to: {
      transform: "rotate(360deg)"
    }
  },
  "@keyframes animation-fade": {
    "0%": {
      opacity: 0
    },
    "100%": {
      opacity: 1
    }
  },
  ".demo-fade": {
    opacity: 0,
    transition: "opacity 150ms linear"
  },
  ".demo-fade.active": {
    opacity: 1
  },
  "@keyframes animation-grow": {
    "0%": {
      opacity: 0,
      transform: "scale(0)"
    },
    "100%": {
      opacity: 1,
      transform: "scale(1)"
    }
  },
  ".demo-grow": {
    transform: "scale(0)",
    transition: "transform 300ms cubic-bezier(0.455, 0.03, 0.515, 0.955)"
  },
  ".demo-grow.active": {
    transform: "scale(1)"
  },
  "[data-placement^=top] .demo-fade-grow": {
    transformOrigin: "50% calc(100% + 1rem)"
  },
  "[data-placement^=bottom] .demo-fade-grow": {
    transformOrigin: "50% calc(0% - 1rem)"
  },
  "[data-placement^=left] .demo-fade-grow": {
    transformOrigin: "calc(100% + 1rem) 50%"
  },
  "[data-placement^=right] .demo-fade-grow": {
    transformOrigin: "calc(0% - 1rem) 50%"
  },
  "@keyframes animation-slide-left": {
    "0%": {
      opacity: 0,
      transform: "translateX(2rem)"
    },
    "75%": {
      opacity: 1
    },
    "100%": {
      transform: "translateX(0)"
    }
  },
  ".demo-slide-left": {
    opacity: 0,
    transform: "translateX(2rem)",
    transition: "opacity 150ms linear, transform 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53)"
  },
  ".demo-slide-left.active": {
    opacity: 1,
    transform: "translateX(0)",
    transition: "opacity 150ms linear, transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)"
  },
  "@keyframes animation-slide-right": {
    "0%": {
      opacity: 0,
      transform: "translateX(-2rem)"
    },
    "75%": {
      opacity: 1
    },
    "100%": {
      transform: "translateX(0)"
    }
  },
  ".demo-slide-right": {
    opacity: 0,
    transform: "translateX(-2rem)",
    transition: "opacity 150ms linear, transform 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53)"
  },
  ".demo-slide-right.active": {
    opacity: 1,
    transform: "translateX(0)",
    transition: "opacity 150ms linear, transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)"
  },
  "@keyframes animation-slide-top": {
    "0%": {
      opacity: 0,
      transform: "translateY(2rem)"
    },
    "75%": {
      opacity: 1
    },
    "100%": {
      transform: "translateY(0)"
    }
  },
  ".demo-slide-top": {
    opacity: 0,
    transform: "translateY(2rem)",
    transition: "opacity 150ms linear, transform 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53)"
  },
  ".demo-slide-top.active": {
    opacity: 1,
    transform: "translateY(0)",
    transition: "opacity 150ms linear, transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)"
  },
  "@keyframes animation-slide-bottom": {
    "0%": {
      opacity: 0,
      transform: "translateY(-2rem)"
    },
    "75%": {
      opacity: 1
    },
    "100%": {
      transform: "translateY(0)"
    }
  },
  ".demo-slide-bottom": {
    opacity: 0,
    transform: "translateY(-2rem)",
    transition: "opacity 150ms linear, transform 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53)"
  },
  ".demo-slide-bottom.active": {
    opacity: 1,
    transform: "translateY(0)",
    transition: "opacity 150ms linear, transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)"
  },
  ".demo-fade-grow": {
    opacity: 0,
    transform: "scale(0)",
    transition: "opacity 150ms linear, transform 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53)"
  },
  ".demo-fade-grow.active": {
    opacity: 1,
    transform: "scale(1)",
    transition: "opacity 150ms linear, transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)"
  },
  "@keyframes animation-ring-bell": {
    "20%": {
      transform: "rotate(30deg)"
    },
    "40%": {
      transform: "rotate(-30deg)"
    },
    "60%": {
      transform: "rotate(12.66deg)"
    },
    "80%": {
      transform: "rotate(-3.75deg)"
    },
    "100%": {
      transform: "rotate(0)"
    }
  },
  "@keyframes animation-rotate-2": {
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(360deg)"
    }
  },
  "@keyframes animation-fly-plane": {
    "0%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    },
    "40%": {
      transform: "translate3d(1rem, -1rem, 0)",
      opacity: 0
    },
    "60%": {
      transform: "translate3d(-1rem, 1rem, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  },
  "@keyframes animation-heartbeat": {
    "0%": {
      transform: "scale(1)",
      color: "inherit"
    },
    "15%": {
      transform: "scale(1.2)",
      color: "var(--danger)"
    },
    "50%": {
      transform: "scale(1)",
      color: "inherit"
    },
    "65%": {
      transform: "scale(1.2)",
      color: "var(--danger)"
    },
    "100%": {
      transform: "scale(1)",
      color: "inherit"
    }
  },
  "::-webkit-scrollbar": {
    width: "9px",
    height: "8px",
    backgroundColor: "transparent"
  },
  "@media (max-width: 575.98px)": {
    "::-webkit-scrollbar": {
      display: "none",
      width: "0px"
    }
  },
  "::-webkit-scrollbar-track": {
    borderRadius: "0px",
    backgroundColor: "transparent",
    border: "4px solid transparent",
    backgroundClip: "content-box"
  },
  "::-webkit-scrollbar-track:hover": {
    background: "#f2f5f7"
  },
  "::-webkit-scrollbar-thumb": {
    border: "1px solid #c1ccd6",
    background: "#c1ccd6"
  },
  "::-webkit-scrollbar-thumb:hover": {
    border: "0px solid #dce3e8",
    background: "#1c2b36"
  },
  "::-webkit-scrollbar-thumb:active": {
    background: "#1c2b36"
  },
  "::-webkit-scrollbar-corner": {
    background: "transparent"
  },
  ".gs-uitk-html-select": {
    backgroundColor: "#ffffff",
    backgroundClip: "padding-box",
    height: "2rem",
    borderRadius: "0.125rem",
    border: "1px solid #9fb1bd",
    padding: "0.3125rem 0.5rem",
    transition: "border-color 0.15s ease-in-out",
    color: "#1c2b36",
    fontFamily: "Goldman Sans",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.00625rem"
  },
  ".gs-uitk-html-select:focus": {
    boxShadow: "none",
    borderColor: "#186ade",
    outlineWidth: "0"
  },
  ".gs-uitk-html-select:hover": {
    borderColor: "#7a909e"
  },
  ".gs-uitk-html-select--xs, .gs-uitk-html-select--sm": {
    height: "1.5rem",
    lineHeight: "1rem",
    fontSize: "0.75rem"
  },
  ".gs-uitk-html-select--lg, .gs-uitk-html-select--xl": {
    height: "2.5rem",
    lineHeight: "1.5rem",
    fontSize: "1rem"
  },
  ".gs-uitk-html-select:disabled, .gs-uitk-html-select:disabled:hover, .gs-uitk-html-select:disabled:focus, .gs-uitk-html-select:disabled:active": {
    backgroundColor: "rgba(91, 114, 130, 0.1)",
    borderColor: "rgba(91, 114, 130, 0.1)",
    color: "rgba(28, 43, 54, 0.2)"
  },
  ".gs-uitk-html-select--error": {
    borderColor: "#d91f11"
  },
  ".gs-uitk-html-select--success": {
    borderColor: "#fc9162"
  },
  ".gs-uitk-html-select--warning": {
    borderColor: "#186ade"
  },
  ".demo-object-container": {
    display: "block",
    width: "100%",
    height: "150px",
    overflow: "hidden"
  },
  ".demo-object-container .demo-object": {
    height: "100%",
    backgroundColor: "#3e5463"
  },
  ".demo-ease-obj": {
    left: "0%"
  },
  ".demo-ease-obj.active": {
    left: "90%"
  },
  ".token--gs-brand": {
    background: "#7399c6"
  },
  ".token--global-header": {
    background: "#11294d"
  },
  ".token--surface-primary": {
    background: "#ffffff"
  },
  ".token--surface-secondary": {
    background: "#f2f5f7"
  },
  ".token--surface-tertiary": {
    background: "#dce3e8"
  },
  ".token--surface-moderate": {
    background: "#c1ccd6"
  },
  ".token--surface-bold": {
    background: "#9fb1bd"
  },
  ".token--surface-strong": {
    background: "#9fb1bd"
  },
  ".token--surface-contrast": {
    background: "#9fb1bd"
  },
  ".token--surface-overlay": {
    background: "#9fb1bd"
  },
  ".token--border-minimal": {
    background: "#dce3e8"
  },
  ".token--border-subtle": {
    background: "#c1ccd6"
  },
  ".token--border-moderate": {
    background: "#9fb1bd"
  },
  ".token--border-bold": {
    background: "#5b7282"
  },
  ".token--border-contrast": {
    background: "#1c2b36"
  },
  ".token--text-primary": {
    background: "#1c2b36"
  },
  ".token--text-secondary": {
    background: "#3e5463"
  },
  ".token--text-tertiary": {
    background: "#9fb1bd"
  },
  ".token--text-link": {
    background: "#186ade"
  },
  ".token--text-destructive": {
    background: "#d91f11"
  },
  ".token--text-reversed": {
    background: "#ffffff"
  },
  ".token--icon-action": {
    background: "#186ade"
  },
  ".token--icon-primary": {
    background: "#3e5463"
  },
  ".token--icon-secondary": {
    background: "#9fb1bd"
  },
  ".token--icon-reversed": {
    background: "#ffffff"
  },
  ".token--icon-contrast": {
    background: "#000000"
  },
  ".token--icon-destructive": {
    background: "#d91f11"
  },
  ".token--form-input-border": {
    background: "#9fb1bd"
  },
  ".token--form-input-background": {
    background: "#ffffff"
  },
  ".token--status-none-bold": {
    background: "#5b7282"
  },
  ".token--status-error-bold": {
    background: "#d91f11"
  },
  ".token--status-success-bold": {
    background: "#077d55"
  },
  ".token--status-warning-bold": {
    background: "#f5c518"
  },
  ".token--status-information-bold": {
    background: "#186ade"
  },
  ".token--status-warning-icon": {
    background: "#e86427"
  },
  ".token--status-none-subtle": {
    background: "#dce3e8"
  },
  ".token--status-error-subtle": {
    background: "#fadcd9"
  },
  ".token--status-success-subtle": {
    background: "#c7ebd1"
  },
  ".token--status-warning-subtle": {
    background: "#faf6cf"
  },
  ".token--status-information-subtle": {
    background: "#d4e4fa"
  },
  ".token--surface-minimal-hover": {
    background: "rgba(159, 177, 189, 0.1)"
  },
  ".token--surface-subtle-hover": {
    background: "rgba(159, 177, 189, 0.2)"
  },
  ".token--surface-moderate-hover": {
    background: "rgba(159, 177, 189, 0.4)"
  },
  ".token--surface-bold-hover": {
    background: "rgba(159, 177, 189, 0.6)"
  },
  ".token--surface-contrast-hover": {
    background: "#2a3f4d"
  },
  ".token--border-minimal-hover": {
    background: "#c1ccd6"
  },
  ".token--border-subtle-hover": {
    background: "#9fb1bd"
  },
  ".token--border-moderate-hover": {
    background: "#7a909e"
  },
  ".token--border-bold-hover": {
    background: "#3e5463"
  },
  ".token--border-contrast-hover": {
    background: "#0e171f"
  },
  ".token--background-subtle-selected": {
    background: "rgba(24, 106, 222, 0.2)"
  },
  ".token--background-contrast-selected": {
    background: "#186ade"
  },
  ".token--text-subtle-selected": {
    background: "#0d4ea6"
  },
  ".token--text-contrast-selected": {
    background: "#ffffff"
  },
  ".token--background-disabled": {
    background: "rgba(91, 114, 130, 0.1)"
  },
  ".token--foreground-disabled": {
    background: "#c1ccd6"
  },
  ".token--reversed-disabled": {
    background: "rgba(255, 255, 255, 0.6)"
  },
  ".token--text-disabled": {
    background: "rgba(91, 114, 130, 0.4)"
  },
  ".token--border-focus": {
    background: "#186ade"
  },
  ".token--background-focus": {
    background: "rgba(159, 177, 189, 0.2)"
  },
  ".token--gray-ramp-bold-background": {
    background: "#5b7282"
  },
  ".token--red-ramp-bold-background": {
    background: "#d91f11"
  },
  ".token--orange-ramp-bold-background": {
    background: "#e86427"
  },
  ".token--yellow-ramp-bold-background": {
    background: "#f5c518"
  },
  ".token--lime-ramp-bold-background": {
    background: "#3c7d0e"
  },
  ".token--green-ramp-bold-background": {
    background: "#077d55"
  },
  ".token--teal-ramp-bold-background": {
    background: "#167b7d"
  },
  ".token--turquoise-ramp-bold-background": {
    background: "#067a91"
  },
  ".token--aqua-ramp-bold-background": {
    background: "#08548a"
  },
  ".token--blue-ramp-bold-background": {
    background: "#186ade"
  },
  ".token--ultramarine-ramp-bold-background": {
    background: "#545fe8"
  },
  ".token--purple-ramp-bold-background": {
    background: "#8f49de"
  },
  ".token--pink-ramp-bold-background": {
    background: "#cc1d92"
  },
  ".token--gray-ramp-subtle-background": {
    background: "rgba(159, 177, 189, 0.3)"
  },
  ".token--red-ramp-subtle-background": {
    background: "rgba(252, 144, 134, 0.3)"
  },
  ".token--orange-ramp-subtle-background": {
    background: "rgba(252, 145, 98, 0.3)"
  },
  ".token--yellow-ramp-subtle-background": {
    background: "rgba(247, 227, 121, 0.5)"
  },
  ".token--lime-ramp-subtle-background": {
    background: "rgba(120, 191, 57, 0.3)"
  },
  ".token--green-ramp-subtle-background": {
    background: "rgba(67, 196, 120, 0.3)"
  },
  ".token--teal-ramp-subtle-background": {
    background: "rgba(78, 191, 185, 0.3)"
  },
  ".token--turquoise-ramp-subtle-background": {
    background: "rgba(69, 188, 209, 0.3)"
  },
  ".token--aqua-ramp-subtle-background": {
    background: "rgba(72, 184, 240, 0.3)"
  },
  ".token--blue-ramp-subtle-background": {
    background: "rgba(117, 177, 255, 0.3)"
  },
  ".token--ultramarine-ramp-subtle-background": {
    background: "rgba(160, 167, 250, 0.3)"
  },
  ".token--purple-ramp-subtle-background": {
    background: "rgba(200, 154, 252, 0.3)"
  },
  ".token--pink-ramp-subtle-background": {
    background: "rgba(250, 135, 212, 0.3)"
  },
  ".token--gray-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--red-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--orange-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--yellow-ramp-bold-text": {
    background: "#1c2b36"
  },
  ".token--lime-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--green-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--teal-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--turquoise-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--aqua-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--blue-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--ultramarine-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--purple-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--pink-ramp-bold-text": {
    background: "#ffffff"
  },
  ".token--gray-ramp-subtle-text": {
    background: "#2a3f4d"
  },
  ".token--red-ramp-subtle-text": {
    background: "#d91f11"
  },
  ".token--orange-ramp-subtle-text": {
    background: "#bf4815"
  },
  ".token--yellow-ramp-subtle-text": {
    background: "#1c2b36"
  },
  ".token--lime-ramp-subtle-text": {
    background: "#2e5c0e"
  },
  ".token--green-ramp-subtle-text": {
    background: "#075e45"
  },
  ".token--teal-ramp-subtle-text": {
    background: "#155c5e"
  },
  ".token--turquoise-ramp-subtle-text": {
    background: "#09596b"
  },
  ".token--aqua-ramp-subtle-text": {
    background: "#08548a"
  },
  ".token--blue-ramp-subtle-text": {
    background: "#0d4ea6"
  },
  ".token--ultramarine-ramp-subtle-text": {
    background: "#3a45b0"
  },
  ".token--purple-ramp-subtle-text": {
    background: "#6b30ab"
  },
  ".token--pink-ramp-subtle-text": {
    background: "#961574"
  },
  ".token--dataviz-default-sequence-01": {
    background: "#0d4ea6"
  },
  ".token--dataviz-default-sequence-02": {
    background: "#e86427"
  },
  ".token--dataviz-default-sequence-03": {
    background: "#279c9c"
  },
  ".token--dataviz-default-sequence-04": {
    background: "#d9a514"
  },
  ".token--dataviz-default-sequence-05": {
    background: "#ac71f0"
  },
  ".token--dataviz-default-sequence-06": {
    background: "#23254d"
  },
  ".token--dataviz-default-sequence-07": {
    background: "#52a31d"
  },
  ".token--dataviz-default-sequence-08": {
    background: "#cc1d92"
  },
  ".token--dataviz-default-sequence-09": {
    background: "#48b8f0"
  },
  ".token--dataviz-default-sequence-10": {
    background: "#077d55"
  },
  ".design-system-demo [data-gs-uitk-component=button-group][data-orientation=vertical]": {
    width: "200px"
  },
  ".tokens-demo__container": {
    display: "grid",
    gridTemplateColumns: "minmax(500px, max-content) repeat(auto-fill, 500px) 20%"
  },
  ".tokens-demo__box": {
    display: "inline-block",
    width: "14px",
    height: "14px",
    border: "1px solid black"
  },
  ".tokens-demo__text": {
    paddingLeft: "0.5rem",
    display: "inline-block"
  },
  ".colors-demo__container": {
    display: "grid",
    gridTemplateColumns: "minmax(250px, max-content) repeat(auto-fill, 200px) 20%"
  },
  ".colors-demo__heading": {
    textTransform: "capitalize"
  },
  ".colors-demo__row": {
    display: "flex",
    alignItems: "center",
    padding: "0.25rem 0",
    borderTop: "1px solid rgba(0, 0, 0, 0.1)"
  },
  ".colors-demo__box": {
    display: "inline-block",
    width: "14px",
    height: "14px",
    border: "1px solid black"
  },
  ".colors-demo__text": {
    paddingLeft: "0.5rem",
    display: "inline-block"
  },
  ".type-system-demo .type-system-demo__text-mixin-display-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "78px",
    lineHeight: "104px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-display-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "60px",
    lineHeight: "80px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-display-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-heading-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "40px",
    lineHeight: "52px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-heading-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-heading-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-heading-04": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-heading-05": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-heading-06": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-heading-07": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-display-01-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "78px",
    lineHeight: "104px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-display-02-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "60px",
    lineHeight: "80px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-display-03-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-heading-01-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "40px",
    lineHeight: "52px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-heading-02-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-heading-03-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-heading-04-serif": {
    fontFamily: 'Sabon, Georgia, "Times New Roman", serif',
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "0.2px"
  },
  ".type-system-demo .type-system-demo__text-mixin-body-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-body-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-body-03": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-body-04": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "11px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-body-05": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "10px",
    lineHeight: "12px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-ui-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-ui-02": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "11px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-caption-01": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: "11px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-code-01": {
    fontFamily: '"Roboto Mono", "Courier New", monospace',
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  },
  ".type-system-demo .type-system-demo__text-mixin-code-02": {
    fontFamily: '"Roboto Mono", "Courier New", monospace',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  },
  ".spacing-demo__heading": {
    textTransform: "capitalize"
  },
  ".spacing-demo__row": {
    display: "flex",
    alignItems: "center",
    padding: "0.25rem 0"
  },
  ".spacing-demo__box": {
    width: "200px",
    backgroundColor: "#c1ccd6"
  },
  ".spacing-demo__text": {
    width: "250px",
    paddingRight: "8px"
  },
  ".spacing-demo__sizer": {
    backgroundColor: "#c1ccd6"
  },
  ".spacing-demo__sizer__outer": {
    backgroundColor: "#7a909e"
  },
  ".spacing-demo__sizer__outer[class*=gs-uitk-w-] .spacing-demo__sizer__inner": {
    width: "100%"
  },
  ".spacing-demo__sizer__outer[class*=gs-uitk-h-] .spacing-demo__sizer__inner": {
    height: "100%"
  },
  ".spacing-demo__sizer__inner": {
    backgroundColor: "#3e5463",
    height: "16px",
    width: "16px"
  },
  ".elevation-demo__small-box": {
    width: "3.75rem",
    height: "3.75rem",
    borderRadius: "0.125rem"
  },
  ".elevation-demo__large-box": {
    width: "11.875rem",
    height: "7.5rem",
    borderRadius: "0.125rem"
  },
  ".elevation-demo__bottom-position": {
    position: "absolute",
    bottom: "0.5rem"
  }
};

// components/design-system/common/src/inject-legacy-global-design-system-demo-css.ts
var stylesInjected2 = /* @__PURE__ */ new Set();
function injectLegacyGlobalDesignSystemDemoCss(scopingSelector) {
  if (stylesInjected2.has(scopingSelector || ""))
    return;
  if (scopingSelector) {
    injectGlobal2(getScopedCss(demo_scss_default, scopingSelector));
  } else {
    injectGlobal2(demo_scss_default);
  }
  stylesInjected2.add(scopingSelector || "");
}

// components/design-system/common/src/inject-legacy-global-reboot-css.ts
import { injectGlobal as injectGlobal3 } from "@gs-ux-uitoolkit-common/style";

// components/design-system/common/src/generated/reboot.scss.ts
var reboot_scss_default = {
  "*, *::before, *::after": {
    boxSizing: "border-box"
  },
  html: {
    fontFamily: "sans-serif",
    lineHeight: 1.15,
    WebkitTextSizeAdjust: "100%",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  },
  "article, aside, figcaption, figure, footer, header, hgroup, main, nav, section": {
    display: "block"
  },
  body: {
    margin: "0",
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: "#0e171f",
    textAlign: "left",
    backgroundColor: "#ffffff",
    letterSpacing: "0"
  },
  hr: {
    boxSizing: "content-box",
    height: "0",
    overflow: "visible"
  },
  "h1, .text-7, h2, .text-6, h3, .text-5, h4, .text-4, h5, .text-3, h6, .text-2": {
    marginTop: "0",
    marginBottom: "0.5rem"
  },
  "p, .text-1": {
    marginTop: "0",
    marginBottom: "1rem",
    margin: "0.375rem 0 0.75rem"
  },
  "abbr[title], abbr[data-original-title]": {
    textDecoration: ["underline", "underline dotted"],
    cursor: "help",
    borderBottom: "0",
    textDecorationSkipInk: "none"
  },
  address: {
    marginBottom: "1rem",
    fontStyle: "normal",
    lineHeight: "inherit"
  },
  "ol, ul, dl": {
    marginTop: "0",
    marginBottom: "1rem"
  },
  "ol ol, ul ul, ol ul, ul ol": {
    marginBottom: "0"
  },
  dt: {
    fontWeight: 700
  },
  dd: {
    marginBottom: "0.5rem",
    marginLeft: "0"
  },
  blockquote: {
    margin: "0 0 1rem"
  },
  "b, strong": {
    fontWeight: "bolder"
  },
  small: {
    fontSize: "12px",
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: "0"
  },
  "sub, sup": {
    position: "relative",
    fontSize: "75%",
    lineHeight: 0,
    verticalAlign: "baseline"
  },
  sub: {
    bottom: "-0.25em"
  },
  sup: {
    top: "-0.5em"
  },
  a: {
    color: "#186ade",
    textDecoration: "none",
    backgroundColor: "transparent"
  },
  "a:hover": {
    color: "#114999",
    textDecoration: "underline"
  },
  "a:not([href]):not([class])": {
    color: "inherit",
    textDecoration: "none"
  },
  "a:not([href]):not([class]):hover": {
    color: "inherit",
    textDecoration: "none"
  },
  "pre, code, kbd, samp": {
    fontFamily: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    fontSize: "1em"
  },
  pre: {
    marginTop: "0",
    marginBottom: "1rem",
    overflow: "auto",
    msOverflowStyle: "scrollbar"
  },
  figure: {
    margin: "0 0 1rem"
  },
  img: {
    verticalAlign: "middle",
    borderStyle: "none"
  },
  svg: {
    overflow: "hidden",
    verticalAlign: "middle"
  },
  table: {
    borderCollapse: "collapse"
  },
  caption: {
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    color: "#5b7282",
    textAlign: "left",
    captionSide: "bottom"
  },
  th: {
    textAlign: "inherit"
  },
  label: {
    display: "inline-block",
    marginBottom: "0.5rem"
  },
  button: {
    borderRadius: "0"
  },
  "button:focus": {
    outline: ["1px dotted", "5px auto -webkit-focus-ring-color"]
  },
  "input, button, select, optgroup, textarea": {
    margin: "0",
    fontFamily: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit"
  },
  "button, input": {
    overflow: "visible"
  },
  "button, select": {
    textTransform: "none"
  },
  "[role=button]": {
    cursor: "pointer"
  },
  select: {
    wordWrap: "normal"
  },
  "button, [type=button], [type=reset], [type=submit]": {
    WebkitAppearance: "button"
  },
  "button:not(:disabled), [type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled)": {
    cursor: "pointer"
  },
  "button::-moz-focus-inner, [type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner": {
    padding: "0",
    borderStyle: "none"
  },
  "input[type=radio], input[type=checkbox]": {
    boxSizing: "border-box",
    padding: "0"
  },
  textarea: {
    overflow: "auto",
    resize: "vertical"
  },
  fieldset: {
    minWidth: "0",
    padding: "0",
    margin: "0",
    border: "0"
  },
  legend: {
    display: "block",
    width: "100%",
    maxWidth: "100%",
    padding: "0",
    marginBottom: "0.5rem",
    fontSize: "1.5rem",
    lineHeight: "inherit",
    color: "inherit",
    whiteSpace: "normal"
  },
  progress: {
    verticalAlign: "baseline"
  },
  "[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button": {
    height: "auto"
  },
  "[type=search]": {
    outlineOffset: "-2px",
    WebkitAppearance: "none"
  },
  "[type=search]::-webkit-search-decoration": {
    WebkitAppearance: "none"
  },
  "::-webkit-file-upload-button": {
    font: "inherit",
    WebkitAppearance: "button"
  },
  output: {
    display: "inline-block"
  },
  summary: {
    display: "list-item",
    cursor: "pointer"
  },
  template: {
    display: "none"
  },
  "[hidden]": {
    display: "none !important"
  },
  "@font-face": {
    fontFamily: '"Sabon"',
    src: 'url("https://cdn.gs.com/fonts/sabon/v1/sabon.woff2") format("woff2"), url("https://cdn.gs.com/fonts/sabon/v1/sabon.woff") format("woff")',
    fontWeight: 400,
    fontStyle: "normal"
  },
  ".display-1": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "78px",
    lineHeight: "104px",
    letterSpacing: "0.2px"
  },
  ".display-2": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "60px",
    lineHeight: "80px",
    letterSpacing: "0.2px"
  },
  ".display-3": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "0.2px"
  },
  ".display-4": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: ["48px", "38.4px"],
    lineHeight: "64px",
    letterSpacing: "0.2px"
  },
  "h1, .text-7, .h1": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "40px",
    lineHeight: "52px",
    letterSpacing: "0.2px",
    margin: "0.5rem 0 1rem"
  },
  "h2, .text-6, .h2": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.2px",
    margin: "1.25rem 0 0.75rem"
  },
  "h3, .text-5, .h3": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.2px",
    margin: "1.25rem 0 0.75rem"
  },
  "h4, .text-4, .h4": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "0.2px",
    margin: "1.25rem 0 0.75rem"
  },
  "h5, .text-3, .h5": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0",
    margin: "1.25rem 0 0.5rem"
  },
  "h6, .text-2, .h6": {
    fontFamily: '"Goldman Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0",
    margin: "1.25rem 0 0.25rem"
  },
  "ul, ol": {
    listStyle: "none"
  },
  "ul.list-bulleted": {
    listStyle: "square"
  },
  "ol.list-numbered": {
    listStyle: "decimal"
  },
  "::-webkit-scrollbar": {
    width: "9px",
    height: "8px",
    backgroundColor: "transparent"
  },
  "@media (max-width: 575.98px)": {
    "::-webkit-scrollbar": {
      display: "none",
      width: "0px"
    }
  },
  "::-webkit-scrollbar-track": {
    borderRadius: "0px",
    backgroundColor: "transparent",
    border: "4px solid transparent",
    backgroundClip: "content-box"
  },
  "::-webkit-scrollbar-track:hover": {
    background: "#f2f5f7"
  },
  "::-webkit-scrollbar-thumb": {
    border: "1px solid #c1ccd6",
    background: "#c1ccd6"
  },
  "::-webkit-scrollbar-thumb:hover": {
    border: "0px solid #dce3e8",
    background: "#1c2b36"
  },
  "::-webkit-scrollbar-thumb:active": {
    background: "#1c2b36"
  },
  "::-webkit-scrollbar-corner": {
    background: "transparent"
  },
  "body, *::placeholder": {
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale"
  }
};

// components/design-system/common/src/inject-legacy-global-reboot-css.ts
var stylesInjected3 = /* @__PURE__ */ new Set();
function injectLegacyGlobalRebootCss(scopingSelector) {
  if (stylesInjected3.has(scopingSelector || ""))
    return;
  if (scopingSelector) {
    injectGlobal3(getScopedCss(reboot_scss_default, scopingSelector));
  } else {
    injectGlobal3(reboot_scss_default);
  }
  stylesInjected3.add(scopingSelector || "");
}

// components/design-system/common/src/inject-legacy-global-utilities-css.ts
import { injectGlobal as injectGlobal4 } from "@gs-ux-uitoolkit-common/style";

// components/design-system/common/src/generated/utilities.scss.ts
var utilities_scss_default = {
  ".align-baseline": {
    verticalAlign: "baseline !important"
  },
  ".align-top": {
    verticalAlign: "top !important"
  },
  ".align-middle": {
    verticalAlign: "middle !important"
  },
  ".align-bottom": {
    verticalAlign: "bottom !important"
  },
  ".align-text-bottom": {
    verticalAlign: "text-bottom !important"
  },
  ".align-text-top": {
    verticalAlign: "text-top !important"
  },
  ".bg-primary": {
    backgroundColor: "#186ade !important"
  },
  "a.bg-primary:hover, a.bg-primary:focus, button.bg-primary:hover, button.bg-primary:focus": {
    backgroundColor: "#1354b0 !important"
  },
  ".bg-secondary": {
    backgroundColor: "#c1ccd6 !important"
  },
  "a.bg-secondary:hover, a.bg-secondary:focus, button.bg-secondary:hover, button.bg-secondary:focus": {
    backgroundColor: "#a2b3c2 !important"
  },
  ".bg-success": {
    backgroundColor: "#077d55 !important"
  },
  "a.bg-success:hover, a.bg-success:focus, button.bg-success:hover, button.bg-success:focus": {
    backgroundColor: "#044d34 !important"
  },
  ".bg-info": {
    backgroundColor: "#186ade !important"
  },
  "a.bg-info:hover, a.bg-info:focus, button.bg-info:hover, button.bg-info:focus": {
    backgroundColor: "#1354b0 !important"
  },
  ".bg-warning": {
    backgroundColor: "#f5c518 !important"
  },
  "a.bg-warning:hover, a.bg-warning:focus, button.bg-warning:hover, button.bg-warning:focus": {
    backgroundColor: "#d1a609 !important"
  },
  ".bg-danger": {
    backgroundColor: "#d91f11 !important"
  },
  "a.bg-danger:hover, a.bg-danger:focus, button.bg-danger:hover, button.bg-danger:focus": {
    backgroundColor: "#aa180d !important"
  },
  ".bg-light": {
    backgroundColor: "#ffffff !important"
  },
  "a.bg-light:hover, a.bg-light:focus, button.bg-light:hover, button.bg-light:focus": {
    backgroundColor: "#e6e6e6 !important"
  },
  ".bg-dark": {
    backgroundColor: "#1c2b36 !important"
  },
  "a.bg-dark:hover, a.bg-dark:focus, button.bg-dark:hover, button.bg-dark:focus": {
    backgroundColor: "#0b1014 !important"
  },
  ".bg-white": {
    backgroundColor: "#ffffff !important"
  },
  ".bg-transparent": {
    backgroundColor: "transparent !important"
  },
  ".border": {
    border: "1px solid #dce3e8 !important"
  },
  ".border-top": {
    borderTop: "1px solid #dce3e8 !important"
  },
  ".border-right": {
    borderRight: "1px solid #dce3e8 !important"
  },
  ".border-bottom": {
    borderBottom: "1px solid #dce3e8 !important"
  },
  ".border-left": {
    borderLeft: "1px solid #dce3e8 !important"
  },
  ".border-0": {
    border: "0 !important"
  },
  ".border-top-0": {
    borderTop: "0 !important"
  },
  ".border-right-0": {
    borderRight: "0 !important"
  },
  ".border-bottom-0": {
    borderBottom: "0 !important"
  },
  ".border-left-0": {
    borderLeft: "0 !important"
  },
  ".border-primary": {
    borderColor: "#186ade !important"
  },
  ".border-secondary": {
    borderColor: "#c1ccd6 !important"
  },
  ".border-success": {
    borderColor: "#077d55 !important"
  },
  ".border-info": {
    borderColor: "#186ade !important"
  },
  ".border-warning": {
    borderColor: "#f5c518 !important"
  },
  ".border-danger": {
    borderColor: "#d91f11 !important"
  },
  ".border-light": {
    borderColor: "#ffffff !important"
  },
  ".border-dark": {
    borderColor: "#1c2b36 !important"
  },
  ".border-white": {
    borderColor: "#ffffff !important"
  },
  ".rounded-sm": {
    borderRadius: "0.2rem !important"
  },
  ".rounded": {
    borderRadius: "0.25rem !important"
  },
  ".rounded-top": {
    borderTopLeftRadius: "0.25rem !important",
    borderTopRightRadius: "0.25rem !important"
  },
  ".rounded-right": {
    borderTopRightRadius: "0.25rem !important",
    borderBottomRightRadius: "0.25rem !important"
  },
  ".rounded-bottom": {
    borderBottomRightRadius: "0.25rem !important",
    borderBottomLeftRadius: "0.25rem !important"
  },
  ".rounded-left": {
    borderTopLeftRadius: "0.25rem !important",
    borderBottomLeftRadius: "0.25rem !important"
  },
  ".rounded-lg": {
    borderRadius: "0.3rem !important"
  },
  ".rounded-circle": {
    borderRadius: "50% !important"
  },
  ".rounded-pill": {
    borderRadius: "50rem !important"
  },
  ".rounded-0": {
    borderRadius: "0 !important"
  },
  ".clearfix::after": {
    display: "block",
    clear: "both",
    content: '""'
  },
  ".d-none": {
    display: "none !important"
  },
  ".d-inline": {
    display: "inline !important"
  },
  ".d-inline-block": {
    display: "inline-block !important"
  },
  ".d-block": {
    display: "block !important"
  },
  ".d-table": {
    display: "table !important"
  },
  ".d-table-row": {
    display: "table-row !important"
  },
  ".d-table-cell": {
    display: "table-cell !important"
  },
  ".d-flex": {
    display: "flex !important"
  },
  ".d-inline-flex": {
    display: "inline-flex !important"
  },
  "@media (min-width: 576px)": {
    ".d-sm-none": {
      display: "none !important"
    },
    ".d-sm-inline": {
      display: "inline !important"
    },
    ".d-sm-inline-block": {
      display: "inline-block !important"
    },
    ".d-sm-block": {
      display: "block !important"
    },
    ".d-sm-table": {
      display: "table !important"
    },
    ".d-sm-table-row": {
      display: "table-row !important"
    },
    ".d-sm-table-cell": {
      display: "table-cell !important"
    },
    ".d-sm-flex": {
      display: "flex !important"
    },
    ".d-sm-inline-flex": {
      display: "inline-flex !important"
    },
    ".flex-sm-row": {
      flexDirection: "row !important"
    },
    ".flex-sm-column": {
      flexDirection: "column !important"
    },
    ".flex-sm-row-reverse": {
      flexDirection: "row-reverse !important"
    },
    ".flex-sm-column-reverse": {
      flexDirection: "column-reverse !important"
    },
    ".flex-sm-wrap": {
      flexWrap: "wrap !important"
    },
    ".flex-sm-nowrap": {
      flexWrap: "nowrap !important"
    },
    ".flex-sm-wrap-reverse": {
      flexWrap: "wrap-reverse !important"
    },
    ".flex-sm-fill": {
      flex: "1 1 auto !important"
    },
    ".flex-sm-grow-0": {
      flexGrow: "0 !important"
    },
    ".flex-sm-grow-1": {
      flexGrow: "1 !important"
    },
    ".flex-sm-shrink-0": {
      flexShrink: "0 !important"
    },
    ".flex-sm-shrink-1": {
      flexShrink: "1 !important"
    },
    ".justify-content-sm-start": {
      justifyContent: "flex-start !important"
    },
    ".justify-content-sm-end": {
      justifyContent: "flex-end !important"
    },
    ".justify-content-sm-center": {
      justifyContent: "center !important"
    },
    ".justify-content-sm-between": {
      justifyContent: "space-between !important"
    },
    ".justify-content-sm-around": {
      justifyContent: "space-around !important"
    },
    ".align-items-sm-start": {
      alignItems: "flex-start !important"
    },
    ".align-items-sm-end": {
      alignItems: "flex-end !important"
    },
    ".align-items-sm-center": {
      alignItems: "center !important"
    },
    ".align-items-sm-baseline": {
      alignItems: "baseline !important"
    },
    ".align-items-sm-stretch": {
      alignItems: "stretch !important"
    },
    ".align-content-sm-start": {
      alignContent: "flex-start !important"
    },
    ".align-content-sm-end": {
      alignContent: "flex-end !important"
    },
    ".align-content-sm-center": {
      alignContent: "center !important"
    },
    ".align-content-sm-between": {
      alignContent: "space-between !important"
    },
    ".align-content-sm-around": {
      alignContent: "space-around !important"
    },
    ".align-content-sm-stretch": {
      alignContent: "stretch !important"
    },
    ".align-self-sm-auto": {
      alignSelf: "auto !important"
    },
    ".align-self-sm-start": {
      alignSelf: "flex-start !important"
    },
    ".align-self-sm-end": {
      alignSelf: "flex-end !important"
    },
    ".align-self-sm-center": {
      alignSelf: "center !important"
    },
    ".align-self-sm-baseline": {
      alignSelf: "baseline !important"
    },
    ".align-self-sm-stretch": {
      alignSelf: "stretch !important"
    },
    ".float-sm-left": {
      cssFloat: "left !important"
    },
    ".float-sm-right": {
      cssFloat: "right !important"
    },
    ".float-sm-none": {
      cssFloat: "none !important"
    },
    ".m-sm-0": {
      margin: "0 !important"
    },
    ".mt-sm-0,\n  .my-sm-0": {
      marginTop: "0 !important"
    },
    ".mr-sm-0,\n  .mx-sm-0": {
      marginRight: "0 !important"
    },
    ".mb-sm-0,\n  .my-sm-0": {
      marginBottom: "0 !important"
    },
    ".ml-sm-0,\n  .mx-sm-0": {
      marginLeft: "0 !important"
    },
    ".m-sm-1": {
      margin: "0.25rem !important"
    },
    ".mt-sm-1,\n  .my-sm-1": {
      marginTop: "0.25rem !important"
    },
    ".mr-sm-1,\n  .mx-sm-1": {
      marginRight: "0.25rem !important"
    },
    ".mb-sm-1,\n  .my-sm-1": {
      marginBottom: "0.25rem !important"
    },
    ".ml-sm-1,\n  .mx-sm-1": {
      marginLeft: "0.25rem !important"
    },
    ".m-sm-2": {
      margin: "0.5rem !important"
    },
    ".mt-sm-2,\n  .my-sm-2": {
      marginTop: "0.5rem !important"
    },
    ".mr-sm-2,\n  .mx-sm-2": {
      marginRight: "0.5rem !important"
    },
    ".mb-sm-2,\n  .my-sm-2": {
      marginBottom: "0.5rem !important"
    },
    ".ml-sm-2,\n  .mx-sm-2": {
      marginLeft: "0.5rem !important"
    },
    ".m-sm-3": {
      margin: "1rem !important"
    },
    ".mt-sm-3,\n  .my-sm-3": {
      marginTop: "1rem !important"
    },
    ".mr-sm-3,\n  .mx-sm-3": {
      marginRight: "1rem !important"
    },
    ".mb-sm-3,\n  .my-sm-3": {
      marginBottom: "1rem !important"
    },
    ".ml-sm-3,\n  .mx-sm-3": {
      marginLeft: "1rem !important"
    },
    ".m-sm-4": {
      margin: "1.5rem !important"
    },
    ".mt-sm-4,\n  .my-sm-4": {
      marginTop: "1.5rem !important"
    },
    ".mr-sm-4,\n  .mx-sm-4": {
      marginRight: "1.5rem !important"
    },
    ".mb-sm-4,\n  .my-sm-4": {
      marginBottom: "1.5rem !important"
    },
    ".ml-sm-4,\n  .mx-sm-4": {
      marginLeft: "1.5rem !important"
    },
    ".m-sm-5": {
      margin: "3rem !important"
    },
    ".mt-sm-5,\n  .my-sm-5": {
      marginTop: "3rem !important"
    },
    ".mr-sm-5,\n  .mx-sm-5": {
      marginRight: "3rem !important"
    },
    ".mb-sm-5,\n  .my-sm-5": {
      marginBottom: "3rem !important"
    },
    ".ml-sm-5,\n  .mx-sm-5": {
      marginLeft: "3rem !important"
    },
    ".p-sm-0": {
      padding: "0 !important"
    },
    ".pt-sm-0,\n  .py-sm-0": {
      paddingTop: "0 !important"
    },
    ".pr-sm-0,\n  .px-sm-0": {
      paddingRight: "0 !important"
    },
    ".pb-sm-0,\n  .py-sm-0": {
      paddingBottom: "0 !important"
    },
    ".pl-sm-0,\n  .px-sm-0": {
      paddingLeft: "0 !important"
    },
    ".p-sm-1": {
      padding: "0.25rem !important"
    },
    ".pt-sm-1,\n  .py-sm-1": {
      paddingTop: "0.25rem !important"
    },
    ".pr-sm-1,\n  .px-sm-1": {
      paddingRight: "0.25rem !important"
    },
    ".pb-sm-1,\n  .py-sm-1": {
      paddingBottom: "0.25rem !important"
    },
    ".pl-sm-1,\n  .px-sm-1": {
      paddingLeft: "0.25rem !important"
    },
    ".p-sm-2": {
      padding: "0.5rem !important"
    },
    ".pt-sm-2,\n  .py-sm-2": {
      paddingTop: "0.5rem !important"
    },
    ".pr-sm-2,\n  .px-sm-2": {
      paddingRight: "0.5rem !important"
    },
    ".pb-sm-2,\n  .py-sm-2": {
      paddingBottom: "0.5rem !important"
    },
    ".pl-sm-2,\n  .px-sm-2": {
      paddingLeft: "0.5rem !important"
    },
    ".p-sm-3": {
      padding: "1rem !important"
    },
    ".pt-sm-3,\n  .py-sm-3": {
      paddingTop: "1rem !important"
    },
    ".pr-sm-3,\n  .px-sm-3": {
      paddingRight: "1rem !important"
    },
    ".pb-sm-3,\n  .py-sm-3": {
      paddingBottom: "1rem !important"
    },
    ".pl-sm-3,\n  .px-sm-3": {
      paddingLeft: "1rem !important"
    },
    ".p-sm-4": {
      padding: "1.5rem !important"
    },
    ".pt-sm-4,\n  .py-sm-4": {
      paddingTop: "1.5rem !important"
    },
    ".pr-sm-4,\n  .px-sm-4": {
      paddingRight: "1.5rem !important"
    },
    ".pb-sm-4,\n  .py-sm-4": {
      paddingBottom: "1.5rem !important"
    },
    ".pl-sm-4,\n  .px-sm-4": {
      paddingLeft: "1.5rem !important"
    },
    ".p-sm-5": {
      padding: "3rem !important"
    },
    ".pt-sm-5,\n  .py-sm-5": {
      paddingTop: "3rem !important"
    },
    ".pr-sm-5,\n  .px-sm-5": {
      paddingRight: "3rem !important"
    },
    ".pb-sm-5,\n  .py-sm-5": {
      paddingBottom: "3rem !important"
    },
    ".pl-sm-5,\n  .px-sm-5": {
      paddingLeft: "3rem !important"
    },
    ".m-sm-n1": {
      margin: "-0.25rem !important"
    },
    ".mt-sm-n1,\n  .my-sm-n1": {
      marginTop: "-0.25rem !important"
    },
    ".mr-sm-n1,\n  .mx-sm-n1": {
      marginRight: "-0.25rem !important"
    },
    ".mb-sm-n1,\n  .my-sm-n1": {
      marginBottom: "-0.25rem !important"
    },
    ".ml-sm-n1,\n  .mx-sm-n1": {
      marginLeft: "-0.25rem !important"
    },
    ".m-sm-n2": {
      margin: "-0.5rem !important"
    },
    ".mt-sm-n2,\n  .my-sm-n2": {
      marginTop: "-0.5rem !important"
    },
    ".mr-sm-n2,\n  .mx-sm-n2": {
      marginRight: "-0.5rem !important"
    },
    ".mb-sm-n2,\n  .my-sm-n2": {
      marginBottom: "-0.5rem !important"
    },
    ".ml-sm-n2,\n  .mx-sm-n2": {
      marginLeft: "-0.5rem !important"
    },
    ".m-sm-n3": {
      margin: "-1rem !important"
    },
    ".mt-sm-n3,\n  .my-sm-n3": {
      marginTop: "-1rem !important"
    },
    ".mr-sm-n3,\n  .mx-sm-n3": {
      marginRight: "-1rem !important"
    },
    ".mb-sm-n3,\n  .my-sm-n3": {
      marginBottom: "-1rem !important"
    },
    ".ml-sm-n3,\n  .mx-sm-n3": {
      marginLeft: "-1rem !important"
    },
    ".m-sm-n4": {
      margin: "-1.5rem !important"
    },
    ".mt-sm-n4,\n  .my-sm-n4": {
      marginTop: "-1.5rem !important"
    },
    ".mr-sm-n4,\n  .mx-sm-n4": {
      marginRight: "-1.5rem !important"
    },
    ".mb-sm-n4,\n  .my-sm-n4": {
      marginBottom: "-1.5rem !important"
    },
    ".ml-sm-n4,\n  .mx-sm-n4": {
      marginLeft: "-1.5rem !important"
    },
    ".m-sm-n5": {
      margin: "-3rem !important"
    },
    ".mt-sm-n5,\n  .my-sm-n5": {
      marginTop: "-3rem !important"
    },
    ".mr-sm-n5,\n  .mx-sm-n5": {
      marginRight: "-3rem !important"
    },
    ".mb-sm-n5,\n  .my-sm-n5": {
      marginBottom: "-3rem !important"
    },
    ".ml-sm-n5,\n  .mx-sm-n5": {
      marginLeft: "-3rem !important"
    },
    ".m-sm-auto": {
      margin: "auto !important"
    },
    ".mt-sm-auto,\n  .my-sm-auto": {
      marginTop: "auto !important"
    },
    ".mr-sm-auto,\n  .mx-sm-auto": {
      marginRight: "auto !important"
    },
    ".mb-sm-auto,\n  .my-sm-auto": {
      marginBottom: "auto !important"
    },
    ".ml-sm-auto,\n  .mx-sm-auto": {
      marginLeft: "auto !important"
    },
    ".text-sm-left": {
      textAlign: "left !important"
    },
    ".text-sm-right": {
      textAlign: "right !important"
    },
    ".text-sm-center": {
      textAlign: "center !important"
    }
  },
  "@media (min-width: 768px)": {
    ".d-md-none": {
      display: "none !important"
    },
    ".d-md-inline": {
      display: "inline !important"
    },
    ".d-md-inline-block": {
      display: "inline-block !important"
    },
    ".d-md-block": {
      display: "block !important"
    },
    ".d-md-table": {
      display: "table !important"
    },
    ".d-md-table-row": {
      display: "table-row !important"
    },
    ".d-md-table-cell": {
      display: "table-cell !important"
    },
    ".d-md-flex": {
      display: "flex !important"
    },
    ".d-md-inline-flex": {
      display: "inline-flex !important"
    },
    ".flex-md-row": {
      flexDirection: "row !important"
    },
    ".flex-md-column": {
      flexDirection: "column !important"
    },
    ".flex-md-row-reverse": {
      flexDirection: "row-reverse !important"
    },
    ".flex-md-column-reverse": {
      flexDirection: "column-reverse !important"
    },
    ".flex-md-wrap": {
      flexWrap: "wrap !important"
    },
    ".flex-md-nowrap": {
      flexWrap: "nowrap !important"
    },
    ".flex-md-wrap-reverse": {
      flexWrap: "wrap-reverse !important"
    },
    ".flex-md-fill": {
      flex: "1 1 auto !important"
    },
    ".flex-md-grow-0": {
      flexGrow: "0 !important"
    },
    ".flex-md-grow-1": {
      flexGrow: "1 !important"
    },
    ".flex-md-shrink-0": {
      flexShrink: "0 !important"
    },
    ".flex-md-shrink-1": {
      flexShrink: "1 !important"
    },
    ".justify-content-md-start": {
      justifyContent: "flex-start !important"
    },
    ".justify-content-md-end": {
      justifyContent: "flex-end !important"
    },
    ".justify-content-md-center": {
      justifyContent: "center !important"
    },
    ".justify-content-md-between": {
      justifyContent: "space-between !important"
    },
    ".justify-content-md-around": {
      justifyContent: "space-around !important"
    },
    ".align-items-md-start": {
      alignItems: "flex-start !important"
    },
    ".align-items-md-end": {
      alignItems: "flex-end !important"
    },
    ".align-items-md-center": {
      alignItems: "center !important"
    },
    ".align-items-md-baseline": {
      alignItems: "baseline !important"
    },
    ".align-items-md-stretch": {
      alignItems: "stretch !important"
    },
    ".align-content-md-start": {
      alignContent: "flex-start !important"
    },
    ".align-content-md-end": {
      alignContent: "flex-end !important"
    },
    ".align-content-md-center": {
      alignContent: "center !important"
    },
    ".align-content-md-between": {
      alignContent: "space-between !important"
    },
    ".align-content-md-around": {
      alignContent: "space-around !important"
    },
    ".align-content-md-stretch": {
      alignContent: "stretch !important"
    },
    ".align-self-md-auto": {
      alignSelf: "auto !important"
    },
    ".align-self-md-start": {
      alignSelf: "flex-start !important"
    },
    ".align-self-md-end": {
      alignSelf: "flex-end !important"
    },
    ".align-self-md-center": {
      alignSelf: "center !important"
    },
    ".align-self-md-baseline": {
      alignSelf: "baseline !important"
    },
    ".align-self-md-stretch": {
      alignSelf: "stretch !important"
    },
    ".float-md-left": {
      cssFloat: "left !important"
    },
    ".float-md-right": {
      cssFloat: "right !important"
    },
    ".float-md-none": {
      cssFloat: "none !important"
    },
    ".m-md-0": {
      margin: "0 !important"
    },
    ".mt-md-0,\n  .my-md-0": {
      marginTop: "0 !important"
    },
    ".mr-md-0,\n  .mx-md-0": {
      marginRight: "0 !important"
    },
    ".mb-md-0,\n  .my-md-0": {
      marginBottom: "0 !important"
    },
    ".ml-md-0,\n  .mx-md-0": {
      marginLeft: "0 !important"
    },
    ".m-md-1": {
      margin: "0.25rem !important"
    },
    ".mt-md-1,\n  .my-md-1": {
      marginTop: "0.25rem !important"
    },
    ".mr-md-1,\n  .mx-md-1": {
      marginRight: "0.25rem !important"
    },
    ".mb-md-1,\n  .my-md-1": {
      marginBottom: "0.25rem !important"
    },
    ".ml-md-1,\n  .mx-md-1": {
      marginLeft: "0.25rem !important"
    },
    ".m-md-2": {
      margin: "0.5rem !important"
    },
    ".mt-md-2,\n  .my-md-2": {
      marginTop: "0.5rem !important"
    },
    ".mr-md-2,\n  .mx-md-2": {
      marginRight: "0.5rem !important"
    },
    ".mb-md-2,\n  .my-md-2": {
      marginBottom: "0.5rem !important"
    },
    ".ml-md-2,\n  .mx-md-2": {
      marginLeft: "0.5rem !important"
    },
    ".m-md-3": {
      margin: "1rem !important"
    },
    ".mt-md-3,\n  .my-md-3": {
      marginTop: "1rem !important"
    },
    ".mr-md-3,\n  .mx-md-3": {
      marginRight: "1rem !important"
    },
    ".mb-md-3,\n  .my-md-3": {
      marginBottom: "1rem !important"
    },
    ".ml-md-3,\n  .mx-md-3": {
      marginLeft: "1rem !important"
    },
    ".m-md-4": {
      margin: "1.5rem !important"
    },
    ".mt-md-4,\n  .my-md-4": {
      marginTop: "1.5rem !important"
    },
    ".mr-md-4,\n  .mx-md-4": {
      marginRight: "1.5rem !important"
    },
    ".mb-md-4,\n  .my-md-4": {
      marginBottom: "1.5rem !important"
    },
    ".ml-md-4,\n  .mx-md-4": {
      marginLeft: "1.5rem !important"
    },
    ".m-md-5": {
      margin: "3rem !important"
    },
    ".mt-md-5,\n  .my-md-5": {
      marginTop: "3rem !important"
    },
    ".mr-md-5,\n  .mx-md-5": {
      marginRight: "3rem !important"
    },
    ".mb-md-5,\n  .my-md-5": {
      marginBottom: "3rem !important"
    },
    ".ml-md-5,\n  .mx-md-5": {
      marginLeft: "3rem !important"
    },
    ".p-md-0": {
      padding: "0 !important"
    },
    ".pt-md-0,\n  .py-md-0": {
      paddingTop: "0 !important"
    },
    ".pr-md-0,\n  .px-md-0": {
      paddingRight: "0 !important"
    },
    ".pb-md-0,\n  .py-md-0": {
      paddingBottom: "0 !important"
    },
    ".pl-md-0,\n  .px-md-0": {
      paddingLeft: "0 !important"
    },
    ".p-md-1": {
      padding: "0.25rem !important"
    },
    ".pt-md-1,\n  .py-md-1": {
      paddingTop: "0.25rem !important"
    },
    ".pr-md-1,\n  .px-md-1": {
      paddingRight: "0.25rem !important"
    },
    ".pb-md-1,\n  .py-md-1": {
      paddingBottom: "0.25rem !important"
    },
    ".pl-md-1,\n  .px-md-1": {
      paddingLeft: "0.25rem !important"
    },
    ".p-md-2": {
      padding: "0.5rem !important"
    },
    ".pt-md-2,\n  .py-md-2": {
      paddingTop: "0.5rem !important"
    },
    ".pr-md-2,\n  .px-md-2": {
      paddingRight: "0.5rem !important"
    },
    ".pb-md-2,\n  .py-md-2": {
      paddingBottom: "0.5rem !important"
    },
    ".pl-md-2,\n  .px-md-2": {
      paddingLeft: "0.5rem !important"
    },
    ".p-md-3": {
      padding: "1rem !important"
    },
    ".pt-md-3,\n  .py-md-3": {
      paddingTop: "1rem !important"
    },
    ".pr-md-3,\n  .px-md-3": {
      paddingRight: "1rem !important"
    },
    ".pb-md-3,\n  .py-md-3": {
      paddingBottom: "1rem !important"
    },
    ".pl-md-3,\n  .px-md-3": {
      paddingLeft: "1rem !important"
    },
    ".p-md-4": {
      padding: "1.5rem !important"
    },
    ".pt-md-4,\n  .py-md-4": {
      paddingTop: "1.5rem !important"
    },
    ".pr-md-4,\n  .px-md-4": {
      paddingRight: "1.5rem !important"
    },
    ".pb-md-4,\n  .py-md-4": {
      paddingBottom: "1.5rem !important"
    },
    ".pl-md-4,\n  .px-md-4": {
      paddingLeft: "1.5rem !important"
    },
    ".p-md-5": {
      padding: "3rem !important"
    },
    ".pt-md-5,\n  .py-md-5": {
      paddingTop: "3rem !important"
    },
    ".pr-md-5,\n  .px-md-5": {
      paddingRight: "3rem !important"
    },
    ".pb-md-5,\n  .py-md-5": {
      paddingBottom: "3rem !important"
    },
    ".pl-md-5,\n  .px-md-5": {
      paddingLeft: "3rem !important"
    },
    ".m-md-n1": {
      margin: "-0.25rem !important"
    },
    ".mt-md-n1,\n  .my-md-n1": {
      marginTop: "-0.25rem !important"
    },
    ".mr-md-n1,\n  .mx-md-n1": {
      marginRight: "-0.25rem !important"
    },
    ".mb-md-n1,\n  .my-md-n1": {
      marginBottom: "-0.25rem !important"
    },
    ".ml-md-n1,\n  .mx-md-n1": {
      marginLeft: "-0.25rem !important"
    },
    ".m-md-n2": {
      margin: "-0.5rem !important"
    },
    ".mt-md-n2,\n  .my-md-n2": {
      marginTop: "-0.5rem !important"
    },
    ".mr-md-n2,\n  .mx-md-n2": {
      marginRight: "-0.5rem !important"
    },
    ".mb-md-n2,\n  .my-md-n2": {
      marginBottom: "-0.5rem !important"
    },
    ".ml-md-n2,\n  .mx-md-n2": {
      marginLeft: "-0.5rem !important"
    },
    ".m-md-n3": {
      margin: "-1rem !important"
    },
    ".mt-md-n3,\n  .my-md-n3": {
      marginTop: "-1rem !important"
    },
    ".mr-md-n3,\n  .mx-md-n3": {
      marginRight: "-1rem !important"
    },
    ".mb-md-n3,\n  .my-md-n3": {
      marginBottom: "-1rem !important"
    },
    ".ml-md-n3,\n  .mx-md-n3": {
      marginLeft: "-1rem !important"
    },
    ".m-md-n4": {
      margin: "-1.5rem !important"
    },
    ".mt-md-n4,\n  .my-md-n4": {
      marginTop: "-1.5rem !important"
    },
    ".mr-md-n4,\n  .mx-md-n4": {
      marginRight: "-1.5rem !important"
    },
    ".mb-md-n4,\n  .my-md-n4": {
      marginBottom: "-1.5rem !important"
    },
    ".ml-md-n4,\n  .mx-md-n4": {
      marginLeft: "-1.5rem !important"
    },
    ".m-md-n5": {
      margin: "-3rem !important"
    },
    ".mt-md-n5,\n  .my-md-n5": {
      marginTop: "-3rem !important"
    },
    ".mr-md-n5,\n  .mx-md-n5": {
      marginRight: "-3rem !important"
    },
    ".mb-md-n5,\n  .my-md-n5": {
      marginBottom: "-3rem !important"
    },
    ".ml-md-n5,\n  .mx-md-n5": {
      marginLeft: "-3rem !important"
    },
    ".m-md-auto": {
      margin: "auto !important"
    },
    ".mt-md-auto,\n  .my-md-auto": {
      marginTop: "auto !important"
    },
    ".mr-md-auto,\n  .mx-md-auto": {
      marginRight: "auto !important"
    },
    ".mb-md-auto,\n  .my-md-auto": {
      marginBottom: "auto !important"
    },
    ".ml-md-auto,\n  .mx-md-auto": {
      marginLeft: "auto !important"
    },
    ".text-md-left": {
      textAlign: "left !important"
    },
    ".text-md-right": {
      textAlign: "right !important"
    },
    ".text-md-center": {
      textAlign: "center !important"
    }
  },
  "@media (min-width: 992px)": {
    ".d-lg-none": {
      display: "none !important"
    },
    ".d-lg-inline": {
      display: "inline !important"
    },
    ".d-lg-inline-block": {
      display: "inline-block !important"
    },
    ".d-lg-block": {
      display: "block !important"
    },
    ".d-lg-table": {
      display: "table !important"
    },
    ".d-lg-table-row": {
      display: "table-row !important"
    },
    ".d-lg-table-cell": {
      display: "table-cell !important"
    },
    ".d-lg-flex": {
      display: "flex !important"
    },
    ".d-lg-inline-flex": {
      display: "inline-flex !important"
    },
    ".flex-lg-row": {
      flexDirection: "row !important"
    },
    ".flex-lg-column": {
      flexDirection: "column !important"
    },
    ".flex-lg-row-reverse": {
      flexDirection: "row-reverse !important"
    },
    ".flex-lg-column-reverse": {
      flexDirection: "column-reverse !important"
    },
    ".flex-lg-wrap": {
      flexWrap: "wrap !important"
    },
    ".flex-lg-nowrap": {
      flexWrap: "nowrap !important"
    },
    ".flex-lg-wrap-reverse": {
      flexWrap: "wrap-reverse !important"
    },
    ".flex-lg-fill": {
      flex: "1 1 auto !important"
    },
    ".flex-lg-grow-0": {
      flexGrow: "0 !important"
    },
    ".flex-lg-grow-1": {
      flexGrow: "1 !important"
    },
    ".flex-lg-shrink-0": {
      flexShrink: "0 !important"
    },
    ".flex-lg-shrink-1": {
      flexShrink: "1 !important"
    },
    ".justify-content-lg-start": {
      justifyContent: "flex-start !important"
    },
    ".justify-content-lg-end": {
      justifyContent: "flex-end !important"
    },
    ".justify-content-lg-center": {
      justifyContent: "center !important"
    },
    ".justify-content-lg-between": {
      justifyContent: "space-between !important"
    },
    ".justify-content-lg-around": {
      justifyContent: "space-around !important"
    },
    ".align-items-lg-start": {
      alignItems: "flex-start !important"
    },
    ".align-items-lg-end": {
      alignItems: "flex-end !important"
    },
    ".align-items-lg-center": {
      alignItems: "center !important"
    },
    ".align-items-lg-baseline": {
      alignItems: "baseline !important"
    },
    ".align-items-lg-stretch": {
      alignItems: "stretch !important"
    },
    ".align-content-lg-start": {
      alignContent: "flex-start !important"
    },
    ".align-content-lg-end": {
      alignContent: "flex-end !important"
    },
    ".align-content-lg-center": {
      alignContent: "center !important"
    },
    ".align-content-lg-between": {
      alignContent: "space-between !important"
    },
    ".align-content-lg-around": {
      alignContent: "space-around !important"
    },
    ".align-content-lg-stretch": {
      alignContent: "stretch !important"
    },
    ".align-self-lg-auto": {
      alignSelf: "auto !important"
    },
    ".align-self-lg-start": {
      alignSelf: "flex-start !important"
    },
    ".align-self-lg-end": {
      alignSelf: "flex-end !important"
    },
    ".align-self-lg-center": {
      alignSelf: "center !important"
    },
    ".align-self-lg-baseline": {
      alignSelf: "baseline !important"
    },
    ".align-self-lg-stretch": {
      alignSelf: "stretch !important"
    },
    ".float-lg-left": {
      cssFloat: "left !important"
    },
    ".float-lg-right": {
      cssFloat: "right !important"
    },
    ".float-lg-none": {
      cssFloat: "none !important"
    },
    ".m-lg-0": {
      margin: "0 !important"
    },
    ".mt-lg-0,\n  .my-lg-0": {
      marginTop: "0 !important"
    },
    ".mr-lg-0,\n  .mx-lg-0": {
      marginRight: "0 !important"
    },
    ".mb-lg-0,\n  .my-lg-0": {
      marginBottom: "0 !important"
    },
    ".ml-lg-0,\n  .mx-lg-0": {
      marginLeft: "0 !important"
    },
    ".m-lg-1": {
      margin: "0.25rem !important"
    },
    ".mt-lg-1,\n  .my-lg-1": {
      marginTop: "0.25rem !important"
    },
    ".mr-lg-1,\n  .mx-lg-1": {
      marginRight: "0.25rem !important"
    },
    ".mb-lg-1,\n  .my-lg-1": {
      marginBottom: "0.25rem !important"
    },
    ".ml-lg-1,\n  .mx-lg-1": {
      marginLeft: "0.25rem !important"
    },
    ".m-lg-2": {
      margin: "0.5rem !important"
    },
    ".mt-lg-2,\n  .my-lg-2": {
      marginTop: "0.5rem !important"
    },
    ".mr-lg-2,\n  .mx-lg-2": {
      marginRight: "0.5rem !important"
    },
    ".mb-lg-2,\n  .my-lg-2": {
      marginBottom: "0.5rem !important"
    },
    ".ml-lg-2,\n  .mx-lg-2": {
      marginLeft: "0.5rem !important"
    },
    ".m-lg-3": {
      margin: "1rem !important"
    },
    ".mt-lg-3,\n  .my-lg-3": {
      marginTop: "1rem !important"
    },
    ".mr-lg-3,\n  .mx-lg-3": {
      marginRight: "1rem !important"
    },
    ".mb-lg-3,\n  .my-lg-3": {
      marginBottom: "1rem !important"
    },
    ".ml-lg-3,\n  .mx-lg-3": {
      marginLeft: "1rem !important"
    },
    ".m-lg-4": {
      margin: "1.5rem !important"
    },
    ".mt-lg-4,\n  .my-lg-4": {
      marginTop: "1.5rem !important"
    },
    ".mr-lg-4,\n  .mx-lg-4": {
      marginRight: "1.5rem !important"
    },
    ".mb-lg-4,\n  .my-lg-4": {
      marginBottom: "1.5rem !important"
    },
    ".ml-lg-4,\n  .mx-lg-4": {
      marginLeft: "1.5rem !important"
    },
    ".m-lg-5": {
      margin: "3rem !important"
    },
    ".mt-lg-5,\n  .my-lg-5": {
      marginTop: "3rem !important"
    },
    ".mr-lg-5,\n  .mx-lg-5": {
      marginRight: "3rem !important"
    },
    ".mb-lg-5,\n  .my-lg-5": {
      marginBottom: "3rem !important"
    },
    ".ml-lg-5,\n  .mx-lg-5": {
      marginLeft: "3rem !important"
    },
    ".p-lg-0": {
      padding: "0 !important"
    },
    ".pt-lg-0,\n  .py-lg-0": {
      paddingTop: "0 !important"
    },
    ".pr-lg-0,\n  .px-lg-0": {
      paddingRight: "0 !important"
    },
    ".pb-lg-0,\n  .py-lg-0": {
      paddingBottom: "0 !important"
    },
    ".pl-lg-0,\n  .px-lg-0": {
      paddingLeft: "0 !important"
    },
    ".p-lg-1": {
      padding: "0.25rem !important"
    },
    ".pt-lg-1,\n  .py-lg-1": {
      paddingTop: "0.25rem !important"
    },
    ".pr-lg-1,\n  .px-lg-1": {
      paddingRight: "0.25rem !important"
    },
    ".pb-lg-1,\n  .py-lg-1": {
      paddingBottom: "0.25rem !important"
    },
    ".pl-lg-1,\n  .px-lg-1": {
      paddingLeft: "0.25rem !important"
    },
    ".p-lg-2": {
      padding: "0.5rem !important"
    },
    ".pt-lg-2,\n  .py-lg-2": {
      paddingTop: "0.5rem !important"
    },
    ".pr-lg-2,\n  .px-lg-2": {
      paddingRight: "0.5rem !important"
    },
    ".pb-lg-2,\n  .py-lg-2": {
      paddingBottom: "0.5rem !important"
    },
    ".pl-lg-2,\n  .px-lg-2": {
      paddingLeft: "0.5rem !important"
    },
    ".p-lg-3": {
      padding: "1rem !important"
    },
    ".pt-lg-3,\n  .py-lg-3": {
      paddingTop: "1rem !important"
    },
    ".pr-lg-3,\n  .px-lg-3": {
      paddingRight: "1rem !important"
    },
    ".pb-lg-3,\n  .py-lg-3": {
      paddingBottom: "1rem !important"
    },
    ".pl-lg-3,\n  .px-lg-3": {
      paddingLeft: "1rem !important"
    },
    ".p-lg-4": {
      padding: "1.5rem !important"
    },
    ".pt-lg-4,\n  .py-lg-4": {
      paddingTop: "1.5rem !important"
    },
    ".pr-lg-4,\n  .px-lg-4": {
      paddingRight: "1.5rem !important"
    },
    ".pb-lg-4,\n  .py-lg-4": {
      paddingBottom: "1.5rem !important"
    },
    ".pl-lg-4,\n  .px-lg-4": {
      paddingLeft: "1.5rem !important"
    },
    ".p-lg-5": {
      padding: "3rem !important"
    },
    ".pt-lg-5,\n  .py-lg-5": {
      paddingTop: "3rem !important"
    },
    ".pr-lg-5,\n  .px-lg-5": {
      paddingRight: "3rem !important"
    },
    ".pb-lg-5,\n  .py-lg-5": {
      paddingBottom: "3rem !important"
    },
    ".pl-lg-5,\n  .px-lg-5": {
      paddingLeft: "3rem !important"
    },
    ".m-lg-n1": {
      margin: "-0.25rem !important"
    },
    ".mt-lg-n1,\n  .my-lg-n1": {
      marginTop: "-0.25rem !important"
    },
    ".mr-lg-n1,\n  .mx-lg-n1": {
      marginRight: "-0.25rem !important"
    },
    ".mb-lg-n1,\n  .my-lg-n1": {
      marginBottom: "-0.25rem !important"
    },
    ".ml-lg-n1,\n  .mx-lg-n1": {
      marginLeft: "-0.25rem !important"
    },
    ".m-lg-n2": {
      margin: "-0.5rem !important"
    },
    ".mt-lg-n2,\n  .my-lg-n2": {
      marginTop: "-0.5rem !important"
    },
    ".mr-lg-n2,\n  .mx-lg-n2": {
      marginRight: "-0.5rem !important"
    },
    ".mb-lg-n2,\n  .my-lg-n2": {
      marginBottom: "-0.5rem !important"
    },
    ".ml-lg-n2,\n  .mx-lg-n2": {
      marginLeft: "-0.5rem !important"
    },
    ".m-lg-n3": {
      margin: "-1rem !important"
    },
    ".mt-lg-n3,\n  .my-lg-n3": {
      marginTop: "-1rem !important"
    },
    ".mr-lg-n3,\n  .mx-lg-n3": {
      marginRight: "-1rem !important"
    },
    ".mb-lg-n3,\n  .my-lg-n3": {
      marginBottom: "-1rem !important"
    },
    ".ml-lg-n3,\n  .mx-lg-n3": {
      marginLeft: "-1rem !important"
    },
    ".m-lg-n4": {
      margin: "-1.5rem !important"
    },
    ".mt-lg-n4,\n  .my-lg-n4": {
      marginTop: "-1.5rem !important"
    },
    ".mr-lg-n4,\n  .mx-lg-n4": {
      marginRight: "-1.5rem !important"
    },
    ".mb-lg-n4,\n  .my-lg-n4": {
      marginBottom: "-1.5rem !important"
    },
    ".ml-lg-n4,\n  .mx-lg-n4": {
      marginLeft: "-1.5rem !important"
    },
    ".m-lg-n5": {
      margin: "-3rem !important"
    },
    ".mt-lg-n5,\n  .my-lg-n5": {
      marginTop: "-3rem !important"
    },
    ".mr-lg-n5,\n  .mx-lg-n5": {
      marginRight: "-3rem !important"
    },
    ".mb-lg-n5,\n  .my-lg-n5": {
      marginBottom: "-3rem !important"
    },
    ".ml-lg-n5,\n  .mx-lg-n5": {
      marginLeft: "-3rem !important"
    },
    ".m-lg-auto": {
      margin: "auto !important"
    },
    ".mt-lg-auto,\n  .my-lg-auto": {
      marginTop: "auto !important"
    },
    ".mr-lg-auto,\n  .mx-lg-auto": {
      marginRight: "auto !important"
    },
    ".mb-lg-auto,\n  .my-lg-auto": {
      marginBottom: "auto !important"
    },
    ".ml-lg-auto,\n  .mx-lg-auto": {
      marginLeft: "auto !important"
    },
    ".text-lg-left": {
      textAlign: "left !important"
    },
    ".text-lg-right": {
      textAlign: "right !important"
    },
    ".text-lg-center": {
      textAlign: "center !important"
    }
  },
  "@media (min-width: 1200px)": {
    ".d-xl-none": {
      display: "none !important"
    },
    ".d-xl-inline": {
      display: "inline !important"
    },
    ".d-xl-inline-block": {
      display: "inline-block !important"
    },
    ".d-xl-block": {
      display: "block !important"
    },
    ".d-xl-table": {
      display: "table !important"
    },
    ".d-xl-table-row": {
      display: "table-row !important"
    },
    ".d-xl-table-cell": {
      display: "table-cell !important"
    },
    ".d-xl-flex": {
      display: "flex !important"
    },
    ".d-xl-inline-flex": {
      display: "inline-flex !important"
    },
    ".flex-xl-row": {
      flexDirection: "row !important"
    },
    ".flex-xl-column": {
      flexDirection: "column !important"
    },
    ".flex-xl-row-reverse": {
      flexDirection: "row-reverse !important"
    },
    ".flex-xl-column-reverse": {
      flexDirection: "column-reverse !important"
    },
    ".flex-xl-wrap": {
      flexWrap: "wrap !important"
    },
    ".flex-xl-nowrap": {
      flexWrap: "nowrap !important"
    },
    ".flex-xl-wrap-reverse": {
      flexWrap: "wrap-reverse !important"
    },
    ".flex-xl-fill": {
      flex: "1 1 auto !important"
    },
    ".flex-xl-grow-0": {
      flexGrow: "0 !important"
    },
    ".flex-xl-grow-1": {
      flexGrow: "1 !important"
    },
    ".flex-xl-shrink-0": {
      flexShrink: "0 !important"
    },
    ".flex-xl-shrink-1": {
      flexShrink: "1 !important"
    },
    ".justify-content-xl-start": {
      justifyContent: "flex-start !important"
    },
    ".justify-content-xl-end": {
      justifyContent: "flex-end !important"
    },
    ".justify-content-xl-center": {
      justifyContent: "center !important"
    },
    ".justify-content-xl-between": {
      justifyContent: "space-between !important"
    },
    ".justify-content-xl-around": {
      justifyContent: "space-around !important"
    },
    ".align-items-xl-start": {
      alignItems: "flex-start !important"
    },
    ".align-items-xl-end": {
      alignItems: "flex-end !important"
    },
    ".align-items-xl-center": {
      alignItems: "center !important"
    },
    ".align-items-xl-baseline": {
      alignItems: "baseline !important"
    },
    ".align-items-xl-stretch": {
      alignItems: "stretch !important"
    },
    ".align-content-xl-start": {
      alignContent: "flex-start !important"
    },
    ".align-content-xl-end": {
      alignContent: "flex-end !important"
    },
    ".align-content-xl-center": {
      alignContent: "center !important"
    },
    ".align-content-xl-between": {
      alignContent: "space-between !important"
    },
    ".align-content-xl-around": {
      alignContent: "space-around !important"
    },
    ".align-content-xl-stretch": {
      alignContent: "stretch !important"
    },
    ".align-self-xl-auto": {
      alignSelf: "auto !important"
    },
    ".align-self-xl-start": {
      alignSelf: "flex-start !important"
    },
    ".align-self-xl-end": {
      alignSelf: "flex-end !important"
    },
    ".align-self-xl-center": {
      alignSelf: "center !important"
    },
    ".align-self-xl-baseline": {
      alignSelf: "baseline !important"
    },
    ".align-self-xl-stretch": {
      alignSelf: "stretch !important"
    },
    ".float-xl-left": {
      cssFloat: "left !important"
    },
    ".float-xl-right": {
      cssFloat: "right !important"
    },
    ".float-xl-none": {
      cssFloat: "none !important"
    },
    ".m-xl-0": {
      margin: "0 !important"
    },
    ".mt-xl-0,\n  .my-xl-0": {
      marginTop: "0 !important"
    },
    ".mr-xl-0,\n  .mx-xl-0": {
      marginRight: "0 !important"
    },
    ".mb-xl-0,\n  .my-xl-0": {
      marginBottom: "0 !important"
    },
    ".ml-xl-0,\n  .mx-xl-0": {
      marginLeft: "0 !important"
    },
    ".m-xl-1": {
      margin: "0.25rem !important"
    },
    ".mt-xl-1,\n  .my-xl-1": {
      marginTop: "0.25rem !important"
    },
    ".mr-xl-1,\n  .mx-xl-1": {
      marginRight: "0.25rem !important"
    },
    ".mb-xl-1,\n  .my-xl-1": {
      marginBottom: "0.25rem !important"
    },
    ".ml-xl-1,\n  .mx-xl-1": {
      marginLeft: "0.25rem !important"
    },
    ".m-xl-2": {
      margin: "0.5rem !important"
    },
    ".mt-xl-2,\n  .my-xl-2": {
      marginTop: "0.5rem !important"
    },
    ".mr-xl-2,\n  .mx-xl-2": {
      marginRight: "0.5rem !important"
    },
    ".mb-xl-2,\n  .my-xl-2": {
      marginBottom: "0.5rem !important"
    },
    ".ml-xl-2,\n  .mx-xl-2": {
      marginLeft: "0.5rem !important"
    },
    ".m-xl-3": {
      margin: "1rem !important"
    },
    ".mt-xl-3,\n  .my-xl-3": {
      marginTop: "1rem !important"
    },
    ".mr-xl-3,\n  .mx-xl-3": {
      marginRight: "1rem !important"
    },
    ".mb-xl-3,\n  .my-xl-3": {
      marginBottom: "1rem !important"
    },
    ".ml-xl-3,\n  .mx-xl-3": {
      marginLeft: "1rem !important"
    },
    ".m-xl-4": {
      margin: "1.5rem !important"
    },
    ".mt-xl-4,\n  .my-xl-4": {
      marginTop: "1.5rem !important"
    },
    ".mr-xl-4,\n  .mx-xl-4": {
      marginRight: "1.5rem !important"
    },
    ".mb-xl-4,\n  .my-xl-4": {
      marginBottom: "1.5rem !important"
    },
    ".ml-xl-4,\n  .mx-xl-4": {
      marginLeft: "1.5rem !important"
    },
    ".m-xl-5": {
      margin: "3rem !important"
    },
    ".mt-xl-5,\n  .my-xl-5": {
      marginTop: "3rem !important"
    },
    ".mr-xl-5,\n  .mx-xl-5": {
      marginRight: "3rem !important"
    },
    ".mb-xl-5,\n  .my-xl-5": {
      marginBottom: "3rem !important"
    },
    ".ml-xl-5,\n  .mx-xl-5": {
      marginLeft: "3rem !important"
    },
    ".p-xl-0": {
      padding: "0 !important"
    },
    ".pt-xl-0,\n  .py-xl-0": {
      paddingTop: "0 !important"
    },
    ".pr-xl-0,\n  .px-xl-0": {
      paddingRight: "0 !important"
    },
    ".pb-xl-0,\n  .py-xl-0": {
      paddingBottom: "0 !important"
    },
    ".pl-xl-0,\n  .px-xl-0": {
      paddingLeft: "0 !important"
    },
    ".p-xl-1": {
      padding: "0.25rem !important"
    },
    ".pt-xl-1,\n  .py-xl-1": {
      paddingTop: "0.25rem !important"
    },
    ".pr-xl-1,\n  .px-xl-1": {
      paddingRight: "0.25rem !important"
    },
    ".pb-xl-1,\n  .py-xl-1": {
      paddingBottom: "0.25rem !important"
    },
    ".pl-xl-1,\n  .px-xl-1": {
      paddingLeft: "0.25rem !important"
    },
    ".p-xl-2": {
      padding: "0.5rem !important"
    },
    ".pt-xl-2,\n  .py-xl-2": {
      paddingTop: "0.5rem !important"
    },
    ".pr-xl-2,\n  .px-xl-2": {
      paddingRight: "0.5rem !important"
    },
    ".pb-xl-2,\n  .py-xl-2": {
      paddingBottom: "0.5rem !important"
    },
    ".pl-xl-2,\n  .px-xl-2": {
      paddingLeft: "0.5rem !important"
    },
    ".p-xl-3": {
      padding: "1rem !important"
    },
    ".pt-xl-3,\n  .py-xl-3": {
      paddingTop: "1rem !important"
    },
    ".pr-xl-3,\n  .px-xl-3": {
      paddingRight: "1rem !important"
    },
    ".pb-xl-3,\n  .py-xl-3": {
      paddingBottom: "1rem !important"
    },
    ".pl-xl-3,\n  .px-xl-3": {
      paddingLeft: "1rem !important"
    },
    ".p-xl-4": {
      padding: "1.5rem !important"
    },
    ".pt-xl-4,\n  .py-xl-4": {
      paddingTop: "1.5rem !important"
    },
    ".pr-xl-4,\n  .px-xl-4": {
      paddingRight: "1.5rem !important"
    },
    ".pb-xl-4,\n  .py-xl-4": {
      paddingBottom: "1.5rem !important"
    },
    ".pl-xl-4,\n  .px-xl-4": {
      paddingLeft: "1.5rem !important"
    },
    ".p-xl-5": {
      padding: "3rem !important"
    },
    ".pt-xl-5,\n  .py-xl-5": {
      paddingTop: "3rem !important"
    },
    ".pr-xl-5,\n  .px-xl-5": {
      paddingRight: "3rem !important"
    },
    ".pb-xl-5,\n  .py-xl-5": {
      paddingBottom: "3rem !important"
    },
    ".pl-xl-5,\n  .px-xl-5": {
      paddingLeft: "3rem !important"
    },
    ".m-xl-n1": {
      margin: "-0.25rem !important"
    },
    ".mt-xl-n1,\n  .my-xl-n1": {
      marginTop: "-0.25rem !important"
    },
    ".mr-xl-n1,\n  .mx-xl-n1": {
      marginRight: "-0.25rem !important"
    },
    ".mb-xl-n1,\n  .my-xl-n1": {
      marginBottom: "-0.25rem !important"
    },
    ".ml-xl-n1,\n  .mx-xl-n1": {
      marginLeft: "-0.25rem !important"
    },
    ".m-xl-n2": {
      margin: "-0.5rem !important"
    },
    ".mt-xl-n2,\n  .my-xl-n2": {
      marginTop: "-0.5rem !important"
    },
    ".mr-xl-n2,\n  .mx-xl-n2": {
      marginRight: "-0.5rem !important"
    },
    ".mb-xl-n2,\n  .my-xl-n2": {
      marginBottom: "-0.5rem !important"
    },
    ".ml-xl-n2,\n  .mx-xl-n2": {
      marginLeft: "-0.5rem !important"
    },
    ".m-xl-n3": {
      margin: "-1rem !important"
    },
    ".mt-xl-n3,\n  .my-xl-n3": {
      marginTop: "-1rem !important"
    },
    ".mr-xl-n3,\n  .mx-xl-n3": {
      marginRight: "-1rem !important"
    },
    ".mb-xl-n3,\n  .my-xl-n3": {
      marginBottom: "-1rem !important"
    },
    ".ml-xl-n3,\n  .mx-xl-n3": {
      marginLeft: "-1rem !important"
    },
    ".m-xl-n4": {
      margin: "-1.5rem !important"
    },
    ".mt-xl-n4,\n  .my-xl-n4": {
      marginTop: "-1.5rem !important"
    },
    ".mr-xl-n4,\n  .mx-xl-n4": {
      marginRight: "-1.5rem !important"
    },
    ".mb-xl-n4,\n  .my-xl-n4": {
      marginBottom: "-1.5rem !important"
    },
    ".ml-xl-n4,\n  .mx-xl-n4": {
      marginLeft: "-1.5rem !important"
    },
    ".m-xl-n5": {
      margin: "-3rem !important"
    },
    ".mt-xl-n5,\n  .my-xl-n5": {
      marginTop: "-3rem !important"
    },
    ".mr-xl-n5,\n  .mx-xl-n5": {
      marginRight: "-3rem !important"
    },
    ".mb-xl-n5,\n  .my-xl-n5": {
      marginBottom: "-3rem !important"
    },
    ".ml-xl-n5,\n  .mx-xl-n5": {
      marginLeft: "-3rem !important"
    },
    ".m-xl-auto": {
      margin: "auto !important"
    },
    ".mt-xl-auto,\n  .my-xl-auto": {
      marginTop: "auto !important"
    },
    ".mr-xl-auto,\n  .mx-xl-auto": {
      marginRight: "auto !important"
    },
    ".mb-xl-auto,\n  .my-xl-auto": {
      marginBottom: "auto !important"
    },
    ".ml-xl-auto,\n  .mx-xl-auto": {
      marginLeft: "auto !important"
    },
    ".text-xl-left": {
      textAlign: "left !important"
    },
    ".text-xl-right": {
      textAlign: "right !important"
    },
    ".text-xl-center": {
      textAlign: "center !important"
    }
  },
  "@media print": {
    ".d-print-none": {
      display: "none !important"
    },
    ".d-print-inline": {
      display: "inline !important"
    },
    ".d-print-inline-block": {
      display: "inline-block !important"
    },
    ".d-print-block": {
      display: "block !important"
    },
    ".d-print-table": {
      display: "table !important"
    },
    ".d-print-table-row": {
      display: "table-row !important"
    },
    ".d-print-table-cell": {
      display: "table-cell !important"
    },
    ".d-print-flex": {
      display: "flex !important"
    },
    ".d-print-inline-flex": {
      display: "inline-flex !important"
    }
  },
  ".embed-responsive": {
    position: "relative",
    display: "block",
    width: "100%",
    padding: "0",
    overflow: "hidden"
  },
  ".embed-responsive::before": {
    display: "block",
    content: '""'
  },
  ".embed-responsive .embed-responsive-item, .embed-responsive iframe, .embed-responsive embed, .embed-responsive object, .embed-responsive video": {
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "0",
    width: "100%",
    height: "100%",
    border: "0"
  },
  ".embed-responsive-21by9::before": {
    paddingTop: "42.8571428571%"
  },
  ".embed-responsive-16by9::before": {
    paddingTop: "56.25%"
  },
  ".embed-responsive-4by3::before": {
    paddingTop: "75%"
  },
  ".embed-responsive-1by1::before": {
    paddingTop: "100%"
  },
  ".flex-row": {
    flexDirection: "row !important"
  },
  ".flex-column": {
    flexDirection: "column !important"
  },
  ".flex-row-reverse": {
    flexDirection: "row-reverse !important"
  },
  ".flex-column-reverse": {
    flexDirection: "column-reverse !important"
  },
  ".flex-wrap": {
    flexWrap: "wrap !important"
  },
  ".flex-nowrap": {
    flexWrap: "nowrap !important"
  },
  ".flex-wrap-reverse": {
    flexWrap: "wrap-reverse !important"
  },
  ".flex-fill": {
    flex: "1 1 auto !important"
  },
  ".flex-grow-0": {
    flexGrow: "0 !important"
  },
  ".flex-grow-1": {
    flexGrow: "1 !important"
  },
  ".flex-shrink-0": {
    flexShrink: "0 !important"
  },
  ".flex-shrink-1": {
    flexShrink: "1 !important"
  },
  ".justify-content-start": {
    justifyContent: "flex-start !important"
  },
  ".justify-content-end": {
    justifyContent: "flex-end !important"
  },
  ".justify-content-center": {
    justifyContent: "center !important"
  },
  ".justify-content-between": {
    justifyContent: "space-between !important"
  },
  ".justify-content-around": {
    justifyContent: "space-around !important"
  },
  ".align-items-start": {
    alignItems: "flex-start !important"
  },
  ".align-items-end": {
    alignItems: "flex-end !important"
  },
  ".align-items-center": {
    alignItems: "center !important"
  },
  ".align-items-baseline": {
    alignItems: "baseline !important"
  },
  ".align-items-stretch": {
    alignItems: "stretch !important"
  },
  ".align-content-start": {
    alignContent: "flex-start !important"
  },
  ".align-content-end": {
    alignContent: "flex-end !important"
  },
  ".align-content-center": {
    alignContent: "center !important"
  },
  ".align-content-between": {
    alignContent: "space-between !important"
  },
  ".align-content-around": {
    alignContent: "space-around !important"
  },
  ".align-content-stretch": {
    alignContent: "stretch !important"
  },
  ".align-self-auto": {
    alignSelf: "auto !important"
  },
  ".align-self-start": {
    alignSelf: "flex-start !important"
  },
  ".align-self-end": {
    alignSelf: "flex-end !important"
  },
  ".align-self-center": {
    alignSelf: "center !important"
  },
  ".align-self-baseline": {
    alignSelf: "baseline !important"
  },
  ".align-self-stretch": {
    alignSelf: "stretch !important"
  },
  ".float-left": {
    cssFloat: "left !important"
  },
  ".float-right": {
    cssFloat: "right !important"
  },
  ".float-none": {
    cssFloat: "none !important"
  },
  ".user-select-all": {
    userSelect: "all !important"
  },
  ".user-select-auto": {
    userSelect: "auto !important"
  },
  ".user-select-none": {
    userSelect: "none !important"
  },
  ".overflow-auto": {
    overflow: "auto !important"
  },
  ".overflow-hidden": {
    overflow: "hidden !important"
  },
  ".position-static": {
    position: "static !important"
  },
  ".position-relative": {
    position: "relative !important"
  },
  ".position-absolute": {
    position: "absolute !important"
  },
  ".position-fixed": {
    position: "fixed !important"
  },
  ".position-sticky": {
    position: "sticky !important"
  },
  ".fixed-top": {
    position: "fixed",
    top: "0",
    right: "0",
    left: "0",
    zIndex: 1030
  },
  ".fixed-bottom": {
    position: "fixed",
    right: "0",
    bottom: "0",
    left: "0",
    zIndex: 1030
  },
  "@supports (position: sticky)": {
    ".sticky-top": {
      position: "sticky",
      top: "0",
      zIndex: 1020
    }
  },
  ".sr-only": {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: "0"
  },
  ".sr-only-focusable:active, .sr-only-focusable:focus": {
    position: "static",
    width: "auto",
    height: "auto",
    overflow: "visible",
    clip: "auto",
    whiteSpace: "normal"
  },
  ".shadow-sm": {
    boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important"
  },
  ".shadow": {
    boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important"
  },
  ".shadow-lg": {
    boxShadow: "0 1rem 3rem rgba(0, 0, 0, 0.175) !important"
  },
  ".shadow-none": {
    boxShadow: "none !important"
  },
  ".w-25": {
    width: "25% !important"
  },
  ".w-50": {
    width: "50% !important"
  },
  ".w-75": {
    width: "75% !important"
  },
  ".w-100": {
    width: "100% !important"
  },
  ".w-auto": {
    width: "auto !important"
  },
  ".h-25": {
    height: "25% !important"
  },
  ".h-50": {
    height: "50% !important"
  },
  ".h-75": {
    height: "75% !important"
  },
  ".h-100": {
    height: "100% !important"
  },
  ".h-auto": {
    height: "auto !important"
  },
  ".mw-100": {
    maxWidth: "100% !important"
  },
  ".mh-100": {
    maxHeight: "100% !important"
  },
  ".min-vw-100": {
    minWidth: "100vw !important"
  },
  ".min-vh-100": {
    minHeight: "100vh !important"
  },
  ".vw-100": {
    width: "100vw !important"
  },
  ".vh-100": {
    height: "100vh !important"
  },
  ".m-0": {
    margin: "0 !important"
  },
  ".mt-0, .my-0": {
    marginTop: "0 !important"
  },
  ".mr-0, .mx-0": {
    marginRight: "0 !important"
  },
  ".mb-0, .my-0": {
    marginBottom: "0 !important"
  },
  ".ml-0, .mx-0": {
    marginLeft: "0 !important"
  },
  ".m-1": {
    margin: "0.25rem !important"
  },
  ".mt-1, .my-1": {
    marginTop: "0.25rem !important"
  },
  ".mr-1, .mx-1": {
    marginRight: "0.25rem !important"
  },
  ".mb-1, .my-1": {
    marginBottom: "0.25rem !important"
  },
  ".ml-1, .mx-1": {
    marginLeft: "0.25rem !important"
  },
  ".m-2": {
    margin: "0.5rem !important"
  },
  ".mt-2, .my-2": {
    marginTop: "0.5rem !important"
  },
  ".mr-2, .mx-2": {
    marginRight: "0.5rem !important"
  },
  ".mb-2, .my-2": {
    marginBottom: "0.5rem !important"
  },
  ".ml-2, .mx-2": {
    marginLeft: "0.5rem !important"
  },
  ".m-3": {
    margin: "1rem !important"
  },
  ".mt-3, .my-3": {
    marginTop: "1rem !important"
  },
  ".mr-3, .mx-3": {
    marginRight: "1rem !important"
  },
  ".mb-3, .my-3": {
    marginBottom: "1rem !important"
  },
  ".ml-3, .mx-3": {
    marginLeft: "1rem !important"
  },
  ".m-4": {
    margin: "1.5rem !important"
  },
  ".mt-4, .my-4": {
    marginTop: "1.5rem !important"
  },
  ".mr-4, .mx-4": {
    marginRight: "1.5rem !important"
  },
  ".mb-4, .my-4": {
    marginBottom: "1.5rem !important"
  },
  ".ml-4, .mx-4": {
    marginLeft: "1.5rem !important"
  },
  ".m-5": {
    margin: "3rem !important"
  },
  ".mt-5, .my-5": {
    marginTop: "3rem !important"
  },
  ".mr-5, .mx-5": {
    marginRight: "3rem !important"
  },
  ".mb-5, .my-5": {
    marginBottom: "3rem !important"
  },
  ".ml-5, .mx-5": {
    marginLeft: "3rem !important"
  },
  ".p-0": {
    padding: "0 !important"
  },
  ".pt-0, .py-0": {
    paddingTop: "0 !important"
  },
  ".pr-0, .px-0": {
    paddingRight: "0 !important"
  },
  ".pb-0, .py-0": {
    paddingBottom: "0 !important"
  },
  ".pl-0, .px-0": {
    paddingLeft: "0 !important"
  },
  ".p-1": {
    padding: "0.25rem !important"
  },
  ".pt-1, .py-1": {
    paddingTop: "0.25rem !important"
  },
  ".pr-1, .px-1": {
    paddingRight: "0.25rem !important"
  },
  ".pb-1, .py-1": {
    paddingBottom: "0.25rem !important"
  },
  ".pl-1, .px-1": {
    paddingLeft: "0.25rem !important"
  },
  ".p-2": {
    padding: "0.5rem !important"
  },
  ".pt-2, .py-2": {
    paddingTop: "0.5rem !important"
  },
  ".pr-2, .px-2": {
    paddingRight: "0.5rem !important"
  },
  ".pb-2, .py-2": {
    paddingBottom: "0.5rem !important"
  },
  ".pl-2, .px-2": {
    paddingLeft: "0.5rem !important"
  },
  ".p-3": {
    padding: "1rem !important"
  },
  ".pt-3, .py-3": {
    paddingTop: "1rem !important"
  },
  ".pr-3, .px-3": {
    paddingRight: "1rem !important"
  },
  ".pb-3, .py-3": {
    paddingBottom: "1rem !important"
  },
  ".pl-3, .px-3": {
    paddingLeft: "1rem !important"
  },
  ".p-4": {
    padding: "1.5rem !important"
  },
  ".pt-4, .py-4": {
    paddingTop: "1.5rem !important"
  },
  ".pr-4, .px-4": {
    paddingRight: "1.5rem !important"
  },
  ".pb-4, .py-4": {
    paddingBottom: "1.5rem !important"
  },
  ".pl-4, .px-4": {
    paddingLeft: "1.5rem !important"
  },
  ".p-5": {
    padding: "3rem !important"
  },
  ".pt-5, .py-5": {
    paddingTop: "3rem !important"
  },
  ".pr-5, .px-5": {
    paddingRight: "3rem !important"
  },
  ".pb-5, .py-5": {
    paddingBottom: "3rem !important"
  },
  ".pl-5, .px-5": {
    paddingLeft: "3rem !important"
  },
  ".m-n1": {
    margin: "-0.25rem !important"
  },
  ".mt-n1, .my-n1": {
    marginTop: "-0.25rem !important"
  },
  ".mr-n1, .mx-n1": {
    marginRight: "-0.25rem !important"
  },
  ".mb-n1, .my-n1": {
    marginBottom: "-0.25rem !important"
  },
  ".ml-n1, .mx-n1": {
    marginLeft: "-0.25rem !important"
  },
  ".m-n2": {
    margin: "-0.5rem !important"
  },
  ".mt-n2, .my-n2": {
    marginTop: "-0.5rem !important"
  },
  ".mr-n2, .mx-n2": {
    marginRight: "-0.5rem !important"
  },
  ".mb-n2, .my-n2": {
    marginBottom: "-0.5rem !important"
  },
  ".ml-n2, .mx-n2": {
    marginLeft: "-0.5rem !important"
  },
  ".m-n3": {
    margin: "-1rem !important"
  },
  ".mt-n3, .my-n3": {
    marginTop: "-1rem !important"
  },
  ".mr-n3, .mx-n3": {
    marginRight: "-1rem !important"
  },
  ".mb-n3, .my-n3": {
    marginBottom: "-1rem !important"
  },
  ".ml-n3, .mx-n3": {
    marginLeft: "-1rem !important"
  },
  ".m-n4": {
    margin: "-1.5rem !important"
  },
  ".mt-n4, .my-n4": {
    marginTop: "-1.5rem !important"
  },
  ".mr-n4, .mx-n4": {
    marginRight: "-1.5rem !important"
  },
  ".mb-n4, .my-n4": {
    marginBottom: "-1.5rem !important"
  },
  ".ml-n4, .mx-n4": {
    marginLeft: "-1.5rem !important"
  },
  ".m-n5": {
    margin: "-3rem !important"
  },
  ".mt-n5, .my-n5": {
    marginTop: "-3rem !important"
  },
  ".mr-n5, .mx-n5": {
    marginRight: "-3rem !important"
  },
  ".mb-n5, .my-n5": {
    marginBottom: "-3rem !important"
  },
  ".ml-n5, .mx-n5": {
    marginLeft: "-3rem !important"
  },
  ".m-auto": {
    margin: "auto !important"
  },
  ".mt-auto, .my-auto": {
    marginTop: "auto !important"
  },
  ".mr-auto, .mx-auto": {
    marginRight: "auto !important"
  },
  ".mb-auto, .my-auto": {
    marginBottom: "auto !important"
  },
  ".ml-auto, .mx-auto": {
    marginLeft: "auto !important"
  },
  ".stretched-link::after": {
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    zIndex: 1,
    pointerEvents: "auto",
    content: '""',
    backgroundColor: "rgba(0, 0, 0, 0)"
  },
  ".text-monospace": {
    fontFamily: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important'
  },
  ".text-justify": {
    textAlign: "justify !important"
  },
  ".text-wrap": {
    whiteSpace: "normal !important"
  },
  ".text-nowrap": {
    whiteSpace: "nowrap !important"
  },
  ".text-truncate": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  ".text-left": {
    textAlign: "left !important"
  },
  ".text-right": {
    textAlign: "right !important"
  },
  ".text-center": {
    textAlign: "center !important"
  },
  ".text-lowercase": {
    textTransform: "lowercase !important"
  },
  ".text-uppercase": {
    textTransform: "uppercase !important"
  },
  ".text-capitalize": {
    textTransform: "capitalize !important"
  },
  ".font-weight-light": {
    fontWeight: "300 !important"
  },
  ".font-weight-lighter": {
    fontWeight: "lighter !important"
  },
  ".font-weight-normal": {
    fontWeight: "400 !important"
  },
  ".font-weight-bold": {
    fontWeight: "700 !important"
  },
  ".font-weight-bolder": {
    fontWeight: "bolder !important"
  },
  ".font-italic": {
    fontStyle: "italic !important"
  },
  ".text-white": {
    color: "#ffffff !important"
  },
  ".text-primary": {
    color: "#186ade !important"
  },
  "a.text-primary:hover, a.text-primary:focus": {
    color: "#114999 !important"
  },
  ".text-secondary": {
    color: "#c1ccd6 !important"
  },
  "a.text-secondary:hover, a.text-secondary:focus": {
    color: "#93a6b8 !important"
  },
  ".text-success": {
    color: "#077d55 !important"
  },
  "a.text-success:hover, a.text-success:focus": {
    color: "#033524 !important"
  },
  ".text-info": {
    color: "#186ade !important"
  },
  "a.text-info:hover, a.text-info:focus": {
    color: "#114999 !important"
  },
  ".text-warning": {
    color: "#f5c518 !important"
  },
  "a.text-warning:hover, a.text-warning:focus": {
    color: "#b99208 !important"
  },
  ".text-danger": {
    color: "#d91f11 !important"
  },
  "a.text-danger:hover, a.text-danger:focus": {
    color: "#92150b !important"
  },
  ".text-light": {
    color: "#ffffff !important"
  },
  "a.text-light:hover, a.text-light:focus": {
    color: "#d9d9d9 !important"
  },
  ".text-dark": {
    color: "#1c2b36 !important"
  },
  "a.text-dark:hover, a.text-dark:focus": {
    color: "#020304 !important"
  },
  ".text-body": {
    color: "#0e171f !important"
  },
  ".text-muted": {
    color: "#5b7282 !important"
  },
  ".text-black-50": {
    color: "rgba(0, 0, 0, 0.5) !important"
  },
  ".text-white-50": {
    color: "rgba(255, 255, 255, 0.5) !important"
  },
  ".text-hide": {
    font: "0/0 a",
    color: "transparent",
    textShadow: "none",
    backgroundColor: "transparent",
    border: "0"
  },
  ".text-decoration-none": {
    textDecoration: "none !important"
  },
  ".text-break": {
    wordBreak: "break-word !important",
    overflowWrap: "break-word !important"
  },
  ".text-reset": {
    color: "inherit !important"
  },
  ".visible": {
    visibility: "visible !important"
  },
  ".invisible": {
    visibility: "hidden !important"
  },
  ".gs-uitk-bg-red-010": {
    backgroundColor: "#fcf0f0 !important"
  },
  "a.gs-uitk-bg-red-010:hover, a.gs-uitk-bg-red-010:focus, button.gs-uitk-bg-red-010:hover, button.gs-uitk-bg-red-010:focus": {
    backgroundColor: "#f4c6c6 !important"
  },
  ".gs-uitk-text-red-010": {
    color: "#fcf0f0 !important"
  },
  "a.gs-uitk-text-red-010:hover, a.gs-uitk-text-red-010:focus": {
    color: "#efb0b0 !important"
  },
  ".gs-uitk-bg-red-020": {
    backgroundColor: "#fadcd9 !important"
  },
  "a.gs-uitk-bg-red-020:hover, a.gs-uitk-bg-red-020:focus, button.gs-uitk-bg-red-020:hover, button.gs-uitk-bg-red-020:focus": {
    backgroundColor: "#f4b2ac !important"
  },
  ".gs-uitk-text-red-020": {
    color: "#fadcd9 !important"
  },
  "a.gs-uitk-text-red-020:hover, a.gs-uitk-text-red-020:focus": {
    color: "#f19e95 !important"
  },
  ".gs-uitk-bg-red-030": {
    backgroundColor: "#fabbb4 !important"
  },
  "a.gs-uitk-bg-red-030:hover, a.gs-uitk-bg-red-030:focus, button.gs-uitk-bg-red-030:hover, button.gs-uitk-bg-red-030:focus": {
    backgroundColor: "#f79084 !important"
  },
  ".gs-uitk-text-red-030": {
    color: "#fabbb4 !important"
  },
  "a.gs-uitk-text-red-030:hover, a.gs-uitk-text-red-030:focus": {
    color: "#f57a6c !important"
  },
  ".gs-uitk-bg-red-040": {
    backgroundColor: "#fc9086 !important"
  },
  "a.gs-uitk-bg-red-040:hover, a.gs-uitk-bg-red-040:focus, button.gs-uitk-bg-red-040:hover, button.gs-uitk-bg-red-040:focus": {
    backgroundColor: "#fb6254 !important"
  },
  ".gs-uitk-text-red-040": {
    color: "#fc9086 !important"
  },
  "a.gs-uitk-text-red-040:hover, a.gs-uitk-text-red-040:focus": {
    color: "#fa4c3b !important"
  },
  ".gs-uitk-bg-red-050": {
    backgroundColor: "#fa5343 !important"
  },
  "a.gs-uitk-bg-red-050:hover, a.gs-uitk-bg-red-050:focus, button.gs-uitk-bg-red-050:hover, button.gs-uitk-bg-red-050:focus": {
    backgroundColor: "#f92611 !important"
  },
  ".gs-uitk-text-red-050": {
    color: "#fa5343 !important"
  },
  "a.gs-uitk-text-red-050:hover, a.gs-uitk-text-red-050:focus": {
    color: "#ea1a06 !important"
  },
  ".gs-uitk-bg-red-060": {
    backgroundColor: "#d91f11 !important"
  },
  "a.gs-uitk-bg-red-060:hover, a.gs-uitk-bg-red-060:focus, button.gs-uitk-bg-red-060:hover, button.gs-uitk-bg-red-060:focus": {
    backgroundColor: "#aa180d !important"
  },
  ".gs-uitk-text-red-060": {
    color: "#d91f11 !important"
  },
  "a.gs-uitk-text-red-060:hover, a.gs-uitk-text-red-060:focus": {
    color: "#92150b !important"
  },
  ".gs-uitk-bg-red-070": {
    backgroundColor: "#a1160a !important"
  },
  "a.gs-uitk-bg-red-070:hover, a.gs-uitk-bg-red-070:focus, button.gs-uitk-bg-red-070:hover, button.gs-uitk-bg-red-070:focus": {
    backgroundColor: "#710f07 !important"
  },
  ".gs-uitk-text-red-070": {
    color: "#a1160a !important"
  },
  "a.gs-uitk-text-red-070:hover, a.gs-uitk-text-red-070:focus": {
    color: "#590c06 !important"
  },
  ".gs-uitk-bg-red-080": {
    backgroundColor: "#75160c !important"
  },
  "a.gs-uitk-bg-red-080:hover, a.gs-uitk-bg-red-080:focus, button.gs-uitk-bg-red-080:hover, button.gs-uitk-bg-red-080:focus": {
    backgroundColor: "#470d07 !important"
  },
  ".gs-uitk-text-red-080": {
    color: "#75160c !important"
  },
  "a.gs-uitk-text-red-080:hover, a.gs-uitk-text-red-080:focus": {
    color: "#300905 !important"
  },
  ".gs-uitk-bg-red-090": {
    backgroundColor: "#4f150f !important"
  },
  "a.gs-uitk-bg-red-090:hover, a.gs-uitk-bg-red-090:focus, button.gs-uitk-bg-red-090:hover, button.gs-uitk-bg-red-090:focus": {
    backgroundColor: "#240a07 !important"
  },
  ".gs-uitk-text-red-090": {
    color: "#4f150f !important"
  },
  "a.gs-uitk-text-red-090:hover, a.gs-uitk-text-red-090:focus": {
    color: "#0f0403 !important"
  },
  ".gs-uitk-bg-red-100": {
    backgroundColor: "#24120c !important"
  },
  "a.gs-uitk-bg-red-100:hover, a.gs-uitk-bg-red-100:focus, button.gs-uitk-bg-red-100:hover, button.gs-uitk-bg-red-100:focus": {
    backgroundColor: "black !important"
  },
  ".gs-uitk-text-red-100": {
    color: "#24120c !important"
  },
  "a.gs-uitk-text-red-100:hover, a.gs-uitk-text-red-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-orange-010": {
    backgroundColor: "#fcf2eb !important"
  },
  "a.gs-uitk-bg-orange-010:hover, a.gs-uitk-bg-orange-010:focus, button.gs-uitk-bg-orange-010:hover, button.gs-uitk-bg-orange-010:focus": {
    backgroundColor: "#f5d5bf !important"
  },
  ".gs-uitk-text-orange-010": {
    color: "#fcf2eb !important"
  },
  "a.gs-uitk-text-orange-010:hover, a.gs-uitk-text-orange-010:focus": {
    color: "#f2c7a8 !important"
  },
  ".gs-uitk-bg-orange-020": {
    backgroundColor: "#fcddc7 !important"
  },
  "a.gs-uitk-bg-orange-020:hover, a.gs-uitk-bg-orange-020:focus, button.gs-uitk-bg-orange-020:hover, button.gs-uitk-bg-orange-020:focus": {
    backgroundColor: "#f9c097 !important"
  },
  ".gs-uitk-text-orange-020": {
    color: "#fcddc7 !important"
  },
  "a.gs-uitk-text-orange-020:hover, a.gs-uitk-text-orange-020:focus": {
    color: "#f8b17e !important"
  },
  ".gs-uitk-bg-orange-030": {
    backgroundColor: "#fcbc97 !important"
  },
  "a.gs-uitk-bg-orange-030:hover, a.gs-uitk-bg-orange-030:focus, button.gs-uitk-bg-orange-030:hover, button.gs-uitk-bg-orange-030:focus": {
    backgroundColor: "#fb9c65 !important"
  },
  ".gs-uitk-text-orange-030": {
    color: "#fcbc97 !important"
  },
  "a.gs-uitk-text-orange-030:hover, a.gs-uitk-text-orange-030:focus": {
    color: "#fa8c4d !important"
  },
  ".gs-uitk-bg-orange-040": {
    backgroundColor: "#fc9162 !important"
  },
  "a.gs-uitk-bg-orange-040:hover, a.gs-uitk-bg-orange-040:focus, button.gs-uitk-bg-orange-040:hover, button.gs-uitk-bg-orange-040:focus": {
    backgroundColor: "#fb6e30 !important"
  },
  ".gs-uitk-text-orange-040": {
    color: "#fc9162 !important"
  },
  "a.gs-uitk-text-orange-040:hover, a.gs-uitk-text-orange-040:focus": {
    color: "#fb5c17 !important"
  },
  ".gs-uitk-bg-orange-050": {
    backgroundColor: "#e86427 !important"
  },
  "a.gs-uitk-bg-orange-050:hover, a.gs-uitk-bg-orange-050:focus, button.gs-uitk-bg-orange-050:hover, button.gs-uitk-bg-orange-050:focus": {
    backgroundColor: "#c74d15 !important"
  },
  ".gs-uitk-text-orange-050": {
    color: "#e86427 !important"
  },
  "a.gs-uitk-text-orange-050:hover, a.gs-uitk-text-orange-050:focus": {
    color: "#b04413 !important"
  },
  ".gs-uitk-bg-orange-060": {
    backgroundColor: "#bf4815 !important"
  },
  "a.gs-uitk-bg-orange-060:hover, a.gs-uitk-bg-orange-060:focus, button.gs-uitk-bg-orange-060:hover, button.gs-uitk-bg-orange-060:focus": {
    backgroundColor: "#913710 !important"
  },
  ".gs-uitk-text-orange-060": {
    color: "#bf4815 !important"
  },
  "a.gs-uitk-text-orange-060:hover, a.gs-uitk-text-orange-060:focus": {
    color: "#7a2e0d !important"
  },
  ".gs-uitk-bg-orange-070": {
    backgroundColor: "#8f3415 !important"
  },
  "a.gs-uitk-bg-orange-070:hover, a.gs-uitk-bg-orange-070:focus, button.gs-uitk-bg-orange-070:hover, button.gs-uitk-bg-orange-070:focus": {
    backgroundColor: "#63240e !important"
  },
  ".gs-uitk-text-orange-070": {
    color: "#8f3415 !important"
  },
  "a.gs-uitk-text-orange-070:hover, a.gs-uitk-text-orange-070:focus": {
    color: "#4c1c0b !important"
  },
  ".gs-uitk-bg-orange-080": {
    backgroundColor: "#632b17 !important"
  },
  "a.gs-uitk-bg-orange-080:hover, a.gs-uitk-bg-orange-080:focus, button.gs-uitk-bg-orange-080:hover, button.gs-uitk-bg-orange-080:focus": {
    backgroundColor: "#3a190d !important"
  },
  ".gs-uitk-text-orange-080": {
    color: "#632b17 !important"
  },
  "a.gs-uitk-text-orange-080:hover, a.gs-uitk-text-orange-080:focus": {
    color: "#251009 !important"
  },
  ".gs-uitk-bg-orange-090": {
    backgroundColor: "#402117 !important"
  },
  "a.gs-uitk-bg-orange-090:hover, a.gs-uitk-bg-orange-090:focus, button.gs-uitk-bg-orange-090:hover, button.gs-uitk-bg-orange-090:focus": {
    backgroundColor: "#1a0e0a !important"
  },
  ".gs-uitk-text-orange-090": {
    color: "#402117 !important"
  },
  "a.gs-uitk-text-orange-090:hover, a.gs-uitk-text-orange-090:focus": {
    color: "#080403 !important"
  },
  ".gs-uitk-bg-orange-100": {
    backgroundColor: "#1f1410 !important"
  },
  "a.gs-uitk-bg-orange-100:hover, a.gs-uitk-bg-orange-100:focus, button.gs-uitk-bg-orange-100:hover, button.gs-uitk-bg-orange-100:focus": {
    backgroundColor: "black !important"
  },
  ".gs-uitk-text-orange-100": {
    color: "#1f1410 !important"
  },
  "a.gs-uitk-text-orange-100:hover, a.gs-uitk-text-orange-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-yellow-010": {
    backgroundColor: "#faf6cf !important"
  },
  "a.gs-uitk-bg-yellow-010:hover, a.gs-uitk-bg-yellow-010:focus, button.gs-uitk-bg-yellow-010:hover, button.gs-uitk-bg-yellow-010:focus": {
    backgroundColor: "#f5eda1 !important"
  },
  ".gs-uitk-text-yellow-010": {
    color: "#faf6cf !important"
  },
  "a.gs-uitk-text-yellow-010:hover, a.gs-uitk-text-yellow-010:focus": {
    color: "#f3e98a !important"
  },
  ".gs-uitk-bg-yellow-020": {
    backgroundColor: "#f7e379 !important"
  },
  "a.gs-uitk-bg-yellow-020:hover, a.gs-uitk-bg-yellow-020:focus, button.gs-uitk-bg-yellow-020:hover, button.gs-uitk-bg-yellow-020:focus": {
    backgroundColor: "#f4d949 !important"
  },
  ".gs-uitk-text-yellow-020": {
    color: "#f7e379 !important"
  },
  "a.gs-uitk-text-yellow-020:hover, a.gs-uitk-text-yellow-020:focus": {
    color: "#f3d431 !important"
  },
  ".gs-uitk-bg-yellow-030": {
    backgroundColor: "#f5c518 !important"
  },
  "a.gs-uitk-bg-yellow-030:hover, a.gs-uitk-bg-yellow-030:focus, button.gs-uitk-bg-yellow-030:hover, button.gs-uitk-bg-yellow-030:focus": {
    backgroundColor: "#d1a609 !important"
  },
  ".gs-uitk-text-yellow-030": {
    color: "#f5c518 !important"
  },
  "a.gs-uitk-text-yellow-030:hover, a.gs-uitk-text-yellow-030:focus": {
    color: "#b99208 !important"
  },
  ".gs-uitk-bg-yellow-040": {
    backgroundColor: "#d9a514 !important"
  },
  "a.gs-uitk-bg-yellow-040:hover, a.gs-uitk-bg-yellow-040:focus, button.gs-uitk-bg-yellow-040:hover, button.gs-uitk-bg-yellow-040:focus": {
    backgroundColor: "#aa8110 !important"
  },
  ".gs-uitk-text-yellow-040": {
    color: "#d9a514 !important"
  },
  "a.gs-uitk-text-yellow-040:hover, a.gs-uitk-text-yellow-040:focus": {
    color: "#93700e !important"
  },
  ".gs-uitk-bg-yellow-050": {
    backgroundColor: "#b3870e !important"
  },
  "a.gs-uitk-bg-yellow-050:hover, a.gs-uitk-bg-yellow-050:focus, button.gs-uitk-bg-yellow-050:hover, button.gs-uitk-bg-yellow-050:focus": {
    backgroundColor: "#84630a !important"
  },
  ".gs-uitk-text-yellow-050": {
    color: "#b3870e !important"
  },
  "a.gs-uitk-text-yellow-050:hover, a.gs-uitk-text-yellow-050:focus": {
    color: "#6c5108 !important"
  },
  ".gs-uitk-bg-yellow-060": {
    backgroundColor: "#946613 !important"
  },
  "a.gs-uitk-bg-yellow-060:hover, a.gs-uitk-bg-yellow-060:focus, button.gs-uitk-bg-yellow-060:hover, button.gs-uitk-bg-yellow-060:focus": {
    backgroundColor: "#67470d !important"
  },
  ".gs-uitk-text-yellow-060": {
    color: "#946613 !important"
  },
  "a.gs-uitk-text-yellow-060:hover, a.gs-uitk-text-yellow-060:focus": {
    color: "#50370a !important"
  },
  ".gs-uitk-bg-yellow-070": {
    backgroundColor: "#70491c !important"
  },
  "a.gs-uitk-bg-yellow-070:hover, a.gs-uitk-bg-yellow-070:focus, button.gs-uitk-bg-yellow-070:hover, button.gs-uitk-bg-yellow-070:focus": {
    backgroundColor: "#472e12 !important"
  },
  ".gs-uitk-text-yellow-070": {
    color: "#70491c !important"
  },
  "a.gs-uitk-text-yellow-070:hover, a.gs-uitk-text-yellow-070:focus": {
    color: "#33210d !important"
  },
  ".gs-uitk-bg-yellow-080": {
    backgroundColor: "#54341f !important"
  },
  "a.gs-uitk-bg-yellow-080:hover, a.gs-uitk-bg-yellow-080:focus, button.gs-uitk-bg-yellow-080:hover, button.gs-uitk-bg-yellow-080:focus": {
    backgroundColor: "#2f1d11 !important"
  },
  ".gs-uitk-text-yellow-080": {
    color: "#54341f !important"
  },
  "a.gs-uitk-text-yellow-080:hover, a.gs-uitk-text-yellow-080:focus": {
    color: "#1c110a !important"
  },
  ".gs-uitk-bg-yellow-090": {
    backgroundColor: "#38251b !important"
  },
  "a.gs-uitk-bg-yellow-090:hover, a.gs-uitk-bg-yellow-090:focus, button.gs-uitk-bg-yellow-090:hover, button.gs-uitk-bg-yellow-090:focus": {
    backgroundColor: "#160e0a !important"
  },
  ".gs-uitk-text-yellow-090": {
    color: "#38251b !important"
  },
  "a.gs-uitk-text-yellow-090:hover, a.gs-uitk-text-yellow-090:focus": {
    color: "#040302 !important"
  },
  ".gs-uitk-bg-yellow-100": {
    backgroundColor: "#1c1613 !important"
  },
  "a.gs-uitk-bg-yellow-100:hover, a.gs-uitk-bg-yellow-100:focus, button.gs-uitk-bg-yellow-100:hover, button.gs-uitk-bg-yellow-100:focus": {
    backgroundColor: "black !important"
  },
  ".gs-uitk-text-yellow-100": {
    color: "#1c1613 !important"
  },
  "a.gs-uitk-text-yellow-100:hover, a.gs-uitk-text-yellow-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-lime-010": {
    backgroundColor: "#ebf7da !important"
  },
  "a.gs-uitk-bg-lime-010:hover, a.gs-uitk-bg-lime-010:focus, button.gs-uitk-bg-lime-010:hover, button.gs-uitk-bg-lime-010:focus": {
    backgroundColor: "#d4eeb0 !important"
  },
  ".gs-uitk-text-lime-010": {
    color: "#ebf7da !important"
  },
  "a.gs-uitk-text-lime-010:hover, a.gs-uitk-text-lime-010:focus": {
    color: "#c9e99b !important"
  },
  ".gs-uitk-bg-lime-020": {
    backgroundColor: "#d5f0b1 !important"
  },
  "a.gs-uitk-bg-lime-020:hover, a.gs-uitk-bg-lime-020:focus, button.gs-uitk-bg-lime-020:hover, button.gs-uitk-bg-lime-020:focus": {
    backgroundColor: "#bee886 !important"
  },
  ".gs-uitk-text-lime-020": {
    color: "#d5f0b1 !important"
  },
  "a.gs-uitk-text-lime-020:hover, a.gs-uitk-text-lime-020:focus": {
    color: "#b2e471 !important"
  },
  ".gs-uitk-bg-lime-030": {
    backgroundColor: "#aad971 !important"
  },
  "a.gs-uitk-bg-lime-030:hover, a.gs-uitk-bg-lime-030:focus, button.gs-uitk-bg-lime-030:hover, button.gs-uitk-bg-lime-030:focus": {
    backgroundColor: "#92ce49 !important"
  },
  ".gs-uitk-text-lime-030": {
    color: "#aad971 !important"
  },
  "a.gs-uitk-text-lime-030:hover, a.gs-uitk-text-lime-030:focus": {
    color: "#86c836 !important"
  },
  ".gs-uitk-bg-lime-040": {
    backgroundColor: "#78bf39 !important"
  },
  "a.gs-uitk-bg-lime-040:hover, a.gs-uitk-bg-lime-040:focus, button.gs-uitk-bg-lime-040:hover, button.gs-uitk-bg-lime-040:focus": {
    backgroundColor: "#5f982d !important"
  },
  ".gs-uitk-text-lime-040": {
    color: "#78bf39 !important"
  },
  "a.gs-uitk-text-lime-040:hover, a.gs-uitk-text-lime-040:focus": {
    color: "#538427 !important"
  },
  ".gs-uitk-bg-lime-050": {
    backgroundColor: "#52a31d !important"
  },
  "a.gs-uitk-bg-lime-050:hover, a.gs-uitk-bg-lime-050:focus, button.gs-uitk-bg-lime-050:hover, button.gs-uitk-bg-lime-050:focus": {
    backgroundColor: "#3c7815 !important"
  },
  ".gs-uitk-text-lime-050": {
    color: "#52a31d !important"
  },
  "a.gs-uitk-text-lime-050:hover, a.gs-uitk-text-lime-050:focus": {
    color: "#316211 !important"
  },
  ".gs-uitk-bg-lime-060": {
    backgroundColor: "#3c7d0e !important"
  },
  "a.gs-uitk-bg-lime-060:hover, a.gs-uitk-bg-lime-060:focus, button.gs-uitk-bg-lime-060:hover, button.gs-uitk-bg-lime-060:focus": {
    backgroundColor: "#264f09 !important"
  },
  ".gs-uitk-text-lime-060": {
    color: "#3c7d0e !important"
  },
  "a.gs-uitk-text-lime-060:hover, a.gs-uitk-text-lime-060:focus": {
    color: "#1b3806 !important"
  },
  ".gs-uitk-bg-lime-070": {
    backgroundColor: "#2e5c0e !important"
  },
  "a.gs-uitk-bg-lime-070:hover, a.gs-uitk-bg-lime-070:focus, button.gs-uitk-bg-lime-070:hover, button.gs-uitk-bg-lime-070:focus": {
    backgroundColor: "#183007 !important"
  },
  ".gs-uitk-text-lime-070": {
    color: "#2e5c0e !important"
  },
  "a.gs-uitk-text-lime-070:hover, a.gs-uitk-text-lime-070:focus": {
    color: "#0d1a04 !important"
  },
  ".gs-uitk-bg-lime-080": {
    backgroundColor: "#254211 !important"
  },
  "a.gs-uitk-bg-lime-080:hover, a.gs-uitk-bg-lime-080:focus, button.gs-uitk-bg-lime-080:hover, button.gs-uitk-bg-lime-080:focus": {
    backgroundColor: "#0e1907 !important"
  },
  ".gs-uitk-text-lime-080": {
    color: "#254211 !important"
  },
  "a.gs-uitk-text-lime-080:hover, a.gs-uitk-text-lime-080:focus": {
    color: "#030501 !important"
  },
  ".gs-uitk-bg-lime-090": {
    backgroundColor: "#1c2e10 !important"
  },
  "a.gs-uitk-bg-lime-090:hover, a.gs-uitk-bg-lime-090:focus, button.gs-uitk-bg-lime-090:hover, button.gs-uitk-bg-lime-090:focus": {
    backgroundColor: "#050803 !important"
  },
  ".gs-uitk-text-lime-090": {
    color: "#1c2e10 !important"
  },
  "a.gs-uitk-text-lime-090:hover, a.gs-uitk-text-lime-090:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-lime-100": {
    backgroundColor: "#121a0d !important"
  },
  "a.gs-uitk-bg-lime-100:hover, a.gs-uitk-bg-lime-100:focus, button.gs-uitk-bg-lime-100:hover, button.gs-uitk-bg-lime-100:focus": {
    backgroundColor: "black !important"
  },
  ".gs-uitk-text-lime-100": {
    color: "#121a0d !important"
  },
  "a.gs-uitk-text-lime-100:hover, a.gs-uitk-text-lime-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-green-010": {
    backgroundColor: "#ebf7ed !important"
  },
  "a.gs-uitk-bg-green-010:hover, a.gs-uitk-bg-green-010:focus, button.gs-uitk-bg-green-010:hover, button.gs-uitk-bg-green-010:focus": {
    backgroundColor: "#c7e8cc !important"
  },
  ".gs-uitk-text-green-010": {
    color: "#ebf7ed !important"
  },
  "a.gs-uitk-text-green-010:hover, a.gs-uitk-text-green-010:focus": {
    color: "#b4e1bc !important"
  },
  ".gs-uitk-bg-green-020": {
    backgroundColor: "#c7ebd1 !important"
  },
  "a.gs-uitk-bg-green-020:hover, a.gs-uitk-bg-green-020:focus, button.gs-uitk-bg-green-020:hover, button.gs-uitk-bg-green-020:focus": {
    backgroundColor: "#a1deb2 !important"
  },
  ".gs-uitk-text-green-020": {
    color: "#c7ebd1 !important"
  },
  "a.gs-uitk-text-green-020:hover, a.gs-uitk-text-green-020:focus": {
    color: "#8fd7a3 !important"
  },
  ".gs-uitk-bg-green-030": {
    backgroundColor: "#88dba8 !important"
  },
  "a.gs-uitk-bg-green-030:hover, a.gs-uitk-bg-green-030:focus, button.gs-uitk-bg-green-030:hover, button.gs-uitk-bg-green-030:focus": {
    backgroundColor: "#61cf8b !important"
  },
  ".gs-uitk-text-green-030": {
    color: "#88dba8 !important"
  },
  "a.gs-uitk-text-green-030:hover, a.gs-uitk-text-green-030:focus": {
    color: "#4dc97d !important"
  },
  ".gs-uitk-bg-green-040": {
    backgroundColor: "#43c478 !important"
  },
  "a.gs-uitk-bg-green-040:hover, a.gs-uitk-bg-green-040:focus, button.gs-uitk-bg-green-040:hover, button.gs-uitk-bg-green-040:focus": {
    backgroundColor: "#33a160 !important"
  },
  ".gs-uitk-text-green-040": {
    color: "#43c478 !important"
  },
  "a.gs-uitk-text-green-040:hover, a.gs-uitk-text-green-040:focus": {
    color: "#2d8e55 !important"
  },
  ".gs-uitk-bg-green-050": {
    backgroundColor: "#16a163 !important"
  },
  "a.gs-uitk-bg-green-050:hover, a.gs-uitk-bg-green-050:focus, button.gs-uitk-bg-green-050:hover, button.gs-uitk-bg-green-050:focus": {
    backgroundColor: "#107447 !important"
  },
  ".gs-uitk-text-green-050": {
    color: "#16a163 !important"
  },
  "a.gs-uitk-text-green-050:hover, a.gs-uitk-text-green-050:focus": {
    color: "#0d5e3a !important"
  },
  ".gs-uitk-bg-green-060": {
    backgroundColor: "#077d55 !important"
  },
  "a.gs-uitk-bg-green-060:hover, a.gs-uitk-bg-green-060:focus, button.gs-uitk-bg-green-060:hover, button.gs-uitk-bg-green-060:focus": {
    backgroundColor: "#044d34 !important"
  },
  ".gs-uitk-text-green-060": {
    color: "#077d55 !important"
  },
  "a.gs-uitk-text-green-060:hover, a.gs-uitk-text-green-060:focus": {
    color: "#033524 !important"
  },
  ".gs-uitk-bg-green-070": {
    backgroundColor: "#075e45 !important"
  },
  "a.gs-uitk-bg-green-070:hover, a.gs-uitk-bg-green-070:focus, button.gs-uitk-bg-green-070:hover, button.gs-uitk-bg-green-070:focus": {
    backgroundColor: "#032f22 !important"
  },
  ".gs-uitk-text-green-070": {
    color: "#075e45 !important"
  },
  "a.gs-uitk-text-green-070:hover, a.gs-uitk-text-green-070:focus": {
    color: "#021711 !important"
  },
  ".gs-uitk-bg-green-080": {
    backgroundColor: "#094536 !important"
  },
  "a.gs-uitk-bg-green-080:hover, a.gs-uitk-bg-green-080:focus, button.gs-uitk-bg-green-080:hover, button.gs-uitk-bg-green-080:focus": {
    backgroundColor: "#031813 !important"
  },
  ".gs-uitk-text-green-080": {
    color: "#094536 !important"
  },
  "a.gs-uitk-text-green-080:hover, a.gs-uitk-text-green-080:focus": {
    color: "#000101 !important"
  },
  ".gs-uitk-bg-green-090": {
    backgroundColor: "#092e25 !important"
  },
  "a.gs-uitk-bg-green-090:hover, a.gs-uitk-bg-green-090:focus, button.gs-uitk-bg-green-090:hover, button.gs-uitk-bg-green-090:focus": {
    backgroundColor: "#010303 !important"
  },
  ".gs-uitk-text-green-090": {
    color: "#092e25 !important"
  },
  "a.gs-uitk-text-green-090:hover, a.gs-uitk-text-green-090:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-green-100": {
    backgroundColor: "#081a15 !important"
  },
  "a.gs-uitk-bg-green-100:hover, a.gs-uitk-bg-green-100:focus, button.gs-uitk-bg-green-100:hover, button.gs-uitk-bg-green-100:focus": {
    backgroundColor: "black !important"
  },
  ".gs-uitk-text-green-100": {
    color: "#081a15 !important"
  },
  "a.gs-uitk-text-green-100:hover, a.gs-uitk-text-green-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-teal-010": {
    backgroundColor: "#ebf5f4 !important"
  },
  "a.gs-uitk-bg-teal-010:hover, a.gs-uitk-bg-teal-010:focus, button.gs-uitk-bg-teal-010:hover, button.gs-uitk-bg-teal-010:focus": {
    backgroundColor: "#c9e4e1 !important"
  },
  ".gs-uitk-text-teal-010": {
    color: "#ebf5f4 !important"
  },
  "a.gs-uitk-text-teal-010:hover, a.gs-uitk-text-teal-010:focus": {
    color: "#b8dcd8 !important"
  },
  ".gs-uitk-bg-teal-020": {
    backgroundColor: "#beebe7 !important"
  },
  "a.gs-uitk-bg-teal-020:hover, a.gs-uitk-bg-teal-020:focus, button.gs-uitk-bg-teal-020:hover, button.gs-uitk-bg-teal-020:focus": {
    backgroundColor: "#97dfd9 !important"
  },
  ".gs-uitk-text-teal-020": {
    color: "#beebe7 !important"
  },
  "a.gs-uitk-text-teal-020:hover, a.gs-uitk-text-teal-020:focus": {
    color: "#84d9d1 !important"
  },
  ".gs-uitk-bg-teal-030": {
    backgroundColor: "#86d9d4 !important"
  },
  "a.gs-uitk-bg-teal-030:hover, a.gs-uitk-bg-teal-030:focus, button.gs-uitk-bg-teal-030:hover, button.gs-uitk-bg-teal-030:focus": {
    backgroundColor: "#5fcdc6 !important"
  },
  ".gs-uitk-text-teal-030": {
    color: "#86d9d4 !important"
  },
  "a.gs-uitk-text-teal-030:hover, a.gs-uitk-text-teal-030:focus": {
    color: "#4cc7bf !important"
  },
  ".gs-uitk-bg-teal-040": {
    backgroundColor: "#4ebfb9 !important"
  },
  "a.gs-uitk-bg-teal-040:hover, a.gs-uitk-bg-teal-040:focus, button.gs-uitk-bg-teal-040:hover, button.gs-uitk-bg-teal-040:focus": {
    backgroundColor: "#3aa09b !important"
  },
  ".gs-uitk-text-teal-040": {
    color: "#4ebfb9 !important"
  },
  "a.gs-uitk-text-teal-040:hover, a.gs-uitk-text-teal-040:focus": {
    color: "#338d89 !important"
  },
  ".gs-uitk-bg-teal-050": {
    backgroundColor: "#279c9c !important"
  },
  "a.gs-uitk-bg-teal-050:hover, a.gs-uitk-bg-teal-050:focus, button.gs-uitk-bg-teal-050:hover, button.gs-uitk-bg-teal-050:focus": {
    backgroundColor: "#1d7373 !important"
  },
  ".gs-uitk-text-teal-050": {
    color: "#279c9c !important"
  },
  "a.gs-uitk-text-teal-050:hover, a.gs-uitk-text-teal-050:focus": {
    color: "#185f5f !important"
  },
  ".gs-uitk-bg-teal-060": {
    backgroundColor: "#167b7d !important"
  },
  "a.gs-uitk-bg-teal-060:hover, a.gs-uitk-bg-teal-060:focus, button.gs-uitk-bg-teal-060:hover, button.gs-uitk-bg-teal-060:focus": {
    backgroundColor: "#0e5052 !important"
  },
  ".gs-uitk-text-teal-060": {
    color: "#167b7d !important"
  },
  "a.gs-uitk-text-teal-060:hover, a.gs-uitk-text-teal-060:focus": {
    color: "#0b3b3c !important"
  },
  ".gs-uitk-bg-teal-070": {
    backgroundColor: "#155c5e !important"
  },
  "a.gs-uitk-bg-teal-070:hover, a.gs-uitk-bg-teal-070:focus, button.gs-uitk-bg-teal-070:hover, button.gs-uitk-bg-teal-070:focus": {
    backgroundColor: "#0c3334 !important"
  },
  ".gs-uitk-text-teal-070": {
    color: "#155c5e !important"
  },
  "a.gs-uitk-text-teal-070:hover, a.gs-uitk-text-teal-070:focus": {
    color: "#071f1f !important"
  },
  ".gs-uitk-bg-teal-080": {
    backgroundColor: "#124241 !important"
  },
  "a.gs-uitk-bg-teal-080:hover, a.gs-uitk-bg-teal-080:focus, button.gs-uitk-bg-teal-080:hover, button.gs-uitk-bg-teal-080:focus": {
    backgroundColor: "#071a1a !important"
  },
  ".gs-uitk-text-teal-080": {
    color: "#124241 !important"
  },
  "a.gs-uitk-text-teal-080:hover, a.gs-uitk-text-teal-080:focus": {
    color: "#020606 !important"
  },
  ".gs-uitk-bg-teal-090": {
    backgroundColor: "#102e2d !important"
  },
  "a.gs-uitk-bg-teal-090:hover, a.gs-uitk-bg-teal-090:focus, button.gs-uitk-bg-teal-090:hover, button.gs-uitk-bg-teal-090:focus": {
    backgroundColor: "#030808 !important"
  },
  ".gs-uitk-text-teal-090": {
    color: "#102e2d !important"
  },
  "a.gs-uitk-text-teal-090:hover, a.gs-uitk-text-teal-090:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-teal-100": {
    backgroundColor: "#0c1a19 !important"
  },
  "a.gs-uitk-bg-teal-100:hover, a.gs-uitk-bg-teal-100:focus, button.gs-uitk-bg-teal-100:hover, button.gs-uitk-bg-teal-100:focus": {
    backgroundColor: "black !important"
  },
  ".gs-uitk-text-teal-100": {
    color: "#0c1a19 !important"
  },
  "a.gs-uitk-text-teal-100:hover, a.gs-uitk-text-teal-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-turquoise-010": {
    backgroundColor: "#ebf5f4 !important"
  },
  "a.gs-uitk-bg-turquoise-010:hover, a.gs-uitk-bg-turquoise-010:focus, button.gs-uitk-bg-turquoise-010:hover, button.gs-uitk-bg-turquoise-010:focus": {
    backgroundColor: "#c9e4e1 !important"
  },
  ".gs-uitk-text-turquoise-010": {
    color: "#ebf5f4 !important"
  },
  "a.gs-uitk-text-turquoise-010:hover, a.gs-uitk-text-turquoise-010:focus": {
    color: "#b8dcd8 !important"
  },
  ".gs-uitk-bg-turquoise-020": {
    backgroundColor: "#c7e8ed !important"
  },
  "a.gs-uitk-bg-turquoise-020:hover, a.gs-uitk-bg-turquoise-020:focus, button.gs-uitk-bg-turquoise-020:hover, button.gs-uitk-bg-turquoise-020:focus": {
    backgroundColor: "#a0d8e1 !important"
  },
  ".gs-uitk-text-turquoise-020": {
    color: "#c7e8ed !important"
  },
  "a.gs-uitk-text-turquoise-020:hover, a.gs-uitk-text-turquoise-020:focus": {
    color: "#8dd0da !important"
  },
  ".gs-uitk-bg-turquoise-030": {
    backgroundColor: "#81d8e6 !important"
  },
  "a.gs-uitk-bg-turquoise-030:hover, a.gs-uitk-bg-turquoise-030:focus, button.gs-uitk-bg-turquoise-030:hover, button.gs-uitk-bg-turquoise-030:focus": {
    backgroundColor: "#56cbde !important"
  },
  ".gs-uitk-text-turquoise-030": {
    color: "#81d8e6 !important"
  },
  "a.gs-uitk-text-turquoise-030:hover, a.gs-uitk-text-turquoise-030:focus": {
    color: "#41c4d9 !important"
  },
  ".gs-uitk-bg-turquoise-040": {
    backgroundColor: "#45bcd1 !important"
  },
  "a.gs-uitk-bg-turquoise-040:hover, a.gs-uitk-bg-turquoise-040:focus, button.gs-uitk-bg-turquoise-040:hover, button.gs-uitk-bg-turquoise-040:focus": {
    backgroundColor: "#2da1b6 !important"
  },
  ".gs-uitk-text-turquoise-040": {
    color: "#45bcd1 !important"
  },
  "a.gs-uitk-text-turquoise-040:hover, a.gs-uitk-text-turquoise-040:focus": {
    color: "#288fa2 !important"
  },
  ".gs-uitk-bg-turquoise-050": {
    backgroundColor: "#159ab3 !important"
  },
  "a.gs-uitk-bg-turquoise-050:hover, a.gs-uitk-bg-turquoise-050:focus, button.gs-uitk-bg-turquoise-050:hover, button.gs-uitk-bg-turquoise-050:focus": {
    backgroundColor: "#107385 !important"
  },
  ".gs-uitk-text-turquoise-050": {
    color: "#159ab3 !important"
  },
  "a.gs-uitk-text-turquoise-050:hover, a.gs-uitk-text-turquoise-050:focus": {
    color: "#0d5f6f !important"
  },
  ".gs-uitk-bg-turquoise-060": {
    backgroundColor: "#067a91 !important"
  },
  "a.gs-uitk-bg-turquoise-060:hover, a.gs-uitk-bg-turquoise-060:focus, button.gs-uitk-bg-turquoise-060:hover, button.gs-uitk-bg-turquoise-060:focus": {
    backgroundColor: "#045160 !important"
  },
  ".gs-uitk-text-turquoise-060": {
    color: "#067a91 !important"
  },
  "a.gs-uitk-text-turquoise-060:hover, a.gs-uitk-text-turquoise-060:focus": {
    color: "#033c48 !important"
  },
  ".gs-uitk-bg-turquoise-070": {
    backgroundColor: "#09596b !important"
  },
  "a.gs-uitk-bg-turquoise-070:hover, a.gs-uitk-bg-turquoise-070:focus, button.gs-uitk-bg-turquoise-070:hover, button.gs-uitk-bg-turquoise-070:focus": {
    backgroundColor: "#05323c !important"
  },
  ".gs-uitk-text-turquoise-070": {
    color: "#09596b !important"
  },
  "a.gs-uitk-text-turquoise-070:hover, a.gs-uitk-text-turquoise-070:focus": {
    color: "#031e24 !important"
  },
  ".gs-uitk-bg-turquoise-080": {
    backgroundColor: "#0c424d !important"
  },
  "a.gs-uitk-bg-turquoise-080:hover, a.gs-uitk-bg-turquoise-080:focus, button.gs-uitk-bg-turquoise-080:hover, button.gs-uitk-bg-turquoise-080:focus": {
    backgroundColor: "#051c21 !important"
  },
  ".gs-uitk-text-turquoise-080": {
    color: "#0c424d !important"
  },
  "a.gs-uitk-text-turquoise-080:hover, a.gs-uitk-text-turquoise-080:focus": {
    color: "#02090b !important"
  },
  ".gs-uitk-bg-turquoise-090": {
    backgroundColor: "#102d33 !important"
  },
  "a.gs-uitk-bg-turquoise-090:hover, a.gs-uitk-bg-turquoise-090:focus, button.gs-uitk-bg-turquoise-090:hover, button.gs-uitk-bg-turquoise-090:focus": {
    backgroundColor: "#040b0c !important"
  },
  ".gs-uitk-text-turquoise-090": {
    color: "#102d33 !important"
  },
  "a.gs-uitk-text-turquoise-090:hover, a.gs-uitk-text-turquoise-090:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-turquoise-100": {
    backgroundColor: "#0f181a !important"
  },
  "a.gs-uitk-bg-turquoise-100:hover, a.gs-uitk-bg-turquoise-100:focus, button.gs-uitk-bg-turquoise-100:hover, button.gs-uitk-bg-turquoise-100:focus": {
    backgroundColor: "black !important"
  },
  ".gs-uitk-text-turquoise-100": {
    color: "#0f181a !important"
  },
  "a.gs-uitk-text-turquoise-100:hover, a.gs-uitk-text-turquoise-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-aqua-010": {
    backgroundColor: "#ebf3f7 !important"
  },
  "a.gs-uitk-bg-aqua-010:hover, a.gs-uitk-bg-aqua-010:focus, button.gs-uitk-bg-aqua-010:hover, button.gs-uitk-bg-aqua-010:focus": {
    backgroundColor: "#c7dde8 !important"
  },
  ".gs-uitk-text-aqua-010": {
    color: "#ebf3f7 !important"
  },
  "a.gs-uitk-text-aqua-010:hover, a.gs-uitk-text-aqua-010:focus": {
    color: "#b4d2e1 !important"
  },
  ".gs-uitk-bg-aqua-020": {
    backgroundColor: "#c9e7f5 !important"
  },
  "a.gs-uitk-bg-aqua-020:hover, a.gs-uitk-bg-aqua-020:focus, button.gs-uitk-bg-aqua-020:hover, button.gs-uitk-bg-aqua-020:focus": {
    backgroundColor: "#9ed4ed !important"
  },
  ".gs-uitk-text-aqua-020": {
    color: "#c9e7f5 !important"
  },
  "a.gs-uitk-text-aqua-020:hover, a.gs-uitk-text-aqua-020:focus": {
    color: "#88cae9 !important"
  },
  ".gs-uitk-bg-aqua-030": {
    backgroundColor: "#8bd3f7 !important"
  },
  "a.gs-uitk-bg-aqua-030:hover, a.gs-uitk-bg-aqua-030:focus, button.gs-uitk-bg-aqua-030:hover, button.gs-uitk-bg-aqua-030:focus": {
    backgroundColor: "#5bc1f4 !important"
  },
  ".gs-uitk-text-aqua-030": {
    color: "#8bd3f7 !important"
  },
  "a.gs-uitk-text-aqua-030:hover, a.gs-uitk-text-aqua-030:focus": {
    color: "#43b8f2 !important"
  },
  ".gs-uitk-bg-aqua-040": {
    backgroundColor: "#48b8f0 !important"
  },
  "a.gs-uitk-bg-aqua-040:hover, a.gs-uitk-bg-aqua-040:focus, button.gs-uitk-bg-aqua-040:hover, button.gs-uitk-bg-aqua-040:focus": {
    backgroundColor: "#19a6ec !important"
  },
  ".gs-uitk-text-aqua-040": {
    color: "#48b8f0 !important"
  },
  "a.gs-uitk-text-aqua-040:hover, a.gs-uitk-text-aqua-040:focus": {
    color: "#1297da !important"
  },
  ".gs-uitk-bg-aqua-050": {
    backgroundColor: "#1195d6 !important"
  },
  "a.gs-uitk-bg-aqua-050:hover, a.gs-uitk-bg-aqua-050:focus, button.gs-uitk-bg-aqua-050:hover, button.gs-uitk-bg-aqua-050:focus": {
    backgroundColor: "#0d74a7 !important"
  },
  ".gs-uitk-text-aqua-050": {
    color: "#1195d6 !important"
  },
  "a.gs-uitk-text-aqua-050:hover, a.gs-uitk-text-aqua-050:focus": {
    color: "#0b648f !important"
  },
  ".gs-uitk-bg-aqua-060": {
    backgroundColor: "#0073ba !important"
  },
  "a.gs-uitk-bg-aqua-060:hover, a.gs-uitk-bg-aqua-060:focus, button.gs-uitk-bg-aqua-060:hover, button.gs-uitk-bg-aqua-060:focus": {
    backgroundColor: "#005387 !important"
  },
  ".gs-uitk-text-aqua-060": {
    color: "#0073ba !important"
  },
  "a.gs-uitk-text-aqua-060:hover, a.gs-uitk-text-aqua-060:focus": {
    color: "#00446e !important"
  },
  ".gs-uitk-bg-aqua-070": {
    backgroundColor: "#08548a !important"
  },
  "a.gs-uitk-bg-aqua-070:hover, a.gs-uitk-bg-aqua-070:focus, button.gs-uitk-bg-aqua-070:hover, button.gs-uitk-bg-aqua-070:focus": {
    backgroundColor: "#05375a !important"
  },
  ".gs-uitk-text-aqua-070": {
    color: "#08548a !important"
  },
  "a.gs-uitk-text-aqua-070:hover, a.gs-uitk-text-aqua-070:focus": {
    color: "#042842 !important"
  },
  ".gs-uitk-bg-aqua-080": {
    backgroundColor: "#0e3d66 !important"
  },
  "a.gs-uitk-bg-aqua-080:hover, a.gs-uitk-bg-aqua-080:focus, button.gs-uitk-bg-aqua-080:hover, button.gs-uitk-bg-aqua-080:focus": {
    backgroundColor: "#082239 !important"
  },
  ".gs-uitk-text-aqua-080": {
    color: "#0e3d66 !important"
  },
  "a.gs-uitk-text-aqua-080:hover, a.gs-uitk-text-aqua-080:focus": {
    color: "#051523 !important"
  },
  ".gs-uitk-bg-aqua-090": {
    backgroundColor: "#0c2b45 !important"
  },
  "a.gs-uitk-bg-aqua-090:hover, a.gs-uitk-bg-aqua-090:focus, button.gs-uitk-bg-aqua-090:hover, button.gs-uitk-bg-aqua-090:focus": {
    backgroundColor: "#04101a !important"
  },
  ".gs-uitk-text-aqua-090": {
    color: "#0c2b45 !important"
  },
  "a.gs-uitk-text-aqua-090:hover, a.gs-uitk-text-aqua-090:focus": {
    color: "#010204 !important"
  },
  ".gs-uitk-bg-aqua-100": {
    backgroundColor: "#0b1724 !important"
  },
  "a.gs-uitk-bg-aqua-100:hover, a.gs-uitk-bg-aqua-100:focus, button.gs-uitk-bg-aqua-100:hover, button.gs-uitk-bg-aqua-100:focus": {
    backgroundColor: "black !important"
  },
  ".gs-uitk-text-aqua-100": {
    color: "#0b1724 !important"
  },
  "a.gs-uitk-text-aqua-100:hover, a.gs-uitk-text-aqua-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-blue-010": {
    backgroundColor: "#f0f4fa !important"
  },
  "a.gs-uitk-bg-blue-010:hover, a.gs-uitk-bg-blue-010:focus, button.gs-uitk-bg-blue-010:hover, button.gs-uitk-bg-blue-010:focus": {
    backgroundColor: "#cad8ed !important"
  },
  ".gs-uitk-text-blue-010": {
    color: "#f0f4fa !important"
  },
  "a.gs-uitk-text-blue-010:hover, a.gs-uitk-text-blue-010:focus": {
    color: "#b7cae7 !important"
  },
  ".gs-uitk-bg-blue-020": {
    backgroundColor: "#d4e4fa !important"
  },
  "a.gs-uitk-bg-blue-020:hover, a.gs-uitk-bg-blue-020:focus, button.gs-uitk-bg-blue-020:hover, button.gs-uitk-bg-blue-020:focus": {
    backgroundColor: "#a6c7f5 !important"
  },
  ".gs-uitk-text-blue-020": {
    color: "#d4e4fa !important"
  },
  "a.gs-uitk-text-blue-020:hover, a.gs-uitk-text-blue-020:focus": {
    color: "#8fb9f2 !important"
  },
  ".gs-uitk-bg-blue-030": {
    backgroundColor: "#adccf7 !important"
  },
  "a.gs-uitk-bg-blue-030:hover, a.gs-uitk-bg-blue-030:focus, button.gs-uitk-bg-blue-030:hover, button.gs-uitk-bg-blue-030:focus": {
    backgroundColor: "#7faff2 !important"
  },
  ".gs-uitk-text-blue-030": {
    color: "#adccf7 !important"
  },
  "a.gs-uitk-text-blue-030:hover, a.gs-uitk-text-blue-030:focus": {
    color: "#67a1f0 !important"
  },
  ".gs-uitk-bg-blue-040": {
    backgroundColor: "#75b1ff !important"
  },
  "a.gs-uitk-bg-blue-040:hover, a.gs-uitk-bg-blue-040:focus, button.gs-uitk-bg-blue-040:hover, button.gs-uitk-bg-blue-040:focus": {
    backgroundColor: "#4294ff !important"
  },
  ".gs-uitk-text-blue-040": {
    color: "#75b1ff !important"
  },
  "a.gs-uitk-text-blue-040:hover, a.gs-uitk-text-blue-040:focus": {
    color: "#2986ff !important"
  },
  ".gs-uitk-bg-blue-050": {
    backgroundColor: "#3d8df5 !important"
  },
  "a.gs-uitk-bg-blue-050:hover, a.gs-uitk-bg-blue-050:focus, button.gs-uitk-bg-blue-050:hover, button.gs-uitk-bg-blue-050:focus": {
    backgroundColor: "#0d71f3 !important"
  },
  ".gs-uitk-text-blue-050": {
    color: "#3d8df5 !important"
  },
  "a.gs-uitk-text-blue-050:hover, a.gs-uitk-text-blue-050:focus": {
    color: "#0b65da !important"
  },
  ".gs-uitk-bg-blue-060": {
    backgroundColor: "#186ade !important"
  },
  "a.gs-uitk-bg-blue-060:hover, a.gs-uitk-bg-blue-060:focus, button.gs-uitk-bg-blue-060:hover, button.gs-uitk-bg-blue-060:focus": {
    backgroundColor: "#1354b0 !important"
  },
  ".gs-uitk-text-blue-060": {
    color: "#186ade !important"
  },
  "a.gs-uitk-text-blue-060:hover, a.gs-uitk-text-blue-060:focus": {
    color: "#114999 !important"
  },
  ".gs-uitk-bg-blue-070": {
    backgroundColor: "#0d4ea6 !important"
  },
  "a.gs-uitk-bg-blue-070:hover, a.gs-uitk-bg-blue-070:focus, button.gs-uitk-bg-blue-070:hover, button.gs-uitk-bg-blue-070:focus": {
    backgroundColor: "#093877 !important"
  },
  ".gs-uitk-text-blue-070": {
    color: "#0d4ea6 !important"
  },
  "a.gs-uitk-text-blue-070:hover, a.gs-uitk-text-blue-070:focus": {
    color: "#072d5f !important"
  },
  ".gs-uitk-bg-blue-080": {
    backgroundColor: "#103a75 !important"
  },
  "a.gs-uitk-bg-blue-080:hover, a.gs-uitk-bg-blue-080:focus, button.gs-uitk-bg-blue-080:hover, button.gs-uitk-bg-blue-080:focus": {
    backgroundColor: "#0a2448 !important"
  },
  ".gs-uitk-text-blue-080": {
    color: "#103a75 !important"
  },
  "a.gs-uitk-text-blue-080:hover, a.gs-uitk-text-blue-080:focus": {
    color: "#071932 !important"
  },
  ".gs-uitk-bg-blue-090": {
    backgroundColor: "#11294d !important"
  },
  "a.gs-uitk-bg-blue-090:hover, a.gs-uitk-bg-blue-090:focus, button.gs-uitk-bg-blue-090:hover, button.gs-uitk-bg-blue-090:focus": {
    backgroundColor: "#081323 !important"
  },
  ".gs-uitk-text-blue-090": {
    color: "#11294d !important"
  },
  "a.gs-uitk-text-blue-090:hover, a.gs-uitk-text-blue-090:focus": {
    color: "#03080e !important"
  },
  ".gs-uitk-bg-blue-100": {
    backgroundColor: "#0d1826 !important"
  },
  "a.gs-uitk-bg-blue-100:hover, a.gs-uitk-bg-blue-100:focus, button.gs-uitk-bg-blue-100:hover, button.gs-uitk-bg-blue-100:focus": {
    backgroundColor: "black !important"
  },
  ".gs-uitk-text-blue-100": {
    color: "#0d1826 !important"
  },
  "a.gs-uitk-text-blue-100:hover, a.gs-uitk-text-blue-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-ultramarine-010": {
    backgroundColor: "#f2f3fa !important"
  },
  "a.gs-uitk-bg-ultramarine-010:hover, a.gs-uitk-bg-ultramarine-010:focus, button.gs-uitk-bg-ultramarine-010:hover, button.gs-uitk-bg-ultramarine-010:focus": {
    backgroundColor: "#cdd1ec !important"
  },
  ".gs-uitk-text-ultramarine-010": {
    color: "#f2f3fa !important"
  },
  "a.gs-uitk-text-ultramarine-010:hover, a.gs-uitk-text-ultramarine-010:focus": {
    color: "#bbc0e5 !important"
  },
  ".gs-uitk-bg-ultramarine-020": {
    backgroundColor: "#dee0fa !important"
  },
  "a.gs-uitk-bg-ultramarine-020:hover, a.gs-uitk-bg-ultramarine-020:focus, button.gs-uitk-bg-ultramarine-020:hover, button.gs-uitk-bg-ultramarine-020:focus": {
    backgroundColor: "#b2b6f3 !important"
  },
  ".gs-uitk-text-ultramarine-020": {
    color: "#dee0fa !important"
  },
  "a.gs-uitk-text-ultramarine-020:hover, a.gs-uitk-text-ultramarine-020:focus": {
    color: "#9ca2f0 !important"
  },
  ".gs-uitk-bg-ultramarine-030": {
    backgroundColor: "#c2c7fc !important"
  },
  "a.gs-uitk-bg-ultramarine-030:hover, a.gs-uitk-bg-ultramarine-030:focus, button.gs-uitk-bg-ultramarine-030:hover, button.gs-uitk-bg-ultramarine-030:focus": {
    backgroundColor: "#919afa !important"
  },
  ".gs-uitk-text-ultramarine-030": {
    color: "#c2c7fc !important"
  },
  "a.gs-uitk-text-ultramarine-030:hover, a.gs-uitk-text-ultramarine-030:focus": {
    color: "#7984f8 !important"
  },
  ".gs-uitk-bg-ultramarine-040": {
    backgroundColor: "#a0a7fa !important"
  },
  "a.gs-uitk-bg-ultramarine-040:hover, a.gs-uitk-bg-ultramarine-040:focus, button.gs-uitk-bg-ultramarine-040:hover, button.gs-uitk-bg-ultramarine-040:focus": {
    backgroundColor: "#707af7 !important"
  },
  ".gs-uitk-text-ultramarine-040": {
    color: "#a0a7fa !important"
  },
  "a.gs-uitk-text-ultramarine-040:hover, a.gs-uitk-text-ultramarine-040:focus": {
    color: "#5764f6 !important"
  },
  ".gs-uitk-bg-ultramarine-050": {
    backgroundColor: "#7681fc !important"
  },
  "a.gs-uitk-bg-ultramarine-050:hover, a.gs-uitk-bg-ultramarine-050:focus, button.gs-uitk-bg-ultramarine-050:hover, button.gs-uitk-bg-ultramarine-050:focus": {
    backgroundColor: "#4453fb !important"
  },
  ".gs-uitk-text-ultramarine-050": {
    color: "#7681fc !important"
  },
  "a.gs-uitk-text-ultramarine-050:hover, a.gs-uitk-text-ultramarine-050:focus": {
    color: "#2b3cfa !important"
  },
  ".gs-uitk-bg-ultramarine-060": {
    backgroundColor: "#545fe8 !important"
  },
  "a.gs-uitk-bg-ultramarine-060:hover, a.gs-uitk-bg-ultramarine-060:focus, button.gs-uitk-bg-ultramarine-060:hover, button.gs-uitk-bg-ultramarine-060:focus": {
    backgroundColor: "#2735e2 !important"
  },
  ".gs-uitk-text-ultramarine-060": {
    color: "#545fe8 !important"
  },
  "a.gs-uitk-text-ultramarine-060:hover, a.gs-uitk-text-ultramarine-060:focus": {
    color: "#1c2ad3 !important"
  },
  ".gs-uitk-bg-ultramarine-070": {
    backgroundColor: "#3a45b0 !important"
  },
  "a.gs-uitk-bg-ultramarine-070:hover, a.gs-uitk-bg-ultramarine-070:focus, button.gs-uitk-bg-ultramarine-070:hover, button.gs-uitk-bg-ultramarine-070:focus": {
    backgroundColor: "#2d368a !important"
  },
  ".gs-uitk-text-ultramarine-070": {
    color: "#3a45b0 !important"
  },
  "a.gs-uitk-text-ultramarine-070:hover, a.gs-uitk-text-ultramarine-070:focus": {
    color: "#272e76 !important"
  },
  ".gs-uitk-bg-ultramarine-080": {
    backgroundColor: "#2f337d !important"
  },
  "a.gs-uitk-bg-ultramarine-080:hover, a.gs-uitk-bg-ultramarine-080:focus, button.gs-uitk-bg-ultramarine-080:hover, button.gs-uitk-bg-ultramarine-080:focus": {
    backgroundColor: "#212458 !important"
  },
  ".gs-uitk-text-ultramarine-080": {
    color: "#2f337d !important"
  },
  "a.gs-uitk-text-ultramarine-080:hover, a.gs-uitk-text-ultramarine-080:focus": {
    color: "#1a1c45 !important"
  },
  ".gs-uitk-bg-ultramarine-090": {
    backgroundColor: "#23254d !important"
  },
  "a.gs-uitk-bg-ultramarine-090:hover, a.gs-uitk-bg-ultramarine-090:focus, button.gs-uitk-bg-ultramarine-090:hover, button.gs-uitk-bg-ultramarine-090:focus": {
    backgroundColor: "#13142a !important"
  },
  ".gs-uitk-text-ultramarine-090": {
    color: "#23254d !important"
  },
  "a.gs-uitk-text-ultramarine-090:hover, a.gs-uitk-text-ultramarine-090:focus": {
    color: "#0b0c18 !important"
  },
  ".gs-uitk-bg-ultramarine-100": {
    backgroundColor: "#141429 !important"
  },
  "a.gs-uitk-bg-ultramarine-100:hover, a.gs-uitk-bg-ultramarine-100:focus, button.gs-uitk-bg-ultramarine-100:hover, button.gs-uitk-bg-ultramarine-100:focus": {
    backgroundColor: "#030307 !important"
  },
  ".gs-uitk-text-ultramarine-100": {
    color: "#141429 !important"
  },
  "a.gs-uitk-text-ultramarine-100:hover, a.gs-uitk-text-ultramarine-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-purple-010": {
    backgroundColor: "#f7f2fc !important"
  },
  "a.gs-uitk-bg-purple-010:hover, a.gs-uitk-bg-purple-010:focus, button.gs-uitk-bg-purple-010:hover, button.gs-uitk-bg-purple-010:focus": {
    backgroundColor: "#dec9f2 !important"
  },
  ".gs-uitk-text-purple-010": {
    color: "#f7f2fc !important"
  },
  "a.gs-uitk-text-purple-010:hover, a.gs-uitk-text-purple-010:focus": {
    color: "#d1b4ee !important"
  },
  ".gs-uitk-bg-purple-020": {
    backgroundColor: "#eadcfc !important"
  },
  "a.gs-uitk-bg-purple-020:hover, a.gs-uitk-bg-purple-020:focus, button.gs-uitk-bg-purple-020:hover, button.gs-uitk-bg-purple-020:focus": {
    backgroundColor: "#ceadf8 !important"
  },
  ".gs-uitk-text-purple-020": {
    color: "#eadcfc !important"
  },
  "a.gs-uitk-text-purple-020:hover, a.gs-uitk-text-purple-020:focus": {
    color: "#c096f6 !important"
  },
  ".gs-uitk-bg-purple-030": {
    backgroundColor: "#dabefa !important"
  },
  "a.gs-uitk-bg-purple-030:hover, a.gs-uitk-bg-purple-030:focus, button.gs-uitk-bg-purple-030:hover, button.gs-uitk-bg-purple-030:focus": {
    backgroundColor: "#bf8ff6 !important"
  },
  ".gs-uitk-text-purple-030": {
    color: "#dabefa !important"
  },
  "a.gs-uitk-text-purple-030:hover, a.gs-uitk-text-purple-030:focus": {
    color: "#b277f5 !important"
  },
  ".gs-uitk-bg-purple-040": {
    backgroundColor: "#c89afc !important"
  },
  "a.gs-uitk-bg-purple-040:hover, a.gs-uitk-bg-purple-040:focus, button.gs-uitk-bg-purple-040:hover, button.gs-uitk-bg-purple-040:focus": {
    backgroundColor: "#ad68fb !important"
  },
  ".gs-uitk-text-purple-040": {
    color: "#c89afc !important"
  },
  "a.gs-uitk-text-purple-040:hover, a.gs-uitk-text-purple-040:focus": {
    color: "#a050fa !important"
  },
  ".gs-uitk-bg-purple-050": {
    backgroundColor: "#ac71f0 !important"
  },
  "a.gs-uitk-bg-purple-050:hover, a.gs-uitk-bg-purple-050:focus, button.gs-uitk-bg-purple-050:hover, button.gs-uitk-bg-purple-050:focus": {
    backgroundColor: "#9143eb !important"
  },
  ".gs-uitk-text-purple-050": {
    color: "#ac71f0 !important"
  },
  "a.gs-uitk-text-purple-050:hover, a.gs-uitk-text-purple-050:focus": {
    color: "#842ce9 !important"
  },
  ".gs-uitk-bg-purple-060": {
    backgroundColor: "#8f49de !important"
  },
  "a.gs-uitk-bg-purple-060:hover, a.gs-uitk-bg-purple-060:focus, button.gs-uitk-bg-purple-060:hover, button.gs-uitk-bg-purple-060:focus": {
    backgroundColor: "#7525cf !important"
  },
  ".gs-uitk-text-purple-060": {
    color: "#8f49de !important"
  },
  "a.gs-uitk-text-purple-060:hover, a.gs-uitk-text-purple-060:focus": {
    color: "#6922b9 !important"
  },
  ".gs-uitk-bg-purple-070": {
    backgroundColor: "#6b30ab !important"
  },
  "a.gs-uitk-bg-purple-070:hover, a.gs-uitk-bg-purple-070:focus, button.gs-uitk-bg-purple-070:hover, button.gs-uitk-bg-purple-070:focus": {
    backgroundColor: "#522583 !important"
  },
  ".gs-uitk-text-purple-070": {
    color: "#6b30ab !important"
  },
  "a.gs-uitk-text-purple-070:hover, a.gs-uitk-text-purple-070:focus": {
    color: "#461f6f !important"
  },
  ".gs-uitk-bg-purple-080": {
    backgroundColor: "#4c277d !important"
  },
  "a.gs-uitk-bg-purple-080:hover, a.gs-uitk-bg-purple-080:focus, button.gs-uitk-bg-purple-080:hover, button.gs-uitk-bg-purple-080:focus": {
    backgroundColor: "#341b56 !important"
  },
  ".gs-uitk-text-purple-080": {
    color: "#4c277d !important"
  },
  "a.gs-uitk-text-purple-080:hover, a.gs-uitk-text-purple-080:focus": {
    color: "#291543 !important"
  },
  ".gs-uitk-bg-purple-090": {
    backgroundColor: "#331f4d !important"
  },
  "a.gs-uitk-bg-purple-090:hover, a.gs-uitk-bg-purple-090:focus, button.gs-uitk-bg-purple-090:hover, button.gs-uitk-bg-purple-090:focus": {
    backgroundColor: "#1b1029 !important"
  },
  ".gs-uitk-text-purple-090": {
    color: "#331f4d !important"
  },
  "a.gs-uitk-text-purple-090:hover, a.gs-uitk-text-purple-090:focus": {
    color: "#0f0916 !important"
  },
  ".gs-uitk-bg-purple-100": {
    backgroundColor: "#1c1229 !important"
  },
  "a.gs-uitk-bg-purple-100:hover, a.gs-uitk-bg-purple-100:focus, button.gs-uitk-bg-purple-100:hover, button.gs-uitk-bg-purple-100:focus": {
    backgroundColor: "#040206 !important"
  },
  ".gs-uitk-text-purple-100": {
    color: "#1c1229 !important"
  },
  "a.gs-uitk-text-purple-100:hover, a.gs-uitk-text-purple-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-pink-010": {
    backgroundColor: "#fcf0f8 !important"
  },
  "a.gs-uitk-bg-pink-010:hover, a.gs-uitk-bg-pink-010:focus, button.gs-uitk-bg-pink-010:hover, button.gs-uitk-bg-pink-010:focus": {
    backgroundColor: "#f4c6e4 !important"
  },
  ".gs-uitk-text-pink-010": {
    color: "#fcf0f8 !important"
  },
  "a.gs-uitk-text-pink-010:hover, a.gs-uitk-text-pink-010:focus": {
    color: "#efb0da !important"
  },
  ".gs-uitk-bg-pink-020": {
    backgroundColor: "#f7daed !important"
  },
  "a.gs-uitk-bg-pink-020:hover, a.gs-uitk-bg-pink-020:focus, button.gs-uitk-bg-pink-020:hover, button.gs-uitk-bg-pink-020:focus": {
    backgroundColor: "#eeb0d9 !important"
  },
  ".gs-uitk-text-pink-020": {
    color: "#f7daed !important"
  },
  "a.gs-uitk-text-pink-020:hover, a.gs-uitk-text-pink-020:focus": {
    color: "#e99bce !important"
  },
  ".gs-uitk-bg-pink-030": {
    backgroundColor: "#f7b7e2 !important"
  },
  "a.gs-uitk-bg-pink-030:hover, a.gs-uitk-bg-pink-030:focus, button.gs-uitk-bg-pink-030:hover, button.gs-uitk-bg-pink-030:focus": {
    backgroundColor: "#f289d0 !important"
  },
  ".gs-uitk-text-pink-030": {
    color: "#f7b7e2 !important"
  },
  "a.gs-uitk-text-pink-030:hover, a.gs-uitk-text-pink-030:focus": {
    color: "#ef72c6 !important"
  },
  ".gs-uitk-bg-pink-040": {
    backgroundColor: "#fa87d4 !important"
  },
  "a.gs-uitk-bg-pink-040:hover, a.gs-uitk-bg-pink-040:focus, button.gs-uitk-bg-pink-040:hover, button.gs-uitk-bg-pink-040:focus": {
    backgroundColor: "#f856c2 !important"
  },
  ".gs-uitk-text-pink-040": {
    color: "#fa87d4 !important"
  },
  "a.gs-uitk-text-pink-040:hover, a.gs-uitk-text-pink-040:focus": {
    color: "#f73eba !important"
  },
  ".gs-uitk-bg-pink-050": {
    backgroundColor: "#ed4cb7 !important"
  },
  "a.gs-uitk-bg-pink-050:hover, a.gs-uitk-bg-pink-050:focus, button.gs-uitk-bg-pink-050:hover, button.gs-uitk-bg-pink-050:focus": {
    backgroundColor: "#e81ea4 !important"
  },
  ".gs-uitk-text-pink-050": {
    color: "#ed4cb7 !important"
  },
  "a.gs-uitk-text-pink-050:hover, a.gs-uitk-text-pink-050:focus": {
    color: "#d71696 !important"
  },
  ".gs-uitk-bg-pink-060": {
    backgroundColor: "#cc1d92 !important"
  },
  "a.gs-uitk-bg-pink-060:hover, a.gs-uitk-bg-pink-060:focus, button.gs-uitk-bg-pink-060:hover, button.gs-uitk-bg-pink-060:focus": {
    backgroundColor: "#9f1772 !important"
  },
  ".gs-uitk-text-pink-060": {
    color: "#cc1d92 !important"
  },
  "a.gs-uitk-text-pink-060:hover, a.gs-uitk-text-pink-060:focus": {
    color: "#891362 !important"
  },
  ".gs-uitk-bg-pink-070": {
    backgroundColor: "#961574 !important"
  },
  "a.gs-uitk-bg-pink-070:hover, a.gs-uitk-bg-pink-070:focus, button.gs-uitk-bg-pink-070:hover, button.gs-uitk-bg-pink-070:focus": {
    backgroundColor: "#690f51 !important"
  },
  ".gs-uitk-text-pink-070": {
    color: "#961574 !important"
  },
  "a.gs-uitk-text-pink-070:hover, a.gs-uitk-text-pink-070:focus": {
    color: "#530c40 !important"
  },
  ".gs-uitk-bg-pink-080": {
    backgroundColor: "#6b155a !important"
  },
  "a.gs-uitk-bg-pink-080:hover, a.gs-uitk-bg-pink-080:focus, button.gs-uitk-bg-pink-080:hover, button.gs-uitk-bg-pink-080:focus": {
    backgroundColor: "#400d36 !important"
  },
  ".gs-uitk-text-pink-080": {
    color: "#6b155a !important"
  },
  "a.gs-uitk-text-pink-080:hover, a.gs-uitk-text-pink-080:focus": {
    color: "#2b0824 !important"
  },
  ".gs-uitk-bg-pink-090": {
    backgroundColor: "#47153f !important"
  },
  "a.gs-uitk-bg-pink-090:hover, a.gs-uitk-bg-pink-090:focus, button.gs-uitk-bg-pink-090:hover, button.gs-uitk-bg-pink-090:focus": {
    backgroundColor: "#20091c !important"
  },
  ".gs-uitk-text-pink-090": {
    color: "#47153f !important"
  },
  "a.gs-uitk-text-pink-090:hover, a.gs-uitk-text-pink-090:focus": {
    color: "#0c040b !important"
  },
  ".gs-uitk-bg-pink-100": {
    backgroundColor: "#241020 !important"
  },
  "a.gs-uitk-bg-pink-100:hover, a.gs-uitk-bg-pink-100:focus, button.gs-uitk-bg-pink-100:hover, button.gs-uitk-bg-pink-100:focus": {
    backgroundColor: "#010001 !important"
  },
  ".gs-uitk-text-pink-100": {
    color: "#241020 !important"
  },
  "a.gs-uitk-text-pink-100:hover, a.gs-uitk-text-pink-100:focus": {
    color: "black !important"
  },
  ".gs-uitk-bg-gray-010": {
    backgroundColor: "#f2f5f7 !important"
  },
  "a.gs-uitk-bg-gray-010:hover, a.gs-uitk-bg-gray-010:focus, button.gs-uitk-bg-gray-010:hover, button.gs-uitk-bg-gray-010:focus": {
    backgroundColor: "#d2dde4 !important"
  },
  ".gs-uitk-text-gray-010": {
    color: "#f2f5f7 !important"
  },
  "a.gs-uitk-text-gray-010:hover, a.gs-uitk-text-gray-010:focus": {
    color: "#c3d1da !important"
  },
  ".gs-uitk-bg-gray-020": {
    backgroundColor: "#dce3e8 !important"
  },
  "a.gs-uitk-bg-gray-020:hover, a.gs-uitk-bg-gray-020:focus, button.gs-uitk-bg-gray-020:hover, button.gs-uitk-bg-gray-020:focus": {
    backgroundColor: "#bdcad4 !important"
  },
  ".gs-uitk-text-gray-020": {
    color: "#dce3e8 !important"
  },
  "a.gs-uitk-text-gray-020:hover, a.gs-uitk-text-gray-020:focus": {
    color: "#aebeca !important"
  },
  ".gs-uitk-bg-gray-030": {
    backgroundColor: "#c1ccd6 !important"
  },
  "a.gs-uitk-bg-gray-030:hover, a.gs-uitk-bg-gray-030:focus, button.gs-uitk-bg-gray-030:hover, button.gs-uitk-bg-gray-030:focus": {
    backgroundColor: "#a2b3c2 !important"
  },
  ".gs-uitk-text-gray-030": {
    color: "#c1ccd6 !important"
  },
  "a.gs-uitk-text-gray-030:hover, a.gs-uitk-text-gray-030:focus": {
    color: "#93a6b8 !important"
  },
  ".gs-uitk-bg-gray-040": {
    backgroundColor: "#9fb1bd !important"
  },
  "a.gs-uitk-bg-gray-040:hover, a.gs-uitk-bg-gray-040:focus, button.gs-uitk-bg-gray-040:hover, button.gs-uitk-bg-gray-040:focus": {
    backgroundColor: "#8198a8 !important"
  },
  ".gs-uitk-text-gray-040": {
    color: "#9fb1bd !important"
  },
  "a.gs-uitk-text-gray-040:hover, a.gs-uitk-text-gray-040:focus": {
    color: "#728c9e !important"
  },
  ".gs-uitk-bg-gray-050": {
    backgroundColor: "#7a909e !important"
  },
  "a.gs-uitk-bg-gray-050:hover, a.gs-uitk-bg-gray-050:focus, button.gs-uitk-bg-gray-050:hover, button.gs-uitk-bg-gray-050:focus": {
    backgroundColor: "#617684 !important"
  },
  ".gs-uitk-text-gray-050": {
    color: "#7a909e !important"
  },
  "a.gs-uitk-text-gray-050:hover, a.gs-uitk-text-gray-050:focus": {
    color: "#566976 !important"
  },
  ".gs-uitk-bg-gray-060": {
    backgroundColor: "#5b7282 !important"
  },
  "a.gs-uitk-bg-gray-060:hover, a.gs-uitk-bg-gray-060:focus, button.gs-uitk-bg-gray-060:hover, button.gs-uitk-bg-gray-060:focus": {
    backgroundColor: "#465864 !important"
  },
  ".gs-uitk-text-gray-060": {
    color: "#5b7282 !important"
  },
  "a.gs-uitk-text-gray-060:hover, a.gs-uitk-text-gray-060:focus": {
    color: "#3c4b55 !important"
  },
  ".gs-uitk-bg-gray-070": {
    backgroundColor: "#3e5463 !important"
  },
  "a.gs-uitk-bg-gray-070:hover, a.gs-uitk-bg-gray-070:focus, button.gs-uitk-bg-gray-070:hover, button.gs-uitk-bg-gray-070:focus": {
    backgroundColor: "#2a3944 !important"
  },
  ".gs-uitk-text-gray-070": {
    color: "#3e5463 !important"
  },
  "a.gs-uitk-text-gray-070:hover, a.gs-uitk-text-gray-070:focus": {
    color: "#212c34 !important"
  },
  ".gs-uitk-bg-gray-080": {
    backgroundColor: "#2a3f4d !important"
  },
  "a.gs-uitk-bg-gray-080:hover, a.gs-uitk-bg-gray-080:focus, button.gs-uitk-bg-gray-080:hover, button.gs-uitk-bg-gray-080:focus": {
    backgroundColor: "#18242c !important"
  },
  ".gs-uitk-text-gray-080": {
    color: "#2a3f4d !important"
  },
  "a.gs-uitk-text-gray-080:hover, a.gs-uitk-text-gray-080:focus": {
    color: "#0f171c !important"
  },
  ".gs-uitk-bg-gray-090": {
    backgroundColor: "#1c2b36 !important"
  },
  "a.gs-uitk-bg-gray-090:hover, a.gs-uitk-bg-gray-090:focus, button.gs-uitk-bg-gray-090:hover, button.gs-uitk-bg-gray-090:focus": {
    backgroundColor: "#0b1014 !important"
  },
  ".gs-uitk-text-gray-090": {
    color: "#1c2b36 !important"
  },
  "a.gs-uitk-text-gray-090:hover, a.gs-uitk-text-gray-090:focus": {
    color: "#020304 !important"
  },
  ".gs-uitk-bg-gray-100": {
    backgroundColor: "#0e171f !important"
  },
  "a.gs-uitk-bg-gray-100:hover, a.gs-uitk-bg-gray-100:focus, button.gs-uitk-bg-gray-100:hover, button.gs-uitk-bg-gray-100:focus": {
    backgroundColor: "black !important"
  },
  ".gs-uitk-text-gray-100": {
    color: "#0e171f !important"
  },
  "a.gs-uitk-text-gray-100:hover, a.gs-uitk-text-gray-100:focus": {
    color: "black !important"
  }
};

// components/design-system/common/src/inject-legacy-global-utilities-css.ts
var stylesInjected4 = /* @__PURE__ */ new Set();
function injectLegacyGlobalUtilitiesCss(scopingSelector) {
  if (stylesInjected4.has(scopingSelector || ""))
    return;
  if (scopingSelector) {
    injectGlobal4(getScopedCss(utilities_scss_default, scopingSelector));
  } else {
    injectGlobal4(utilities_scss_default);
  }
  stylesInjected4.add(scopingSelector || "");
}

// components/design-system/common/src/spacing.ts
var spacerBaseline = 0.5;
var spacers = {
  baseline: `${spacerBaseline}rem`,
  "0": "0",
  "1px": "1px",
  "0_25": `${spacerBaseline * 0.25}rem`,
  "0_5": `${spacerBaseline * 0.5}rem`,
  "0_75": `${spacerBaseline * 0.75}rem`,
  "1": `${spacerBaseline}rem`,
  "1_5": `${spacerBaseline * 1.5}rem`,
  "2": `${spacerBaseline * 2}rem`,
  "2_5": `${spacerBaseline * 2.5}rem`,
  "3": `${spacerBaseline * 3}rem`,
  "4": `${spacerBaseline * 4}rem`,
  "5": `${spacerBaseline * 5}rem`,
  "6": `${spacerBaseline * 6}rem`,
  "7": `${spacerBaseline * 7}rem`,
  "8": `${spacerBaseline * 8}rem`,
  "9": `${spacerBaseline * 9}rem`,
  "10": `${spacerBaseline * 10}rem`
};

// components/design-system/common/src/status.ts
var statuses = ["none", "information", "success", "warning", "error", "loading"];

// components/design-system/common/src/surface.ts
var surfaces = [
  "primary",
  "secondary",
  "tertiary",
  "moderate",
  "bold",
  "strong",
  "contrast",
  "none"
];

// components/design-system/common/src/elevation.ts
var elevations = ["00", "01", "02", "03", "04", "05", "06", "07", "08"];
var elevationVariants = {
  "00": {
    boxShadow: "none"
  },
  "01": {
    boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)"
  },
  "02": {
    boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2)"
  },
  "03": {
    boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px -1px rgba(0, 0, 0, 0.2)"
  },
  "04": {
    boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px -1px rgba(0, 0, 0, 0.2)"
  },
  "05": {
    boxShadow: "0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 5px 5px -3px rgba(0, 0, 0, 0.2)"
  },
  "06": {
    boxShadow: "0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12), 0px 7px 8px -4px rgba(0, 0, 0, 0.2)"
  },
  "07": {
    boxShadow: "0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12), 0px 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  "08": {
    boxShadow: "0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 11px 15px -7px rgba(0, 0, 0, 0.2)"
  }
};

// components/design-system/common/src/typography.ts
import { injectFont } from "@gs-ux-uitoolkit-common/style";
var fontFamily = {
  goldmanSans: "Goldman Sans",
  /**
   * @deprecated Use `goldmanSans` and fontWeight instead
   */
  goldmanSansThin: "Goldman Sans Thin",
  /**
   * @deprecated Use `goldmanSans` and fontWeight instead
   */
  goldmanSansLight: "Goldman Sans Light",
  /**
   * @deprecated Use `goldmanSans` and fontWeight instead
   */
  goldmanSansItalic: "Goldman Sans Italic",
  /**
   * @deprecated Use `goldmanSans` and fontWeight instead
   */
  goldmanSansMedium: "Goldman Sans Medium",
  /**
   * @deprecated Use `goldmanSans` and fontWeight instead
   */
  goldmanSansMediumItalic: "Goldman Sans Medium Italic",
  /**
   * @deprecated Use `goldmanSans` and fontWeight instead
   */
  goldmanSansBold: "Goldman Sans Bold",
  /**
   * @deprecated Use `goldmanSans` and fontWeight instead
   */
  goldmanSansBoldItalic: "Goldman Sans Bold Italic",
  /**
   * @deprecated Use `goldmanSans` and fontWeight instead
   */
  goldmanSansBlack: "Goldman Sans Black",
  goldmanSansVariable: "Goldman Sans Variable",
  goldmanSansVariableItalic: "Goldman Sans Variable Italic",
  mono: "Roboto Mono",
  robotoMonoItalic: "Roboto Mono Italic",
  robotoMonoMedium: "Roboto Mono Medium",
  robotoMonoMediumItalic: "Roboto Mono Medium Italic",
  sabonRoman: "Sabon",
  sabonItalic: "Sabon Italic",
  sabonBold: "Sabon Bold",
  sabonBoldItalic: "Sabon Bold Italic",
  basis: "Basis",
  basisItalic: "Basis Italic",
  basisBold: "Basis Bold",
  basisBoldItalic: "Basis Bold Italic",
  basisLight: "Basis Light",
  basisLightItalic: "Basis Light Italic",
  basisMedium: "Basis Medium",
  basisMediumItalic: "Basis Medium Italic",
  basisOffWhite: "Basis Off White",
  basisOffWhiteItalic: "Basis Off White Italic",
  basisMonoRegular: "Basis Mono Regular",
  basisMonoMedium: "Basis Mono Medium"
};
var fontWeight = {
  thin: 100,
  ultraLight: 200,
  light: 300,
  regular: 400,
  normal: 400,
  medium: 500,
  bold: 700,
  strong: 700,
  black: 900
};
var hasInjectedIconFonts = false;
function injectGsdsFonts() {
  if (!hasInjectedIconFonts) {
    getFontFaces().forEach((fontFace) => injectFont(fontFace));
    hasInjectedIconFonts = true;
  }
}
function getFontFaces() {
  const { goldmanSans, robotoMono, sabon, basis, deprecatedGoldmanSans } = getFontFacesByFamily();
  return [...goldmanSans, ...robotoMono, ...sabon, ...basis, ...deprecatedGoldmanSans];
}
function getFontFacesByFamily() {
  const cdnBaseUrl2 = getCdnBaseUrl();
  const goldmanSansBaseUrl = `${cdnBaseUrl2}/fonts/goldman-sans/v1`;
  const robotoMonoBaseUrl = `${cdnBaseUrl2}/fonts/roboto-mono/v1`;
  const sabonBaseUrl = `${cdnBaseUrl2}/fonts/sabon/v1`;
  const basisBaseUrl = `${cdnBaseUrl2}/fonts/basis/v1`;
  const goldmanSans = [
    {
      family: fontFamily.goldmanSans,
      weight: 100,
      // "thin"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-thin.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-thin.woff`
      ]
    },
    {
      family: fontFamily.goldmanSans,
      weight: 300,
      // "light"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-light.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-light.woff`
      ]
    },
    {
      family: fontFamily.goldmanSans,
      weight: 400,
      // "regular"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-regular.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-regular.woff`
      ]
    },
    {
      family: fontFamily.goldmanSans,
      weight: 400,
      // "regular"
      style: "italic",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-regular-italic.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-regular-italic.woff`
      ]
    },
    {
      family: fontFamily.goldmanSans,
      weight: 500,
      // "medium"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-medium.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-medium.woff`
      ]
    },
    {
      family: fontFamily.goldmanSans,
      weight: 500,
      // "medium"
      style: "italic",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-medium-italic.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-medium-italic.woff`
      ]
    },
    {
      family: fontFamily.goldmanSans,
      weight: 700,
      // "bold"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-bold.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-bold.woff`
      ]
    },
    {
      family: fontFamily.goldmanSans,
      weight: 700,
      // "bold"
      style: "italic",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-bold-italic.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-bold-italic.woff`
      ]
    },
    {
      family: fontFamily.goldmanSans,
      weight: 900,
      // "black"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-black.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-black.woff`
      ]
    },
    {
      family: fontFamily.goldmanSansVariable,
      weight: "1 999",
      // variable font weights are specified as a range
      style: "normal",
      src: [`${goldmanSansBaseUrl}/goldman-sans-variable.woff2`]
    },
    {
      family: fontFamily.goldmanSansVariableItalic,
      weight: "1 999",
      // variable font weights are specified as a range
      style: "normal",
      src: [`${goldmanSansBaseUrl}/goldman-sans-variable-italic.woff2`]
    }
  ];
  const robotoMono = [
    {
      family: fontFamily.mono,
      weight: 400,
      // "regular"
      style: "normal",
      src: [
        `${robotoMonoBaseUrl}/roboto-mono-regular.woff2`,
        `${robotoMonoBaseUrl}/roboto-mono-regular.woff`
      ]
    },
    {
      family: fontFamily.robotoMonoItalic,
      weight: 400,
      style: "normal",
      src: [
        `${robotoMonoBaseUrl}/roboto-mono-regular-italic.woff2`,
        `${robotoMonoBaseUrl}/roboto-mono-regular-italic.woff`
      ]
    },
    {
      family: fontFamily.robotoMonoMedium,
      weight: 400,
      style: "normal",
      src: [
        `${robotoMonoBaseUrl}/roboto-mono-medium.woff2`,
        `${robotoMonoBaseUrl}/roboto-mono-medium.woff`
      ]
    },
    {
      family: fontFamily.robotoMonoMediumItalic,
      weight: 400,
      style: "normal",
      src: [
        `${robotoMonoBaseUrl}/roboto-mono-medium-italic.woff2`,
        `${robotoMonoBaseUrl}/roboto-mono-medium-italic.woff`
      ]
    }
  ];
  const sabon = [
    {
      family: fontFamily.sabonRoman,
      weight: 400,
      style: "normal",
      src: [`${sabonBaseUrl}/sabon.woff2`, `${sabonBaseUrl}/sabon.woff`]
    },
    {
      family: fontFamily.sabonItalic,
      weight: 400,
      style: "normal",
      src: [`${sabonBaseUrl}/sabon-italic.woff2`, `${sabonBaseUrl}/sabon-italic.woff`]
    },
    {
      family: fontFamily.sabonBold,
      weight: 400,
      style: "normal",
      src: [`${sabonBaseUrl}/sabon-bold.woff2`, `${sabonBaseUrl}/sabon-bold.woff`]
    },
    {
      family: fontFamily.sabonBoldItalic,
      weight: 400,
      style: "normal",
      src: [
        `${sabonBaseUrl}/sabon-bold-italic.woff2`,
        `${sabonBaseUrl}/sabon-bold-italic.woff`
      ]
    }
  ];
  const basis = [
    {
      family: fontFamily.basis,
      weight: 400,
      style: "normal",
      src: [`${basisBaseUrl}/basis-regular.woff2`, `${basisBaseUrl}/basis-regular.woff`]
    },
    {
      family: fontFamily.basisItalic,
      weight: 400,
      style: "normal",
      src: [`${basisBaseUrl}/basis-italic.woff2`, `${basisBaseUrl}/basis-italic.woff`]
    },
    {
      family: fontFamily.basisBold,
      weight: 400,
      style: "normal",
      src: [`${basisBaseUrl}/basis-bold.woff2`, `${basisBaseUrl}/basis-bold.woff`]
    },
    {
      family: fontFamily.basisBoldItalic,
      weight: 400,
      style: "normal",
      src: [
        `${basisBaseUrl}/basis-bold-italic.woff2`,
        `${basisBaseUrl}/basis-bold-italic.woff`
      ]
    },
    {
      family: fontFamily.basisLight,
      weight: 400,
      style: "normal",
      src: [`${basisBaseUrl}/basis-light.woff2`, `${basisBaseUrl}/basis-light.woff`]
    },
    {
      family: fontFamily.basisLightItalic,
      weight: 400,
      style: "normal",
      src: [
        `${basisBaseUrl}/basis-light-italic.woff2`,
        `${basisBaseUrl}/basis-light-italic.woff`
      ]
    },
    {
      family: fontFamily.basisMedium,
      weight: 400,
      style: "normal",
      src: [`${basisBaseUrl}/basis-medium.woff2`, `${basisBaseUrl}/basis-medium.woff`]
    },
    {
      family: fontFamily.basisMediumItalic,
      weight: 400,
      style: "normal",
      src: [
        `${basisBaseUrl}/basis-medium-italic.woff2`,
        `${basisBaseUrl}/basis-medium-italic.woff`
      ]
    },
    {
      family: fontFamily.basisOffWhite,
      weight: 400,
      style: "normal",
      src: [`${basisBaseUrl}/basis-off-white.woff2`, `${basisBaseUrl}/basis-off-white.woff`]
    },
    {
      family: fontFamily.basisOffWhiteItalic,
      weight: 400,
      style: "normal",
      src: [
        `${basisBaseUrl}/basis-off-white-italic.woff2`,
        `${basisBaseUrl}/basis-off-white-italic.woff`
      ]
    },
    {
      family: fontFamily.basisMonoRegular,
      weight: 400,
      style: "normal",
      src: [
        `${basisBaseUrl}/basis-mono-regular.woff2`,
        `${basisBaseUrl}/basis-mono-regular.woff`
      ]
    },
    {
      family: fontFamily.basisMonoMedium,
      weight: 400,
      style: "normal",
      src: [
        `${basisBaseUrl}/basis-mono-medium.woff2`,
        `${basisBaseUrl}/basis-mono-medium.woff`
      ]
    }
  ];
  const deprecatedGoldmanSans = [
    {
      family: fontFamily.goldmanSansThin,
      weight: 100,
      // "thin"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-thin.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-thin.woff`
      ]
    },
    {
      family: fontFamily.goldmanSansLight,
      weight: 300,
      // "light"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-light.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-light.woff`
      ]
    },
    {
      family: fontFamily.goldmanSans,
      weight: 400,
      // "regular"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-regular.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-regular.woff`
      ]
    },
    {
      family: fontFamily.goldmanSansItalic,
      weight: 400,
      // "regular"
      style: "italic",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-regular-italic.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-regular-italic.woff`
      ]
    },
    {
      family: fontFamily.goldmanSansMedium,
      weight: 500,
      // "medium"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-medium.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-medium.woff`
      ]
    },
    {
      family: fontFamily.goldmanSansMediumItalic,
      weight: 500,
      // "medium"
      style: "italic",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-medium-italic.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-medium-italic.woff`
      ]
    },
    {
      family: fontFamily.goldmanSansBold,
      weight: 700,
      // "bold"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-bold.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-bold.woff`
      ]
    },
    {
      family: fontFamily.goldmanSansBoldItalic,
      weight: 700,
      // "bold"
      style: "italic",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-bold-italic.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-bold-italic.woff`
      ]
    },
    {
      family: fontFamily.goldmanSansBlack,
      weight: 900,
      // "black"
      style: "normal",
      src: [
        `${goldmanSansBaseUrl}/goldman-sans-black.woff2`,
        `${goldmanSansBaseUrl}/goldman-sans-black.woff`
      ]
    },
    {
      family: fontFamily.goldmanSansVariable,
      weight: "1 999",
      // variable font weights are specified as a range
      style: "normal",
      src: [`${goldmanSansBaseUrl}/goldman-sans-variable.woff2`]
    },
    {
      family: fontFamily.goldmanSansVariableItalic,
      weight: "1 999",
      // variable font weights are specified as a range
      style: "normal",
      src: [`${goldmanSansBaseUrl}/goldman-sans-variable-italic.woff2`]
    }
  ];
  return { goldmanSans, deprecatedGoldmanSans, robotoMono, sabon, basis };
}

// components/design-system/common/src/typography-utils.ts
var goldmanSansFallback = ["Helvetica", "Arial", "sans-serif"];
var basisFallback = ["Helvetica", "Arial"];
var sabonFallback = ["Georgia", "Times New Roman", "serif"];
var monospaceFallback = ["Courier New", "monospace"];
function wrapWithQuotes(font) {
  return font.includes(" ") ? `"${font}"` : font;
}
function withGoldmanSansFallback(font) {
  return [font, ...goldmanSansFallback].map(wrapWithQuotes).join(",");
}
function withGoldmanSansVariableFallback(font) {
  return [font, fontFamily.goldmanSans, ...goldmanSansFallback].map(wrapWithQuotes).join(",");
}
function withBasisFallback(font) {
  return [font, ...basisFallback].map(wrapWithQuotes).join(",");
}
function withSabonFallback(font) {
  return [font, ...sabonFallback].map(wrapWithQuotes).join(",");
}
function withMonospaceFallback(font) {
  return [font, ...monospaceFallback].map(wrapWithQuotes).join(",");
}

// components/design-system/common/src/typography-variants.ts
var typographyFonts = {
  display01: "goldmanSansLight",
  display02: "goldmanSansLight",
  display03: "goldmanSansLight",
  heading01: "goldmanSansMedium",
  heading02: "goldmanSansMedium",
  heading03: "goldmanSansMedium",
  heading04: "goldmanSansMedium",
  heading05: "goldmanSansMedium",
  heading06: "goldmanSansMedium",
  heading07: "goldmanSansMedium",
  display01Serif: "sabon",
  display02Serif: "sabon",
  display03Serif: "sabon",
  heading01Serif: "sabon",
  heading02Serif: "sabon",
  heading03Serif: "sabon",
  heading04Serif: "sabon",
  display01Basis: "basis",
  display02Basis: "basis",
  display03Basis: "basis",
  heading01Basis: "basis",
  heading02Basis: "basis",
  heading03Basis: "basis",
  heading04Basis: "basis",
  body01: "goldmanSans",
  body02: "goldmanSans",
  body03: "goldmanSans",
  body04: "goldmanSans",
  body05: "goldmanSans",
  ui01: "goldmanSans",
  ui02: "goldmanSansMedium",
  caption01: "goldmanSans",
  code01: "robotoMono",
  code02: "robotoMono"
};
var typographyFontFamilyVariants = {
  goldmanSansLight: {
    regular: {
      fontFamily: withGoldmanSansFallback(fontFamily.goldmanSans),
      fontWeight: fontWeight.light
    },
    bold: {
      fontFamily: withGoldmanSansFallback(fontFamily.goldmanSans),
      fontWeight: fontWeight.regular
    },
    italic: {
      // the GoldmanSans Variable italic font type is used since there is no font file for 'Goldman Sans Light Italic'
      fontFamily: withGoldmanSansVariableFallback(fontFamily.goldmanSansVariableItalic),
      fontWeight: fontWeight.light
    },
    boldItalic: {
      fontFamily: withGoldmanSansFallback(fontFamily.goldmanSansVariableItalic),
      fontWeight: fontWeight.regular
    }
  },
  goldmanSans: {
    regular: {
      fontFamily: withGoldmanSansFallback(fontFamily.goldmanSans),
      fontWeight: fontWeight.regular
    },
    bold: {
      fontFamily: withGoldmanSansFallback(fontFamily.goldmanSans),
      fontWeight: fontWeight.medium
    },
    italic: {
      fontFamily: withGoldmanSansFallback(fontFamily.goldmanSans),
      fontWeight: fontWeight.regular
    },
    boldItalic: {
      fontFamily: withGoldmanSansFallback(fontFamily.goldmanSans),
      fontWeight: fontWeight.medium
    }
  },
  goldmanSansMedium: {
    regular: {
      fontFamily: withGoldmanSansFallback(fontFamily.goldmanSans),
      fontWeight: fontWeight.medium
    },
    bold: {
      fontFamily: withGoldmanSansFallback(fontFamily.goldmanSans),
      fontWeight: fontWeight.bold
    },
    italic: {
      fontFamily: withGoldmanSansFallback(fontFamily.goldmanSansVariableItalic),
      fontWeight: fontWeight.medium
    },
    boldItalic: {
      fontFamily: withGoldmanSansFallback(fontFamily.goldmanSansVariableItalic),
      fontWeight: fontWeight.bold
    }
  },
  robotoMono: {
    regular: {
      fontFamily: withMonospaceFallback(fontFamily.mono),
      fontWeight: fontWeight.regular
    },
    bold: {
      fontFamily: withMonospaceFallback(fontFamily.robotoMonoMedium),
      fontWeight: fontWeight.medium
    },
    italic: {
      fontFamily: withMonospaceFallback(fontFamily.robotoMonoItalic),
      fontWeight: fontWeight.regular
    },
    boldItalic: {
      fontFamily: withMonospaceFallback(fontFamily.robotoMonoMediumItalic),
      fontWeight: fontWeight.medium
    }
  },
  sabon: {
    regular: {
      fontFamily: withSabonFallback(fontFamily.sabonRoman),
      fontWeight: fontWeight.regular
    },
    bold: {
      fontFamily: withSabonFallback(fontFamily.sabonBold),
      fontWeight: fontWeight.bold
    },
    italic: {
      fontFamily: withSabonFallback(fontFamily.sabonItalic),
      fontWeight: fontWeight.regular
    },
    boldItalic: {
      fontFamily: withSabonFallback(fontFamily.sabonBoldItalic),
      fontWeight: fontWeight.bold
    }
  },
  basis: {
    regular: {
      fontFamily: withBasisFallback(fontFamily.basis),
      fontWeight: fontWeight.regular
    },
    bold: {
      fontFamily: withBasisFallback(fontFamily.basisBold),
      fontWeight: fontWeight.bold
    },
    italic: {
      fontFamily: withBasisFallback(fontFamily.basisItalic),
      fontWeight: fontWeight.regular
    },
    boldItalic: {
      fontFamily: withBasisFallback(fontFamily.basisBoldItalic),
      fontWeight: fontWeight.bold
    }
  }
};
var typographyVariants = {
  display01: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["display01"]].regular), {
    fontSize: "78px",
    lineHeight: "104px",
    letterSpacing: "0.2px"
  }),
  display02: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["display02"]].regular), {
    fontSize: "60px",
    lineHeight: "80px",
    letterSpacing: "0.2px"
  }),
  display03: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["display03"]].regular), {
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "0.2px"
  }),
  heading01: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading01"]].regular), {
    fontSize: "40px",
    lineHeight: "52px",
    letterSpacing: "0.2px"
  }),
  heading02: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading02"]].regular), {
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.2px"
  }),
  heading03: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading03"]].regular), {
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.2px"
  }),
  heading04: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading04"]].regular), {
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "0.2px"
  }),
  heading05: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading05"]].regular), {
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0"
  }),
  heading06: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading06"]].regular), {
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  }),
  heading07: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading07"]].regular), {
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  }),
  display01Serif: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["display01Serif"]].regular), {
    fontSize: "78px",
    lineHeight: "104px",
    letterSpacing: "0.2px"
  }),
  display02Serif: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["display02Serif"]].regular), {
    fontSize: "60px",
    lineHeight: "80px",
    letterSpacing: "0.2px"
  }),
  display03Serif: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["display03Serif"]].regular), {
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "0.2px"
  }),
  heading01Serif: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading01Serif"]].regular), {
    fontSize: "40px",
    lineHeight: "52px",
    letterSpacing: "0.2px"
  }),
  heading02Serif: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading02Serif"]].regular), {
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0.2px"
  }),
  heading03Serif: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading03Serif"]].regular), {
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.2px"
  }),
  heading04Serif: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading04Serif"]].regular), {
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "0.2px"
  }),
  display01Basis: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["display01Basis"]].regular), {
    fontSize: "78px",
    lineHeight: "104px",
    letterSpacing: "0px"
  }),
  display02Basis: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["display02Basis"]].regular), {
    fontSize: "60px",
    lineHeight: "80px",
    letterSpacing: "0px"
  }),
  display03Basis: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["display03Basis"]].regular), {
    fontSize: "48px",
    lineHeight: "64px",
    letterSpacing: "0px"
  }),
  heading01Basis: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading01Basis"]].regular), {
    fontSize: "40px",
    lineHeight: "52px",
    letterSpacing: "0px"
  }),
  heading02Basis: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading02Basis"]].regular), {
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "0px"
  }),
  heading03Basis: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading03Basis"]].regular), {
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0px"
  }),
  heading04Basis: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["heading04Basis"]].regular), {
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "0px"
  }),
  body01: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["body01"]].regular), {
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0"
  }),
  body02: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["body02"]].regular), {
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  }),
  body03: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["body03"]].regular), {
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  }),
  body04: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["body04"]].regular), {
    fontSize: "11px",
    lineHeight: "16px",
    letterSpacing: "0"
  }),
  body05: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["body05"]].regular), {
    fontSize: "10px",
    lineHeight: "12px",
    letterSpacing: "0"
  }),
  ui01: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["ui01"]].regular), {
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0"
  }),
  ui02: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["ui02"]].regular), {
    fontSize: "11px",
    lineHeight: "16px",
    letterSpacing: "0"
  }),
  caption01: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["caption01"]].regular), {
    fontSize: "11px",
    lineHeight: "16px",
    letterSpacing: "0"
  }),
  code01: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["code01"]].regular), {
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0"
  }),
  code02: __spreadProps(__spreadValues({}, typographyFontFamilyVariants[typographyFonts["code02"]].regular), {
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0"
  })
};
var fontStyles = ["regular", "bold", "italic", "boldItalic"];
var textTypographies = [
  "body01",
  "body02",
  "body03",
  "body04",
  "body05",
  "ui01",
  "ui02",
  "caption01",
  "code01",
  "code02"
];
var headingTypographies = [
  "display01",
  "display02",
  "display03",
  "heading01",
  "heading02",
  "heading03",
  "heading04",
  "heading05",
  "heading06",
  "heading07",
  "display01Serif",
  "display02Serif",
  "display03Serif",
  "heading01Serif",
  "heading02Serif",
  "heading03Serif",
  "heading04Serif",
  "display01Basis",
  "display02Basis",
  "display03Basis",
  "heading01Basis",
  "heading02Basis",
  "heading03Basis",
  "heading04Basis"
];

// components/design-system/common/src/zindex.ts
var fixed = 1030;
var overlay = 100;
var zIndex = {
  dropdown: 1e3,
  sticky: 1020,
  fixed,
  modalBackdrop: 1040,
  bottomSheetBackdrop: 1040,
  modal: 1050,
  bottomSheet: 1050,
  popover: 1060,
  tooltip: 1070,
  overlay,
  overlayFixed: fixed + overlay,
  header: fixed,
  menu: 9999
};
export {
  colorNames,
  colorSwatches,
  colors,
  elevationVariants,
  elevations,
  emphases,
  emphasisColorVariants,
  emphasisStatusVariants,
  fontFamily,
  fontStyles,
  fontWeight,
  getCdnBaseUrl,
  getColorVariant,
  getEmphasisStatusClassName,
  getFontFaces,
  getFontFacesByFamily,
  getStatusVariant,
  headingTypographies,
  injectGsdsFonts,
  injectLegacyGlobalDesignSystemCss,
  injectLegacyGlobalDesignSystemDemoCss,
  injectLegacyGlobalRebootCss,
  injectLegacyGlobalUtilitiesCss,
  spacers,
  statuses,
  surfaces,
  textTypographies,
  typographyFontFamilyVariants,
  typographyFonts,
  typographyVariants,
  zIndex
};
//# sourceMappingURL=index.mjs.map
